// eslint quotes double on json
// eslint-disable-next-line quotes
// eslint-disable-next-line quotes

export const gameContent = {
  2048: {
    details: {
      title: "2048 Game Online - Number Puzzle Game",
      gameData: [
        {
          description: [
            <>
              <b>2048 Number Puzzle</b> Block Game, available on Epicplay and
              other platforms, requires no downloading and is absolutely free to
              play. It's a fun and engaging puzzle that has gained immense
              popularity among gamers of all ages.
            </>,
            "Playing 2048 is a great way to exercise your brain and improve your cognitive skills like problem-solving skills, concentration, and strategic thinking. The game is also a great stress-buster and can be played anytime, anywhere, making it an ideal pastime activity. As you progress through the levels, the game becomes more challenging, requiring more focus and strategic thinking to win.",
            "Another reason people should play the 2048 online game on Epicplay is that it can be played from anywhere and anytime. You only need an internet connection and a device to start playing the game immediately. It's a great way to pass the time without spending money.",
          ],
        },
        {
          title: "Gameplay of 2048 Number Puzzle Game",
          description: [
            "It is the next big challenge for puzzle enthusiasts! Put your problem-solving skills to test and take over the grid of tiles to start building the number 2048.",
            "It may seem simple at first to begin with a 2 or a 4. But as the game progresses, the numbers get bigger and that's when you have to gear up and focus. Think twice before making every move because one wrong decision can mess up the entire gameplay. ",
            "Start merging tiles with the same numbers carefully with the goal of achieving 2048. For instance, merge two tiles with number 2 to create the number 4, merge two number 4s to create number 8, and so on. And when you finally reach 2048, you're done! You're the winner of the ultimate number puzzle game!",
            "You can continue to play the game even further to beat your own score and achieve the highest number.",
          ],
          image: {
            path: "/game-assets/game-images/2048-number-puzzle-game.jpg",
            alt: "2048 game online",
            title: "2048 game online",
            caption: "2048: number puzzle game",
          },
        },
        {
          title: "How to play & Rules - 2048 Game Online",
          subTitle: "Controls",
          description: (
            <>
              The controls for playing <b>2048 Game Online</b> are
              straightforward.
            </>
          ),
          items: [
            "On a desktop, players can use the arrow keys to slide the tiles in the desired direction.",
            "On mobile devices, the players can tap on the screen to start playing and swipe left, right, top, or bottom to merge tiles.",
          ],
        },
        {
          subTitle: "How to play 2048",
          description: [
            "To start playing the 2048 Game Online, the player needs to slide the numbered tiles on a 4x4 grid to merge them and create higher number tiles until they reach the ultimate goal of creating the tile with the number 2048. The game starts with two tiles, each containing the number 2 or 4, randomly placed on the grid.",
            "The player must slide the tiles in the desired direction using the arrow keys or by swiping on mobile devices. When two tiles with the same number merge, they create a new tile with double the value. For instance, merging two tiles with the number 2 creates a tile with the number 4 and merging two 8s makes a 16.",
            "The game requires strategic thinking and problem-solving skills to merge the tiles efficiently and avoid filling the grid. The player needs to plan their moves carefully and monitor the available space on the grid to avoid running out of moves.",
          ],
        },
        {
          subTitle: "Rules",
          description: "The rules for playing 2048 Game Online are simple:",
          items: [
            "Merge tiles with the same number to create a higher-value tile.",
            "The tiles are numbered 2 and the powers of 2. For example, 4, 8, 16, 32, etc.",
            "Avoid filling up the grid by planning moves carefully.",
            "The player wins the game when they successfully create the tile with the number 2048.",
            "The game is over when the player cannot merge anymore tiles and the grid is full.",
          ],
        },
        {
          title: "Tips and Tricks - Solve 2048 Number Puzzle",
          subTitle: "Tips to Solve 2048 Number Puzzle",
          items: [
            {
              title: "Plan",
              description:
                "It is essential to plan your moves and think about the consequences of each move. Always try to keep tiles with high values towards the center of the grid, as it will give you more space to move the other tiles around.",
            },
            {
              title: "Start from the corners",
              description:
                "One of the best strategies is to start from the corners, giving you more space to move the tiles around. Try to merge the smaller value tiles first and work your way up.",
            },
            {
              title: "Keep your options open",
              description:
                "Avoid filling up the grid by making unnecessary moves. Always look for opportunities to merge tiles and keep the grid as empty as possible.",
            },
            {
              title: "Use the New Game button",
              description:
                "If you make a wrong move or feel stuck, don't hesitate to use the New Game button. It will help you start over and avoid making the same mistake.",
            },
          ],
        },
        {
          subTitle: "Tricks to go with the right strategy",
          items: [
            {
              title: "Merge smaller value tiles first",
              description:
                "When merging tiles, always start with smaller ones. For instance, if you have two tiles with the value 2 and one with the value 4, merge the two 2's first and then merge the resulting tile with the 4.",
            },
            {
              title: "Keep high-value tiles in the corners",
              description:
                "Keep them in one of the corners of the grid to get more space to move the other tiles around.",
            },
            {
              title: "Be patient",
              description:
                "Patience is vital to solving the 2048 Number Puzzle. Take your time making moves, and always think about the consequences of each move. The game requires strategic thinking, so take your time to plan.",
            },
            {
              title: "Don't get fixated on creating the 2048 tile",
              description:
                "While the game's ultimate goal is to create the tile with the number 2048, don't get fixated on it. Instead, focus on merging tiles efficiently and keeping the grid as empty as possible.",
            },
          ],
        },
      ],
      faq: [
        {
          question: "How do I play the 2048 game?",
          answer:
            "The numbered tiles on a 4x4 grid must be moved using the arrow keys to play 2048. Combine two identical tiles to create a single tile with the sum of their values. For example, combine two 8s to make a 16. Continue merging tiles and create one with the value 2048 to win the game.",
        },
        {
          question: "What is the highest 2048 score that may be achieved?",
          answer:
            "The highest score that can be achieved in the game 2048 is 22,417,760. This score can only be achieved if the player makes the optimal moves at every turn. Getting 2048 wins you the game but you can continue playing to achieve the highest-value tile, which is 131,072.",
        },
        {
          question: "Is it possible to win 2048?",
          answer:
            "Yes, you can win 2048 by making a tile with the value of 2048. After this, the game continues, so you can keep playing and try to beat your previous score.",
        },
        {
          question: "Do 2048 games have any specific strategies?",
          answer:
            "Focusing on amassing the highest-valued tiles in a single grid corner is a standard 2048 playing tactic. An alternative approach is to place the tile with the highest value in the middle of the grid and use the remaining tiles to navigate it.",
        },
        {
          question: "Can I play 2048 on my mobile device?",
          answer:
            "Indeed, 2048 can be played online on any device. You can play 2048 without the need for a download on both desktop and mobile browsers through EpicPlay.",
        },
      ],
      systemRequirements: [
        {
          items: [
            "2048 on EpicPlay can be played on Windows 7, Android 4.4, iOS 8 or higher versions. You can play it on browsers including Google Chrome, Safari, Opera, and Mozilla Firefox. Android WebView also supports it.",
            "It is important to note that these are the minimum system requirements and that higher specifications may be required for optimal performance.",
          ],
        },
      ],
    },
  },
  epl: {
    details: {
      title: "EPL - IPL Cricket Game Online",
      gameData: [
        {
          description: [
            "If you have always wanted to play for your favorite IPL team, here is your chance. With Epic Premiere League (EPL), you can bat for any of the IPL teams, score top runs, and put them on top of the leaderboard. Whether you're a die-hard IPL fan or want to play free cricket only for leisure, EPL is your go-to game. With realistic stadium designs, top-notch graphics, and an unparalleled batting experience, EPL will make your IPL batting dreams come true.",
            "Free IPL cricket browser games for PC and mobile are almost non-existential. So, we created an absolutely free virtual simulation of the popular sport, for the IPL buffs. Experience an immersive batting and stadium experience and the thrill of playing an IPL match for free, only with EPL. Play and enjoy it — on any computer or mobile device for free.",
          ],
        },
        {
          title: "About - Free IPL Cricket Game On EpicPlay",
          description: [
            "EPL is a free IPL cricket game available on EpicPlay, designed to provide an immersive gaming experience to cricket, and more importantly, IPL lovers. Unlike other cricket games, EPL lets you bat and score for your favorite IPL teams, just as you would for them if given a chance. Gather your friends and play IPL cricket with them for free. Challenge other teams, bat for your favorite, and set new scores on the leaderboard. You can play for any IPL team you wish — Royal Challengers Bangalore, Chennai Super Kings, Mumbai Indians, Kolkata Knight Riders, and more! EPL provides an unmatched cricket gaming experience, thanks to realistic graphics, state-of-the-art gameplay, and lifelike batting angles.",
          ],
        },
        {
          image: {
            path: "/game-assets/game-images/ipl-cricket-game-online.jpg",
            alt: "IPL Cricket Game Online",
            title: "IPL Cricket Game Online",
            caption: "IPL Cricket Game Online",
          },
        },
        {
          title: "Gameplay of Free IPL Cricket Game For PC",
          description: [
            "Ever wanted to step into the shoes of a professional IPL cricketer? EPL by EpicPlay makes that possible! Begin the game by selecting the IPL team you want to represent. Compete in high-octane matches against other teams and set record-breaking scores to make your team top the leaderboard. As a batsman, your mission is to lead your team to the top. You can also see the number of players playing simultaneously for your team. On the pitch, you'll face tough opposition in the form of a skilled bowler whose only aim is to dismiss you.",
            "The game begins with the IPL background theme score (designed by Francois Pienaar) to boost the batsman in you. As you stride towards the crease, you can sense the buzz and anticipation building up in the stadium. The bat symbol will lead you — you cannot tap if the symbol's background is gray and strike a shot only when it is white. The indicator around the bat icon will show a 1x/2x/3x to show the streak while you constantly score boundaries. You need to use either the space bar, tap the mouse, or the touchpad to strike. On a smartphone screen, you can simply tap on the screen to strike the ball. ",
            "Every score you make will be added to the leaderboard. And, at the end of each game, your team's score flashes on the screen, revealing whether you've made it to the top. It also shows you how many stars you have won for your batting skills. With every match and every run, you'll be hooked on the thrilling rush to outscore your opponents.",
          ],
        },
        {
          title: "How to play & Rules - IPL Games Online",
        },
        {
          subTitle: "Controls",
          description:
            "EPL has user-friendly controls that let players focus on the game instead of struggling with controls. You can use a mouse, spacebar, touch board, or touchscreen to control the game, depending on the device you are using. Smartphone users can just tap the screen at the right moment to strike.",
          items: [
            {
              title: "PC",
              description:
                "Click the mouse/press the spacebar/tap the touchpad to strike",
            },
            {
              title: "Mobile",
              description: "Tap the screen to strike",
            },
          ],
        },
        {
          subTitle: "How to play",
          items: [
            "The objective of the game is to score as many runs as possible for your IPL team.",
            "Time your shots correctly and try not to miss shots.",
            "A six is scored when the batsman whacks the ball over the boundary rope without bouncing. On the other hand, a four is scored when the ball reaches the boundary rope after bouncing on the ground.",
            "The score will always be visible, and when you finish your game, you will also see the leaderboard to check where your team stands.",
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "Each player gets to bat for an unlimited number of overs.",
            "If the batsman fails to strike the ball or miss the ball, they're out.",
          ],
        },
        {
          title: "Tips and Tricks - High Scoring in IPL Game for PC",
          items: [
            "Timing is crucial in cricket, and it's no different in the EPL. Tap at the right moment as the ball approaches you after pitching, to score the best shot. If you fail to tap at the right time or delay the tap, you will get out.",
            "Sometimes, the best way to score runs is to be patient and wait for the right ball to hit. Don't get frustrated if you're not scoring quickly – the runs will come if you stay calm and focused.",
            <>
              Practice makes perfect! Spend some time in practice with{" "}
              <a
                className="text-primary"
                href="https://www.epicplay.in/games/cricket-stars"
              >
                Cricket Stars Game
              </a>{" "}
              to improve your timing, and you'll find it much easier to score
              runs in the game.
            </>,
            "Remember to have fun! Cricket is a great sport that requires skill, strategy, and patience. Enjoy the game and don't get discouraged if you don't win every time.",
          ],
        },
      ],
      faq: [
        {
          question: "Can I play the IPL cricket game online for free?",
          answer:
            "Yes, EPL is a free IPL cricket online game that you can access on EpicPlay.",
        },
        {
          question: "What are some popular IPL online cricket games for PC?",
          answer:
            "Some of the popular IPL online cricket games for PC and mobile are Epic Premier League (EPL) on EpicPlay, Cricket 19, Real Cricket 22, and IPL Cricket 2023.",
        },
        {
          question: "Which is the best IPL game for Android?",
          answer:
            "EPL by EpicPlay is the best IPL game for Android that can be accessed on all mobile browsers.",
        },
        {
          question: "Can I choose my own team in IPL cricket games?",
          answer: "Yes, you can choose your own team in IPL cricket games.",
        },
        {
          question: "Where can I play IPL cricket games?",
          answer:
            "You can play IPL cricket games like EPL on all the web browsers. Some IPL cricket games are also available on app stores, desktop, and PlayStation.",
        },
        {
          question:
            "Can I play IPL cricket games with friends or other players online?",
          answer:
            "Yes, you can play IPL cricket games with friends or other players online. Various online cricket match games available allow you to play with others online. With EPL, you can note down your score vs your friends and challenge them in real life.",
        },
        {
          question: "What features can I expect in an IPL cricket game?",
          answer:
            "The major features you can expect in any IPL cricket game are to choose your IPL team, bat for your team, and score top runs. Leaderboard, audience reactions, audio background theme score, and team icons are some additional features only top IPL cricket games have.",
        },
        {
          question: "Where can I play IPL cricket games? ",
          answer:
            "IPL cricket games like EPL can be played on cross devices such as desktop, mobile, and tablet browsers.",
        },
        {
          question:
            "What are the system requirements for playing IPL cricket games on PC?",
          answer:
            "Different IPL cricket games on PC need different specifications to play. EPL or Epic Premiere League needs a Windows 7 (64-bit) or higher version for PC.",
        },
      ],
      systemRequirements: [
        {
          description:
            "If you want to enjoy a smooth gaming experience while playing EPL, there are some basic device requirements you should meet. While EPL offers simplified controls, a higher-end device can enhance your game performance. So, make sure your device meets these requirements for the best gameplay.",
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 4.4 or higher",
            "iOS 8 or higher",
          ],
        },
      ],
    },
  },
  cricket_star: {
    details: {
      title: "Cricket Games - Online Cricket Games For PC",
      gameData: [
        {
          description: [
            "Online Cricket games for PC have become increasingly popular in recent years, offering a virtual simulation of one of the most beloved sports in the world. With realistic graphics, intricate gameplay mechanics, and the ability to play against other players online, cricket games have given fans a way to experience the excitement and thrill of the sport from the comfort of their computers.",
            "One of the reasons why people love online cricket games is the ability to immerse themselves in the sport they love. With accurate representations of stadiums, players, and equipment, players can feel like they are a part of the action as they bat, bowl, and field their way to victory.",
          ],
        },
        {
          title: "About - Free Cricket Game on EpicPlay",
          description: [
            "Cricket Star is a free online cricket game offered by EpicPlay that is perfect for all cricket fans. It offers a fun and engaging way to pass the time while also enjoying the excitement of cricket.",
            "The game gained a huge fan following because of its realistic gameplay and user-friendly interface. Whether you're a seasoned cricket player or just a casual fan, Cricket Star is the perfect way to enjoy the sport. So why wait? Start playing Cricket Star right away!",
          ],
        },
        {
          title: "Gameplay of Free PC Cricket Game",
          description: [
            "In this free cricket game, you get to pretend to be a cricketer who is going to bat. You look at the field and the bowler and get ready for the first ball. When the bowler throws the ball, you watch it carefully and try to hit it. You need to be alert and ready to move quickly in case the ball surprises you. You want to get as many runs as possible without getting out.",
            "As you keep playing, you become better at hitting the ball and avoiding getting out. It feels really good when you hit the ball perfectly and it goes far. Even if you don't win the game, you feel proud that you tried your best and had fun playing.",
          ],
        },
        {
          image: {
            path: "/game-assets/game-images/cricket-star-game-online.jpg",
            alt: "Cricket Star: Free Online Cricket Game",
            title: "Cricket Star: Free Online Cricket Game",
            caption: "Cricket Star: Free Online Cricket Game",
          },
        },
        {
          title: "How to play & Rules - Cricket Game Online",
          subTitle: "Controls",
          items: [
            {
              title: "Desktop",
              description:
                "Press the spacebar, tap the touchpad, or click the mouse to hit the ball.",
            },
            {
              title: "Mobile",
              description: "Tap the screen to hit the ball.",
            },
          ],
        },
        {
          subTitle: "How to play",
          description:
            "Cricket Star aims to score as many runs as possible in a limited number of overs.",
          items: [
            "The batting team will be under your direction as they attempt to hit the ball thrown by the bowler of the opposite team.",
            "If you hit the ball well, you can score runs by running back and forth between the wickets.",
            'You can also score runs if the ball goes over the boundary line while touching the ground, which is called a "boundary" and is worth four runs. If the ball crosses the boundary without bouncing, it is called a "six" and is worth six runs.',
            "Hitting the ball too early or too late or not hitting the ball at all causes you to get out.",
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "The bowler bowls the ball within a specific area called the pitch.",
            "To score runs, the batting team hits the ball and moves back and forth between the wickets.",
            "The ball must cross the boundary without hitting the ground for the batting team to score a 6. ",
            "The ball must cross the boundary by staying on the ground to score a 4.",
            "If a player hits the ball in the air and a fielder catches it, the batsman is out.",
            "The batsman is out if they fail to hit the ball, and it strikes the wickets behind them.",
            "The batsman is out if they hit the ball too early or not hit it at all.",
          ],
        },
        {
          title: "Tips and Tricks - High Scoring in Cricket Game for PC",
          items: [
            "Timing and shot selection are crucial for scoring runs in cricket. Try to time your shots well and choose the right shot based on the delivery.",
            "Practice makes perfect, so spend some time practicing to get accustomed to the controls and the gameplay.",
            "Try to time your shots when the ball is in your hitting zone and place it in the gaps in the field to score 4s and 6s.",
          ],
        },
      ],
      faq: [
        {
          question: "What are cricket games?",
          answer:
            "Cricket games refer to video games or mobile games that simulate the sport of cricket. These games allow players to experience the excitement and challenges of playing cricket in a virtual environment.",
        },
        {
          question: "Are cricket games free to play?",
          answer:
            "Yes, online cricket games are available for PC and mobile devices and can be played for free.",
        },
        {
          question: "How do I control the gameplay in cricket games?",
          answer:
            "In cricket games, you can exert control over gameplay through various means. You command the batting by selecting shots and timing them accurately to score runs, while also strategizing field placement and bowling deliveries to outwit opponents.",
        },
        {
          question:
            "Are there any in-game purchases or microtransactions in cricket games?",
          answer:
            "Yes, some online cricket games may have in-game purchases or microtransactions. These can include purchasing additional teams, players, or equipment or unlocking specific features or game modes.",
        },
        {
          question:
            "Can I play cricket games with friends or other players online?",
          answer:
            "Yes, you can play cricket games with friends or other players online. Various online best cricket games available allow you to play with others online.",
        },
        {
          question: "How difficult is it to learn and play cricket online?",
          answer:
            "Learning and playing cricket online can vary in difficulty depending on the individual's familiarity with the sport and experience with video games.",
        },
      ],
      systemRequirements: [
        {
          description:
            "If you want to play an online Cricket Star on EpicPlay, check some basic system requirements before playing any game. It is crucial to emphasize that the listed system requirements represent the minimum specifications for an essential gaming experience. Higher specifications may be necessary for optimal performance and a smoother gameplay experience.",
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 4.4 or higher",
            "iOS 8 or higher",
          ],
        },
      ],
    },
  },
  epic_quiz: {
    details: {
      title: "Quiz Game | Trivia - Online Quiz Questions Answers",
      gameData: [
        {
          description: [
            "Are you looking for a game where your knowledge can be tested? If yes, we have the ideal game tailored just for you. Trivia and quiz games have everything you’re looking for. This game has gained immense popularity across the country, and it's not hard to see why.",
            "Trivia games are all about testing your knowledge of various subjects, including history, geography, science, pop culture, and more. Trivia games give people a chance to show how smart they are. Nowadays, these games are easy to find online. This means anyone can easily play them.",
            "Trivia and quiz games are super fun and exciting! They have fast gameplay and challenging questions. You can compete against others and beat high scores. It feels amazing when you answer a question correctly or remember something you forgot.",
            "Quiz games also help you learn new things in a fun way. Even if you don't know an answer, you can still learn from the explanations given. So, get ready to have a blast and expand your knowledge with trivia and quiz games!",
          ],
        },
        {
          title: "About - Epic Quiz Questions & Answers Game",
          items: [
            "To blow up your mind with an interesting game, EpicPlay came up with an Epic Quiz game. This game takes trivia gaming to a whole new level. With its unique features and gameplay, this game stands out from the rest of the market.",
            "What makes this game truly epic? It’s the attention to every little detail and making sure to have a huge collection of questions. You won't find yourself getting bored with this game because there are so many challenging questions across a wide variety of topics.",
            "What makes this game even more amazing is how accurate and relevant the questions are. EpicPlay has taken the time to make sure the questions are just right, so you can test your knowledge and learn new things.",
            "To make the game more interesting, there are timed challenges and lifelines to help you. When you get an answer right, you'll feel a surge of excitement! The game adds even more excitement with a timer that makes you feel like you're racing against the clock.",
            "So, get ready to have a blast with the Epic Quiz Questions & Answers Game, and enjoy a one-of-a-kind experience that you won't find anywhere else!",
          ],
        },
        {
          title: "Gameplay - Online Trivia & Quiz Game",
          description:
            "Are you ready to dive into the Epic Quiz game to test your skills? If you're curious about how the gameplay works, let's take a closer look at its gameplay.",
          image: {
            path: "/game-assets/game-images/trivia-game-online-quiz.jpg",
            alt: "Trivia Game: Online Quiz",
            title: "Trivia Game: Online Quiz",
            caption: "Trivia Game: Online Quiz",
          },
        },
        {
          numberItems: [
            {
              title: "Start the Game",
              description:
                'Upon launching the game, you will be greeted with a captivating start screen with instructions. Click on the "Start Quiz" button to kick-start the game.',
            },
            {
              title: "Read the Question",
              description: [
                "A question will appear on the screen along with multiple answer options. Take your time to read and understand the question carefully. Each game consists of three rounds.",
                "Each round contains five multiple-choice questions. These rounds are designed to test your knowledge across various topics such as history, science, geography, pop culture, and more.",
              ],
            },
            {
              title: "Select Your Answer",
              description:
                "Choose the answer that you believe is correct by clicking on the option.",
            },
            {
              title: "Use Lifelines",
              description:
                "If you find yourself uncertain about the answer, you have the option to use lifelines. These lifelines can help you while playing:",
              subItems: [
                {
                  title: "50/50 Lifeline",
                  description:
                    "Clicking on this lifeline will remove two incorrect answer options, increasing your chances of selecting the correct one.",
                },
                {
                  title: "Audience Poll Lifeline",
                  description:
                    "By selecting this lifeline, you can see what other players think is the correct answer.",
                },
                {
                  title: "Change Question/Flip Question Lifeline",
                  description:
                    "This lifeline allows you to skip the current question and receive a new one instead.",
                },
              ],
            },
            {
              title: "Answer within the Timer",
              description:
                "Every question must be answered within a time frame of 15 seconds. Make sure to answer the question before the timer runs out.",
            },
            {
              title: "Correct Answer",
              description:
                "If your answer is correct, you will receive points and move on to the next question.",
            },
            {
              title: "Incorrect Answer",
              description:
                "If you happen to select the wrong answer or run out of time, the game will end. But don't worry, you can always try again to beat your previous score!",
            },
          ],
        },
        {
          description:
            "In case you select the wrong answer and want to continue playing, EpicPlay offers an additional life. By watching a short ad, you can get back into the game and continue with the rounds.",
        },
        {
          title: "How to Play & Rules - Epic Quiz Game ",
        },
        {
          subTitle: "How to play:",
          items: [
            {
              title: "Desktop",
              description:
                "Use the mouse to navigate through the game interface. Click to select the answer option. If you want to activate Lifeline then click on the designated keys that are specified in the game.",
            },
            {
              title: "Mobile",
              description:
                "Tap on the answer option to select your choice. If want to activate the lifelines, tap on the designated lifeline icons.",
            },
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "Each question has a time limit to provide your answer. Answer within the time limit of 15 seconds to earn points and proceed to the next question. If the time runs out, the question will be considered incorrect, and you may lose a life.",
            "The game offers various lifelines to assist you. Each lifeline can only be used once, so use them strategically. Lifelines include 50/50, Change Question/Flip Question, and Audience Poll.",
            "The game consists of 3 rounds, each with its own set of questions. Questions may increase in difficulty as you progress.",
            "Earn points for each correct answer based on the game's scoring system.",
          ],
        },
        {
          title:
            "Tips and Tricks - Clear All Questions & Answers of Trivia Game",
        },
        {
          subTitle: "Tips:",
          items: [
            "Focus on each question and read it carefully to increase your chances of answering correctly.",
            "Trivia games cover a wide range of topics. Spend some time refreshing your knowledge in different areas to improve your chances of answering correctly.",
            "Sometimes, your gut feeling can guide you to the right answer. Trust your intuition.",
            "Most trivia games have time limits, so be mindful of the clock.",
            "Before selecting an answer, make sure you read all the options.",
          ],
        },
        {
          subTitle: "Tricks:",
          items: [
            "Lifelines can be a game-changer. Save them for challenging questions that you're unsure about. Don't waste them on easy questions.",
            'The "50/50" lifeline eliminates two incorrect answer options. Only use it when you\'re unsure and want to narrow down your choices.',
            "When all else fails, take an educated guess. Eliminate obviously wrong options and make an educated guess based on your knowledge or any clues within the question itself.",
          ],
        },
      ],
      faq: [
        {
          question: "How many players can join the quiz game?",
          answer:
            "The quiz game allows multiple players to participate simultaneously.",
        },
        {
          question:
            "What categories or topics are included in the trivia game?",
          answer:
            "The trivia game covers various categories like history, geography, science, pop culture, and more.",
        },
        {
          question: "Is there a time limit for answering each question?",
          answer:
            "Yes, there is a time limit of 15 seconds for answering each question in the quiz game to keep the gameplay exciting.",
        },
        {
          question:
            "Can players earn points or rewards based on their performance?",
          answer:
            "Yes, players can earn points or rewards based on their performance in the trivia game.",
        },
        {
          question:
            "Are there any power-ups or lifelines available to assist players?",
          answer:
            "Yes, there are power-ups or lifelines available to assist players in the quiz game. These lifelines can provide hints or eliminate incorrect options.",
        },
        {
          question: "How many rounds or levels are there in the trivia game?",
          answer:
            "The trivia game consists of 3 rounds to provide an engaging and challenging experience.",
        },
        {
          question: "Can players track their progress or high scores?",
          answer:
            "Yes, players can track their progress and high scores in the trivia game to see how well they are performing.",
        },
        {
          question:
            "How frequently are new questions or updates added to the quiz game?",
          answer:
            "New questions and updates are regularly added to the quiz game to ensure it remains fresh and engaging for players.",
        },
      ],
      systemRequirements: [
        {
          description:
            "To fully enjoy the Epic Quiz game and have a seamless gaming experience, please ensure that your device meets the following system requirements: ",
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 5.0 or higher",
            "iOS 10.0 or higher",
          ],
        },
        {
          description:
            "By meeting these system requirements, you can dive into the world of Epic Quiz and have a fantastic time answering trivia questions and challenging your knowledge.",
        },
      ],
    },
  },
  knife_dash: {
    details: {
      title: "Flippy Knife Hit Game Online | Flip Games For Free",
      description: [
        "Welcome to the exciting world of flip games! Are you someone who enjoys testing your coordination and precision? If yes, Flippy knife games are the perfect choice for you. These games include challenges that revolve around the art of flipping knives.",
        "Flip-knife games require players to master the art of timing and accuracy. The objective typically involves flipping knives and successfully hitting targets. It may sound simple, but you'll find out the obstacles that will put your flipping skills to the test.",
        "Are you excited to go on an exciting adventure of flipping knives and improving your aim? Dive into the world of flip knife games today! Get ready to flip, aim, and hit your way to victory!",
      ],
      gameData: [
        {
          title: "About - Free Flippy Knife hit game",
          description: [
            "You can experience the thrill of the Flippy Knife game on EpicPlay, the home of the free Flippy Knife Hit game where you can discover amazing Knife games. The objective is simple. All you need to do is flip the knife in the air and try to land it on various targets. Each successful hit earns you points and unlocks new knives and challenging levels.",
            "You must be wondering why Flippy Knife is so much fun to play. Following are some of the reasons to answer your curiosity:",
          ],
          items: [
            "It's the ultimate time-killing game that keeps you engaged and entertained for hours.",
            "The simple gameplay mechanics make it easy to pick up and play, even if you're new to gaming.",
            "The easy controls allow you to flip the knife with just a tap, making it accessible to players of all ages.",
            "It presents new and thrilling challenges. It keeps you engaged and motivated to improve your skills.",
            "Flipping knives and hitting targets is incredibly satisfying. The engaging nature of the game will have you coming back for more.",
          ],
        },
        {
          description:
            "So, grab your virtual knife and show off your flipping skills. Flippy Knife guarantees hours of fun and a thrilling experience you won't want to miss!",
        },
        {
          title: "Gameplay of Flippy Knife game",
          description: [
            "In Flippy Knife, you'll have the opportunity to showcase your skills by aiming for various targets. By clicking or tapping on the screen, you can make the knife flip. The goal is to time your actions perfectly and land the knife on the targets with accuracy.",
            "The game offers a target of wooden blocks. You are required to adjust your technique and aim carefully. It's all about finding the right balance between power and precision.",
            "As you progress in the game, you'll encounter rocks. Make sure not to hit the knife with the rock. These obstacles add an extra layer of thrill to your gameplay.",
            "One of the exciting aspects of Flippy Knife is the scoring system. You'll aim to achieve high scores by successfully landing your knife on the targets. Can you beat your own records and strive for perfection? It's a challenge that will keep you engaged and motivated.",
          ],
          image: {
            path: "/game-assets/game-images/flippy-knife-game-online.jpg",
            alt: "Knife Dash: Flippy Knife Hit Game",
            title: "Knife Dash: Flippy Knife Hit Game",
            caption: "Knife Dash: Flippy Knife Hit Game",
          },
        },
        {
          title: "How to play & Rules - Knife Dash, the best Flip Game",
          description:
            "Do you want to learn how to play the Knife Dash game perfectly? If yes, keep reading to learn everything you need to know about it.",
          subTitle: "How to Play?",
        },
        {
          subTitle: "Desktop:",
          items: [
            "Launch the Knife Dash game on your browser.",
            "Use the left mouse button to initiate the knife flip.",
            "Click and hold the left mouse button to control the power of your flip.",
            "Release the mouse button to flip the knife.",
          ],
        },
        {
          subTitle: "Mobile:",
          items: [
            "Open the Knife Dash game on your mobile device.",
            "Tap the screen to start the knife flip.",
            "Hold your finger on the screen to control the power of your flip.",
            "Lift your finger to release the knife and make it flip.",
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "Only hit the wooden surfaces with your knife. Hitting any rock will result in a failed attempt.",
            "Be careful not to hit the previous knife you flipped, as it will also result in a failed attempt.",
          ],
        },
        {
          title: "Tips and Tricks - Knife Flip game",
          description:
            "Are you eager to enhance your skills and become a master of Knife Dash? Well, look no further! We have just the right tips and tricks to help you achieve your goal of improving your performance.",
          subTitle: "Tips",
          items: [
            "Maintain a steady grip on the knife to keep it stable.",
            "Avoid excessive hand movements while flipping the knife.",
            "Exercise patience and wait for the right moment to make your move.",
            "Observe the rotating obstacles and identify the perfect time to release the knife.",
            "Aim to land the knife on top of stable wooden surfaces for a successful flip.",
          ],
        },
        {
          subTitle: "Tricks",
          items: [
            "Understand the movement patterns of the obstacles and develop a strategy to pass through them.",
            "Wait for the appearance of a wooden circle to aim for a secure landing.",
            "Time your flips carefully to align with the rotation of the obstacles.",
            "Practice precision and consistency in your flips to improve accuracy.",
            "Adapt your strategy as the game progresses and the difficulty level increases.",
            "Pay attention to the speed and direction of the rotating obstacles.",
            "Develop a rhythm or timing pattern that works best for you to maintain a steady motion.",
            "Take breaks and rest if you feel fatigued.",
          ],
        },
      ],
      faq: [
        {
          question: "How do I play the Flippy Knife game online?",
          answer:
            "To play Flippy Knife online, visit the website EpicPlay, and follow the instructions provided.",
        },
        {
          question: "What is the objective of Flippy Knife?",
          answer:
            "The objective of Flippy Knife is to continuously flip the knife and score points by landing it on wooden surfaces while avoiding obstacles.",
        },
        {
          question: "Can I compete with other players in Flippy Knife online?",
          answer:
            "Yes, Flippy Knife offers leaderboards where you can compete with other players online.",
        },
        {
          question:
            "Is Flippy Knife available for mobile devices or only on a computer?",
          answer:
            "The Flippy Knife game is available for both mobile devices and computers.",
        },
        {
          question:
            "How can I improve my knife-flipping skills in Flippy Knife?",
          answer:
            "To improve your knife flipping skills in Flippy Knife, you need to keep the knife stable, time your flips accurately, and develop strategies to navigate obstacles.",
        },
      ],
      systemRequirements: [
        {
          description:
            "To ensure a smooth gaming experience in Knife Dash, you need to meet the following basic device requirements:",
          subTitle: "For Desktop:",
          description: "Operating System: Windows 7 (64-bit) or higher.",
        },
        {
          subTitle: "For Mobile:",
          items: [
            "Android: Version 4.4 or higher.",
            "iOS: Version 8 or higher.",
          ],
        },
        {
          description: [
            "Please note that these are the minimum system requirements, and it's always beneficial to have the latest operating system version and sufficient device performance for optimal gameplay.",
            "By meeting these requirements, you'll be able to enjoy Knife Dash on your preferred platform without any compatibility issues.",
          ],
        },
      ],
    },
  },
  meteor_attack: {
    details: {
      title: "Galaxy Shooter (Meteor Attack) Game | Free Tap Game",
      gameData: [
        {
          description: [
            "Welcome to the exciting world of tap games and the captivating genre of galaxy and space games! Tap games are super fun and easy to play. All you need to do is just tap on your device's screen and let the magic begin! But what really grabs hold of players is the irresistible charm of space.",
            "Space games have become incredibly popular in the gaming world, making people can’t get over it any sooner. These games let you become a brave space explorer who has the responsibility of saving the universe by fighting against aliens.",
            "It's easy to see why space-themed games are so popular. Space has always fascinated us with its mysteries. The idea of fighting aliens is really exciting. These games let you experience all of that excitement yourself!",
            "So, get ready to tap your way through space and let your imagination soar. Space-themed games are really popular, and now it's your turn to join in on the fun!",
          ],
        },
        {
          title: "About - Space Meteor Game ☄️🪐🌌",
          description: [
            <>
              Are you excited to know about a <b>Meteor Attack</b> that can keep
              you on the edge of your seat? You can never go wrong with
              EpicPlay's Meteor Attack game. It's a guaranteed hit!
            </>,
            "In this game, you will become a brave space pilot tasked with protecting yourself from a rain of meteors. With just a tap of your finger, you can move your rover. It's all about quick reflexes and strategic tapping!",
            "The best part is, you can enjoy space games on any device you have. It doesn’t matter, whether it's your smartphone, tablet, or even your computer. You can dive into the game anytime, anywhere. There is no need for complicated controls.",
            "This easy-to-play tap game is great for everyone, no matter their age. It's simple to learn, but it will keep you entertained for hours as you try to get a high score. The game is so engaging and the colorful graphics will make you feel like you're in another world.",
          ],
          image: {
            path: "/game-assets/game-images/galaxy-meteor-attack-game.jpg",
            alt: "Free Galaxy Meteor Attack Game",
            title: "Free Galaxy Meteor Attack Game",
            caption: "Free Galaxy Meteor Attack Game",
          },
        },
        {
          title: "Gameplay of Free Galaxy Meteor Attack game",
          description: [
            "In this Free Galaxy Meteor Attack game, you get to experience exciting gameplay with multiple planets.",
            "The storyline revolves around the mission of saving your space rover. The rover has been sent to an unexplored planet to gather valuable information. But suddenly, meteors start raining down, threatening to destroy the rover. Your mission is to help the rover escape the meteor attack and gather as much information as possible.",
            "Your task is to control the rover's movements, either moving it from left to right or right to left. Make sure to keep it safe from the falling meteors. The longer the rover survives, the more information it can transmit back to the space station. So, every second counts!",
            "To help you in your mission, keep an eye out for special shields. Collecting these shields will grant the rover protection from one meteor hit each time. This gives you a better chance of survival and gathering more vital information.",
          ],
        },
        {
          title: "How to play & Rules - Meteor Attack, Space Tap game",
          description:
            "Do you want to know about the rules and how to play the game? Here is a breakdown of it!",
        },
        {
          subTitle: "How to Play:",
          items: [
            {
              title: "Desktop",
              description:
                "To play tap games on your desktop, use the mouse or spacebar to change and control the direction of the rover. To keep the rover steady in one place, repeatedly click the mouse or space bar.",
            },
            {
              title: "Mobile",
              description:
                "On your mobile device, touch the screen to change the direction of the rover. Continuously tapping the screen can make the rover stay in one spot.",
            },
          ],
        },
        {
          subTitle: "Rules:",
          items: [
            "Search for blue shields during gameplay. These shields provide temporary protection from meteor hits.",
            "Dodge and evade falling meteors to avoid any collisions.",
            "Timing Matters. Pay attention to the speed and direction of the meteors.",
            "Aim to achieve the highest score possible by keeping the rover safe for as long as you can.",
            "Be prepared for the game to progressively get faster and more challenging as time goes on.",
            "If the rover gets hit by a meteor, the game will end.",
          ],
        },
        {
          description:
            "Keep these rules in mind as you start your meteor-avoiding adventure in Meteor Attack.",
        },
        {
          title: "Tips and Tricks - Galaxy Meteor Attack Game",
        },
        {
          subTitle: "Tips:",
          items: [
            "Stay attentive and keep an eye out for incoming meteors.",
            "Time your movements carefully to avoid getting hit. Move your space rover only when a meteor is approaching.",
            "Focus on collecting blue shields whenever possible.",
            "Instead of constantly moving your space rover, wait for the right moment.",
            "Observe patterns in meteor movement and timing.",
          ],
        },
        {
          subTitle: "Tricks:",
          items: [
            "Practice Makes Perfect. The more you play, the better you will become at it.",
            "Develop a sense of timing by practicing your movements in sync with meteor patterns. ",
            "Stay focused and avoid distractions while playing.",
            "Keep a calm and composed mindset while playing. Panicking can only lead to hasty moves.",
            "Remember these tips and tricks can help you to become a skilled meteor!",
          ],
        },
      ],
      faq: [
        {
          question: "How do I play the Meteor Attack space game?",
          answer:
            "To play the Meteor Attack space game on a desktop, use the mouse or spacebar to control the rover's direction and on mobile, touch the screen to change the rover's direction.",
        },
        {
          question: "What is the objective of the Meteor Attack?",
          answer:
            "The goal is to save the rover from meteor attacks and collect information. Dodge the falling meteors and survive as long as possible to transmit more data to the space station.",
        },
        {
          question: "Are there different levels or stages in the game?",
          answer:
            "Yes, Meteor attacks get difficult as you play. The game gets faster, posing a greater challenge as you advance.",
        },
        {
          question: "Are there power-ups or special abilities in the game?",
          answer:
            "Yes, you can collect blue shields that provide temporary protection from meteor hits. These shields give your rover an extra layer of defense.",
        },
        {
          question:
            "Is Meteor Attack available for mobile devices or only on a computer?",
          answer:
            "Meteor Attack is available for both desktop and mobile devices. ",
        },
        {
          question: "How can I improve my score in Meteor Attack?",
          answer:
            "To improve your score, focus on timing your movements, collecting shields, and avoiding meteor collisions. Practice regularly and stay alert to maximize your survival time.",
        },
      ],
      systemRequirements: [
        {
          description:
            "Meteor Attack is a fun game that can be played on a wide range of devices without the need for high specifications. Here are the basic device requirements to ensure a smooth gaming experience:",
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 4.4 or higher",
            "IOS 8 or higher",
          ],
        },
      ],
    },
  },
  chop_em_all: {
    details: {
      title: "FruitNinja - Play Fruit Cut Game Online",
      gameData: [
        {
          description: [
            "Welcome to FruitNinja's tangy world! Are you prepared for the best fruit-slicing action yet? In this thrilling game, grab your blades and get ready to chop and slice your way through a colorful assortment of fruits!",
            "FruitNinja's look and feel is vibrant, colorful, and welcoming. The game features an enjoyable graphics style. The fruits look juicy and delicious, and the bombs are dangerous enough to make you want to avoid them at all costs. ",
          ],
        },
        {
          title: "About - Favorite Fruit Chop Game",
          description:
            "Are you considering playing FruitNinja online? Great choice! This game is fun, engaging, and perfect for gamers of all ages and skill levels. It came out and launched in the app stores in 2010 and since then, its gameplay has been adopted into various games.",
        },
        {
          description:
            "To help you get started, here's a comprehensive list of FruitNinja terms you should know:",
          items: [
            "Fruits - These are the objects in the game that you will be chopping and dicing. There are many kinds of fruits in the game.",
            "Bombs - You want to avoid chopping any of these objects. You'll lose a life if you slice a bomb.",
            "Combos - You can get bonus points by cutting these consecutive slices of fruit.",
            "High Score - This is the game's highest score you've ever gotten. Beat your previous best to get the greatest score.",
            "Critical Hits - These unique fruit slices give you bonus points. When you cut the fruit in just the correct place, you get critical hits.",
          ],
        },
        {
          description:
            "So why should you play the fruit slice game? Here are just a few reasons:",
          items: [
            "It's a fun and engaging game that's easy to learn but challenging to master.",
            "It's a great way to improve your hand-eye coordination and reflexes.",
            "It's perfect for passing the time on a long commute, during a break at work, or just when you need a quick gaming fix. This fruit chop game online is perfect for anyone looking for a quick and easy way to pass the time.",
            "It's available on multiple platforms, including mobile devices and desktops, so you can play fruit slice games wherever and whenever you want.",
          ],
        },
        {
          title: "Gameplay of FruitNinja Game",
          description:
            "Take on the persona of a talented ninja who is an expert at slicing fruits in the fruit cut game. Slice through several fruits at once with only a swipe, earning points and power-ups along the way. But you can also lose a life with one bad decision—slicing a bomb. So, be quick, and precise, and stay watchful!",
        },
        {
          description: "You can play FruitNinja in three different modes.",
          items: [
            {
              title: "Classic Mode",
              description:
                "This is the game's original mode, in which you slice as many fruits as you can while dodging bombs.",
            },
            {
              title: "Zen Mode",
              description:
                "There are no explosions or distractions in this mode, just fruit-slicing fun. Without any pressure, you can slice fruit at your own pace.",
            },
            {
              title: "Arcade Mode",
              description:
                "This mode increases the game's difficulty level. You'll only have a certain number of lives, but you'll also get unique bonuses and power-ups to help you.",
            },
          ],
        },
        {
          image: {
            path: "/game-assets/game-images/fruit-cut-game-online.jpg",
            alt: "FruitNinja - Play Fruit Cut Game Online",
            title: "FruitNinja - Play Fruit Cut Game Online",
            caption: "FruitNinja - Play Fruit Cut Game Online",
          },
        },
        {
          title: "How to play & Rules - FruitNinja",
          description:
            "Are you ready to become a fruit-slicing ninja master? Here's everything you need to know to play and win at FruitNinja.",
        },
        {
          subTitle: "Controls",
          description: [
            "The controls for FruitNinja are simple. All you need is your finger to swipe across the screen and slice fruits as they appear. It's easy to pick up, but challenging enough to keep you engaged in gameplay for hours.",
            "To start playing FruitNinja on your device, use the appropriate controls:",
          ],
          items: [
            {
              title: "Laptop",
              description:
                "Double-tap the touchpad and swipe through the center of the fruit to begin the game.",
            },
            {
              title: "Desktop",
              description:
                "Click and swipe through the center of the fruit to start playing.",
            },
            {
              title: "Mobile",
              description:
                "Swipe through the center of the fruit to start playing.",
            },
          ],
        },
        {
          subTitle: "How to Play",
          description:
            "Sliding around the screen to slice fruits is all it takes to play FruitNinja online. Here's a how-to manual to get you going:",
          items: [
            "Start the game and select Classic, Arcade, or Zen as your favorite way of playing.",
            "Fruits will start to show up on the screen once you've started playing the game. To cut them, simply swipe across the display.",
            "You'll gain points for slicing fruits. But take care—bombs will also show up on the screen, and cutting one will result in loss of life. Keep slicing fruits and avoiding bombs until you run out of lives or reach the end of the game.",
          ],
        },
        {
          subTitle: "Rules",
          description:
            "There are a few rules to keep in mind while playing FruitNinja:",
          items: [
            "Slice as many fruits as you can, but avoid slicing bombs.",
            "You'll start with a set number of lives - don't lose them all before the game ends.",
            "Bonuses can help you along the way, but they're not always easy to come by.",
            "Stay focused and slice as many fruits as possible to come out on top.",
          ],
        },
        {
          title: "Tips and Tricks - Chop the Fruit & Score High",
          description:
            "Are you looking to improve your gameplay and score higher in the FruitNinja game? Well, look no further because we have some tips and tricks that can help you achieve your goal!",
          items: [
            {
              title: "Timing is key",
              description:
                "Timing is everything in this fruit-cut game. For the fruit to be cut at the ideal time, you must precisely time your swipes. It's possible to miss the fruit or receive a lower score if you swipe too soon or too late. Up until you achieve perfection, keep improving your timing skills.",
            },
            {
              title: "Aim for combos",
              description:
                "Your score will increase greatly if you slice several fruits in a row to create a combo. Get the best possible combo score by slicing as many fruits as you can in a row without missing any.",
            },
            {
              title: "Beware of bombs",
              description:
                "Although it can be quite tempting to slice the game's bombs, doing so will cost you points. Focus on the fruits and avoid slicing the bombs.",
            },
            {
              title: "Use power-ups wisely",
              description:
                "Although they are few in number, the game's power-ups can be highly useful. To maximize their effectiveness, use them carefully. For example, when there are a lot of fruits on the screen, use the freeze power-up to make it easier to slice them all.",
            },
            {
              title: "Practice makes perfect",
              description:
                "The most crucial piece of advice is to never stop practicing. You will get better at the fruit chop game as you practice. Thus, keep trying till you reach your high score goal, and don't give up.",
            },
          ],
        },
      ],
      faq: [
        {
          question:
            "How can I improve my accuracy in the Fruit Cut game online?",
          answer:
            "To improve your accuracy in the FruitNinja game online, you need to focus on timing your swipes and aiming for the center of the fruit. Start with slicing one fruit at a time and gradually increase your speed and accuracy.",
        },
        {
          question: "What happens if I slice a bomb in the FruitNinja game?",
          answer:
            "If you slice a bomb in the Fruit Cut game, it will explode and end the game. Avoid slicing bombs at all costs to keep your score high and progress through the levels.",
        },
        {
          question: "What types of fruits can I slice in the FruitNinja game?",
          answer:
            "Fruit cut game offers a variety of fruits to slice, including watermelons, oranges, pineapples, and more. Each fruit has its own unique properties and can earn you different scores.",
        },
        {
          question:
            "How can I increase my score in the FruitNinja game online?",
          answer:
            "To increase your score in FruitNinja, aim for combos by slicing multiple fruits in a row without missing any. Use power-ups wisely to maximize your score, and avoid slicing bombs at all costs.",
        },
        {
          question:
            "Can I play FruitNinja online without an internet connection?",
          answer:
            "No, you can play the fruit slice game only online on the browser when there is an internet connection.",
        },
        {
          question: "Are there any time limits in FruitNinja?",
          answer:
            "Some game modes in FruitNinja have time limits, while others do not.",
        },
        {
          question: "How do I pause the game in FruitNinja?",
          answer:
            "To pause the game in FruitNinja, simply tap the Pause button in the top right corner of the screen.",
        },
        {
          question:
            "Is it possible to compete with other players in Fruit Cut?",
          answer:
            "Yes, you can compete with players from around the world in Fruit Cut by accessing the leaderboard. You can log in to your Facebook account to view the leaderboard and compare your score with other players.",
        },
        {
          question: "Is it possible to play Fruit Cut on my mobile device?",
          answer:
            "Yes, currently Fruit Cut is available only on Android devices.",
        },
        {
          question:
            "What are the different power-ups available in Fruit Cut, and how can I make use of them?",
          answer:
            "In Fruit Cut, power-ups such as Freeze Time, Double Points, and Bomb Defuser are available. When a power-up icon appears on the top right corner of the screen, you can activate it by tapping on it, and it will be effective for a limited time.",
        },
        {
          question: "What is the process to unlock new levels in Fruit Cut?",
          answer:
            "In Fruit Cut, you can unlock new levels by meeting the target score required for each level. As you progress through the levels, the target score will increase, and you will be able to unlock new levels by achieving the required score.",
        },
        {
          question: "How do I play the Fruit Cut game?",
          answer:
            "To play the Fruit Cut game, your task is to slice different types of fruits with a virtual knife. The objective is to slice as many fruits as possible while avoiding missing any or hitting bombs. You can slice the fruit by swiping your finger on the screen.",
        },
      ],
      systemRequirements: [
        {
          items: [
            "To ensure a smooth and enjoyable gaming experience, it is important to check the system requirements of your device before playing Chop'em All.",
            "Chop'em All can be played on Windows 7, Android 4.4, iOS 8 and higher versions. You can play it on browsers including Google Chrome, Safari, Opera, and Mozilla Firefox. Android WebView also supports it.",
            "It is important to note that these are the minimum system requirements and that higher specifications may be required for optimal performance.",
          ],
        },
      ],
    },
  },
  strike_balls: {
    details: {
      title: "Play Strike Ball Shooting Game Online",
      description: [
        "Are you looking for a fun and easy-to-play shooter game? Look no further than EpicPlay's Strike Balls! This game will transport you back to your childhood when you used to strike soda cans with balls with your friends. The gameplay is simple and intuitive, perfect for players of all ages to enjoy.",
        " Shooter games have been popular for years, offering immersive gameplay that requires strategic thinking, planning, and hand-eye coordination. Strike Balls are no exception. As you aim and shoot at the cans, think ahead to hit as many as possible and set the highest score.",
        " Whether you're a seasoned gamer or a beginner, you'll love the fast-paced action of Strike Balls. So why wait? Start striking those cans now!",
      ],
      gameData: [
        {
          title: "About - Free Strike Ball Shooter Game",
          description: [
            <>
              EpicPlay's Strike Balls game is an arcade{" "}
              <a href="https://www.epicplay.in/category/shooter-games">
                shooter game
              </a>{" "}
              that keeps anyone engaged for hours. This game is designed to
              provide an immersive gaming experience to players of all skill
              levels. The game is difficult and challenges players to overcome
              increasingly demanding obstacles. The immersive gameplay and
              increasing hardship keep everyone coming back for more. One of the
              key features of Strike Balls is its accessibility. Unlike many
              other ball games, you can play it on mobile or desktop browsers
              without downloading. This makes it easy for players to jump right
              into the action and start playing right away.
            </>,
            " In terms of gameplay, Strike Balls is a classic arcade shooter game. Players take control of the tennis and must shoot down waves of incoming juice cans. As the game progresses, the balls become faster and more difficult to hit, making it a true test of skill.",
          ],
        },
        {
          title: "Gameplay of Ball Shooting Game Online",
          description: [
            "To play the game, aim the tennis balls at the juice cans. Every can you knock off will earn you points. However, be careful not to hit the fire cans, as they will cause a blast and end the game.",
            " The sound of the tennis ball hitting the juice cans, the sight of the cans flying through the air, and the excitement make you rack up points and feel like you are right in the middle of the action. ",
            "The game starts easy, giving you a chance to practice your throw. But as you progress, the cans start arriving faster, and demand quick, precise aims. The challenge of aiming the ball at the cans as they fly through the air will keep you on your toes.",
            "If you are up for a game of fun and challenge that engages your senses, play Strike Balls. Get ready to experience the thrill of knocking down cans and racking up points!",
          ],
          image: {
            path: "/game-assets/game-images/strike-balls-game-online.jpg",
            alt: "Strike Ball Shooting Game Online",
            title: "Strike Ball Shooting Game Online",
            caption: "Strike Ball Shooting Game Online",
          },
        },

        {
          title: "How to Play & Rules - Strike Ball Game Online",
          subTitle: "How to play?",
          items: [
            "Striking the balls at the juice cans is super easy. If you are using a desktop, drag the mouse or the pointer from the balls to the cans. If you are playing from a mobile browser, drag your finger along the screen, aiming the balls at the cans to strike.",
            "Press and drag the ball when they can slowly start dropping down from the top to get the best strike. ",
            "Aim only at the colored cans since they fetch you points. ",
            "Avoid cans that are on fire since they are bombs disguised as cans and can end your game.",
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "The main rule is to not strike the fire cans since they are bombs disguised as cans and can end the game.",
            "The game automatically ends if you fail to strike 6 cans. The number of chances left can be seen on the right side of the screen.",
          ],
        },
        {
          title: "Tips and Tricks - Score High In Ball Shooting",
          items: [
            "Strike the ball when it falls since it is closer to the table at the time.",
            "Stay focused on the game since this game demands it.",
            "If you lose focus you might not score your highest.",
            "Avoid the fire cans since they can end thegame sooner.",
          ],
        },
      ],
      faq: [
        {
          question: "What is Strike Ball?",
          answer:
            "Strike Ball is an arcade shooter game where the player has to strike as many flying cans as possible with the balls.",
        },
        {
          question: "How do you play Strike Ball?",
          answer:
            "To play Strike Balls, aim the tennis balls at the juice cans. Knocking off a can will earn you points, but be careful not to hit the bomb cans, as they will cause a blast and end the game.",
        },
        {
          question: "How many levels are there in Strike Ball?",
          answer: "There are no higher levels in the strike ball game.",
        },
        {
          question: "Can you save your progress in Strike Ball?",
          answer:
            "Yes, the game captures your best score, and you can try beating it the next time.",
        },
        {
          question: "Is Strike Ball a multiplayer game?",
          answer: "No, strike ball is not a multiplayer game.",
        },
        {
          question: "Is Strike Ball a difficult game?",
          answer:
            "No, Strike Ball is a simple game with simple gameplay. Strike Ball is an arcade shooter game in which you strike as many flying cans as possible with the balls.",
        },
      ],
      systemRequirements: [
        {
          description:
            "To ensure a seamless gaming experience while playing Strike Balls on EpicPlay, it is essential to meet some basic device requirements. While the game has user-friendly controls, a high-performance device can enhance gameplay. Therefore, check if your device satisfies the following specifications for the best gaming experience.",
          items: [
            "Windows (64-bit) 7 or above",
            "Android 4.4 or above",
            "iOS 8 or above",
          ],
        },
      ],
    },
  },
  fusion_block: {
    details: {
      title: "Block Puzzle Game Online | Tetris Online Game",
      gameData: [
        {
          description: [
            "Block puzzle games are a genre of puzzle games that involve manipulating and fitting different-shaped blocks within a confined space. The objective is to create complete rows or columns of blocks, which then disappear, allowing for more blocks to fall into the play area. The gameplay mechanics often resemble traditional Tetris-style gameplay but with a focus on arranging blocks in a strategic manner. People love block puzzle games for several reasons:",
          ],
          items: [
            "The gameplay is simple and engaging.",
            "It involves strategic thinking, so it’s a good exercise for the brain.",
            "There is challenge and progression involved to keep you engaged.",
            "The gameplay is quick and casual.",
            "There are competitive and social elements in the game.",
            "It is good for relaxation and stress relief.",
          ],
        },
        {
          description: [
            "The history of block puzzle games dates back to 1984 when Tetris was developed by Alexey Pajitnov. The game involved fitting different-shaped blocks called tetrominoe into a playfield, clearing lines when they were completed. Tetris became a global phenomenon and inspired countless block puzzle games that followed.",
          ],
        },
        {
          title: "About - Fusion Blocks, Free Tetris 🕹️🧱🧩",
          description: [
            "Fusion Blocks is an engaging free block game introduced by EpicPlay. It is inspired by The age-old and popular Tetris game, however, the gameplay is slightly different and intuitive. The following factors make Fusion Blocks interesting to play.",
            "The gameplay runs on three things: Fit, Form, and Clear. You are given three different options of tiles that you must fit on the board to form straight lines vertically or horizontally. Once a straight line is formed, the tiles disappear, clearing the board and making more space for new tiles to be placed. You lose the game if you fill the board with tiles without clearing them.",
          ],
          items: [
            "The game has a challenging side that makes you want to progress more and faster.",
            "The pace of the game is as quick as you can play. So you will want to play more.",
            "The game’s colorful interface offers a bright and happy vibe, keeping you hooked to the game.",
            "It is meant for gamers of all levels and interests, so anybody can play it.",
          ],
        },
        {
          title: "Gameplay of Tetris Block Puzzle Online",
          description: [
            "The gameplay of Fusion Blocks is simple yet challenging. You must try to keep the board clear by continuously forming straight lines of the tiles. The longer you last in the game, the higher you score. Additionally, there are three modes in the game.",
          ],
        },
        {
          subTitle: "Classic Mode",
          description:
            " This is a simple process. You are provided with three options of tiles with each move. You must place the tiles to form a straight line and clear the board.",
        },
        {
          subTitle: "Time Mode",
          description:
            " This is similar to the Classic Mode but comes with a timer. The timer keeps revising as you build and clear new straight lines. If you fail to clear the board from time to time, the timer exhausts and you lose.",
        },
        {
          subTitle: "Advance Mode",
          description:
            " In the Advance Mode, you are provided with three options of tiles, which can even be rotated horizontally and vertically. The advantage is that the customization helps you fit the tiles faster and clear the board easily.",
        },
        {
          image: {
            path: "/game-assets/game-images/tetris-block-puzzle-game-online.jpg",
            alt: "Fusion Blocks: Tetris Game Online",
            title: "Fusion Blocks: Tetris Game Online",
            caption: "Fusion Blocks: Tetris Game Online",
          },
        },
        {
          title: "How to play & Rules - Free Tetris for PC & Mobile",
          subTitle: "How to play",
          items: [
            "Open the Fusion Blocks block puzzle game.",
            "Click the Play button on screen.",
            {
              description: "Choose one of the three modes:",
              subItems: [
                "Classic Mode, where the gameplay is simple and straightforward. You must fit the tiles to form a straight line and clear the board. If you fail to do so, you lose.",
                "Time Mode, where you must mind a timer that is ticking and play as much as you can while it is active. If you fail to clear the board while it is active, you lose.",
                "Advance Mode, where you can rotate the tiles to fit them as needed on the board and play without a timer.",
              ],
            },
            "After choosing a mode, the game starts.",
            "Pick a tile from the option of 3 tiles.",
            "Drag it and place it on the board so as to form a straight line vertically or horizontally.",
            "Forming a straight line will clear that line on the board to make space for new tiles.",
            "Continue to clear the board to play longer.",
            "If you fill the board, you lose.",
          ],
        },
        {
          subTitle: "Mobile Controls",
          noTag: true,
          items: [
            "Drag and drop tiles by tapping them.",
            "Tap and hold a tile to rotate it in the Advance Mode.",
          ],
        },
        {
          subTitle: "Desktop Controls",
          noTag: true,
          items: [
            "Tap on a tile using the touchpad or click on it to hold it.",
            "Drag and drop the tile to place it on the board.",
            "Tap on a tile or click on it to rotate it in the Advance Mode.",
          ],
        },
        {
          subTitle: "Rules",
          description:
            "Although there are no set rules for the game, here are some things you must take care of:",
          items: [
            "Plan your moves carefully.",
            "Study the board and the tiles before you decide to place them.",
            "Avoid leaving gaps on the board because it may be problematic in clearing the board.",
          ],
        },
        {
          title: "Tips and Tricks - Score High In Fusion Blocks",
          description:
            "Block puzzle games are simple to play but even require some strategy to score high. Below are some tips and tricks to get a high score in Fusion Blocks.",
        },
        {
          subTitle: "Tips",
          items: [
            {
              title: "Plan ahead",
              description:
                " Try to anticipate the shape of the upcoming tile and plan where you want to place it. Think about how it will fit with the existing blocks and create opportunities for clearing lines.",
            },
            {
              title: "Keep the field tidy",
              description:
                " Aim to keep your playfield as clean as possible by avoiding gaps and uneven stacks. A clean playfield allows for easier line clears and provides more flexibility in placing Tetriminos.",
            },
            {
              title: "Prioritize clearing lines",
              description:
                " Clearing lines should be your main focus. Aim to create complete horizontal or vertical lines whenever possible to prevent filling the board.",
            },
            {
              title: "Master the T-Spin",
              description:
                " A T-Spin is a special move that involves rotating a T-shaped Tetrimino into a tight space to create a line clear. Learning and practicing T-Spins can significantly boost your score and open up new possibilities for clearing lines.",
            },
            {
              title: "Maintain a flat surface",
              description:
                " Avoid building uneven stacks that leave gaps between blocks. A flat surface makes it easier to place Tetriminos and reduces the chances of creating difficult-to-fill holes.",
            },
            {
              title: "Learn from others",
              description:
                " Watch videos of skilled players or participate in online communities to learn new strategies and techniques. Observing experienced players can give you insights into advanced moves and creative solutions.",
            },
            {
              title: "Play regularly",
              description:
                " Like any skill, consistent practice is essential to improving your Tetris abilities. Regularly playing Fusion Blocks will help you familiarize yourself with different Tetrimino shapes, improve your decision-making, and enhance your overall gameplay.",
            },
          ],
        },
        {
          subTitle: "Tricks",
          items: [
            "Look for opportunities to create vertical gaps and fill them with I-shaped Tetriminos to achieve Tetrises whenever possible.",
            "Aim to create consecutive line clears without gaps in between. ",
            "Whenever possible, try to clear more than one line at a time. Look for opportunities to place tiles that will complete two or three lines simultaneously. ",
            "Use the Rotate option in the Advance mode to place tiles accurately and clear the lines quickly. ",
            "Like any skill, practice is key. Regularly playing Fusion Blocks will help you improve your reflexes, decision-making, and overall gameplay.",
          ],
        },
      ],
      faq: [
        {
          question: "How do I play Tetris online?",
          answer:
            "There are many ways to play Tetris online. One of them is on the EpicPlay website, which offers a wide variety of free online games, including Tetris.",
        },
        {
          question: "Is Fusion Blocks - online Tetris free to play?",
          answer:
            "Yes. Fusion Blocks - online Tetris is free to play and involves no paying or downloads.",
        },
        {
          question:
            "Are there different variations of Tetris available online?",
          answer:
            "Yes. Fusion Blocks, Tetris Friends, Jstris, Tetris Online Poland (TOP), Cultris II, NullpoMino, and Tetris Battle are some variations of the Tetris game online.",
        },
        {
          question: "Can I save my progress in online Tetris games?",
          answer:
            "Some game developers allow you to save your progress and some don’t. It depends on which variation you choose to play.",
        },
        {
          question:
            "Are there leaderboards in Fusion Blocks online Tetris games?",
          answer:
            "The information about leaderboards in Fusion Blocks is not provided in the document.",
        },
        {
          question: "Can I play Fusion Blocks - Tetris game on mobile devices?",
          answer:
            "Yes. You can open the game on your mobile browsers and play easily.",
        },
      ],
      systemRequirements: [
        {
          description: [
            "To ensure a seamless gaming experience while playing Fusion Blocks on EpicPlay, it is essential to meet some basic device requirements. While the game has user-friendly controls, a high-performance device can enhance gameplay. Therefore, check if your device satisfies the following specifications for the best gaming experience.",
            "However, it is recommended to have a stable internet connection for smooth gameplay. Overall, the system requirements for Fusion Blocks are very minimal and should be compatible with most devices.",
          ],
        },
      ],
    },
  },
  high_tower: {
    details: {
      title: "High Tower Game - Bounce & Climb Tower Game",
      gameData: [
        {
          description: [
            "Welcome to the exciting world of High Tower Game, the ultimate Bounce & Climb Tower Game! It's a game where you jump and bounce your way up a big tower. It's really exciting and lots of people love playing games like this.",
            "Jump games and bounce games are great because they're a way to have fun and pass the time. Not only that but they are also easy to play. If you want to relax or need a break, High Tower Game is perfect for that!",
            "In High Tower Game, you get to climb a super tall tower with lots of things in your way. You have to be careful and time your jumps just right to keep going up. The more platforms you bounce on, the higher you go!",
            "So, don't wait any longer! Get ready to start jumping and bouncing to reach the top! It’s super fun and you'll love it.",
          ],
        },
        {
          title: "About - High Tower Jump Game 🏢🚧🌳🗼",
          description: [
            "High Tower Game created by EpicPlay has captured the hearts of players worldwide. They have specially designed it for people who love jump games that test their skills and concentration.",
            "High Tower Jump Game is all about jumping to new heights. It's a game that challenges your ability to focus and make precise jumps. In this game, your goal is to jump as high as you can. You'll encounter various obstacles along the way that you need to jump onto. But be careful! Timing is crucial. You have to concentrate and make your jumps at just the right moment to keep climbing.",
            "If you're up for the challenge, get ready to dive into the world of the High Tower Jump Game!",
          ],
        },
        {
          title: "Gameplay - High Tower Bounce Game Online",
          description:
            "In this jumping game, you'll experience exciting gameplay through towers filled with various levels. Let's take a look at how to play the game.",
          image: {
            path: "/game-assets/game-images/high-tower-bounce-game-online.jpg",
            alt: "High Tower: Jump Game Online",
            title: "High Tower: Jump Game Online",
            caption: "High Tower: Jump Game Online",
          },
          items: [
            {
              title: "Start the Game",
              description:
                "Tap on the screen to begin playing High Tower Game.",
            },
            {
              title: "Climbing the Tower",
              description:
                "Tap repeatedly on the screen to make your character climb up the tower's different levels.",
            },
            {
              title: "Closed Floors",
              description:
                "Some levels have closed floors. This means there is a ceiling above you. Bounce off the platforms to reach higher levels.",
            },
            {
              title: "Closed-Ended Floors",
              description:
                "On certain levels, you'll encounter closed-ended floors. These floors have walls on the side. Time your jumps carefully to pass through without hitting the walls.",
            },
            {
              title: "Open-Ended Floors",
              description:
                "These floors don't have walls on the sides, so you must be cautious not to fall off the edges. Maintain control and stay centered while jumping.",
            },
            {
              title: "Avoid Obstacles",
              description:
                "Throughout the game, you'll encounter trees, flags, stones, and various objects on the tower. Jump at the right time and balance your character to avoid colliding with these obstacles.",
            },
          ],
        },
        {
          title: "How to Play & Rules - Jump & Bounce Tower Game",
          subTitle: "How to Play",
          items: [
            {
              title: "Desktop",
              description:
                "Use the spacebar key on your keyboard or left-click the mouse to jump and reach new levels of the tower.",
            },
            {
              title: "Mobile",
              description:
                "On your mobile device, tap the screen to make your character jump and progress through the tower.",
            },
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "The aim is to climb up the tower by jumping and bouncing off the platforms successfully.",
            "Pay attention to where your character is and the heights of the platforms. Time your jumps accurately.",
            "Don't hit trees, flags, stones, or other objects on the tower.",
            "The game continues as long as you navigate the platforms without hitting obstacles or falling off the tower.",
            "Keep jumping, bouncing, and avoiding obstacles to climb higher and advance through each level.",
          ],
        },
        {
          title: "Tips and Tricks - Jumping on High Tower Game",
          subTitle: "Tips",
          items: [
            "Pay attention to the upcoming floors before making your jump. It helps to plan your moves and time your jumps accurately.",
            "Take your time and don't rush your jumps. Wait for the right moment to jump, ensuring you land on the platforms accurately.",
            "Pay attention to your character's balance while jumping.",
            "To keep climbing the tower, focus on consistently jumping and bouncing off the platforms.",
          ],
        },
        {
          subTitle: "Tricks",
          items: [
            "Practice the double bounce technique by tapping or pressing the jump button twice quickly.",
            "Memorize the pattern of specific levels or challenging sections.",
            "Take advantage of consecutive floors with open ends. Jump quickly between these floors to maintain momentum.",
          ],
        },
      ],
      faq: [
        {
          question: "What is the High Tower Jump game?",
          answer:
            "The High Tower Jump game is an exciting game where you climb a tower by jumping and bouncing off platforms.",
        },
        {
          question: "How do I play the High Tower Jump game?",
          answer:
            "To play the High Tower Jump game, tap on the screen to jump. Keep tapping to maintain upward momentum and avoid obstacles.",
        },
        {
          question: "Are there different levels or stages in the Jump Game?",
          answer:
            "Yes, the High Tower game has different levels or stages. Each level presents new challenges and obstacles as you climb higher.",
        },
        {
          question: "Can I compete with other players in the High Tower game?",
          answer:
            "Currently, the High Tower game does not have a multiplayer or competitive mode. You can play individually and aim to achieve your personal best score.",
        },
        {
          question:
            "How can I improve my jumping skills in the High Tower game?",
          answer:
            "To improve your jumping skills, practice timing your jumps accurately and use strategies like double bounce where applicable.",
        },
      ],
      systemRequirements: [
        {
          description:
            "The High Tower Jump Game is designed to be accessible and enjoyable on a variety of devices. Here are the basic system requirements to ensure a smooth gaming experience:",
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 5.0 or higher",
            "iOS 8.0 or higher",
          ],
        },
        {
          description:
            "By meeting these system requirements, you can easily play the High Tower Jump Game on your preferred device and dive into the thrilling world of jumping and climbing towers.",
        },
      ],
    },
  },
  flying_bird: {
    details: {
      title: "Flying Bird: Free Epic Flappy Bird Game Online Play Now",
      gameData: [
        {
          description: [
            "Are you looking for a simple, yet challenging tapping game that will keep you entertained for hours? Step into the exciting realm of the Flappy Bird game online! It is a classic tapping game that has topped the charts.",
            "In this game, you control a small bird attempting to fly through a series of pipes without crashing. Sounds easy, right? Well, think again. The pipes are positioned at different heights in a strategic manner, and it might be challenging to control the flying bird's movement. If you make a mistake, your bird will crash, resulting in the game's end.",
            "But don't worry, the Flying Bird Game is a great way to relax and have fun. This Flying Bird game online is a great way to keep you entertained when waiting for a bus, taking a break from work, or merely looking to pass the time. So, be ready to enjoy the thrill of the Flappy Bird online world!",
          ],
        },
        {
          title: "About - Flying Bird Online Game",
          description: [
            "You can have fun playing the Flying Bird online game at any time and from anywhere. It's a straightforward but engaging game that everyone with any level of skill can play.",
            "To help you get started with the Flappy Bird arcade game, we've compiled a comprehensive list of key terms. Let’s go!",
          ],
          items: [
            {
              title: "Pipes",
              description:
                "These are the slate-gray pipes that the bird must fly through to earn points.",
            },
            {
              title: "Flap",
              description:
                "This is the action of tapping the screen to make the bird flap its wings and fly higher or lower.",
            },
            {
              title: "High score",
              description: "A player's highest score in the game.",
            },
            {
              title: "Medal",
              description:
                "This is a prize given to players who reach a particular score or level.",
            },
            {
              title: "Game Over",
              description:
                "The game is over when the bird collides with a pipe",
            },
          ],
        },
        {
          description:
            "Here are a few reasons why you should consider playing the Flappy Bird game online:",
          items: [
            "Straightforward and engaging gameplay that is simple to learn but difficult to master.",
            "Aids in increasing reflexes and hand-eye coordination.",
            "Suitable for quick gaming sessions, and accessible anytime, anyplace through desktop or mobile browsers.",
            "Satisfying and enjoyable experience that is appropriate for gamers of all skill levels.",
          ],
        },
        {
          title: "Gameplay - Flappy Bird Game On Phone",
          description: [
            "In the universe of the Flappy Bird game online, your main purpose is to fly as far as possible without colliding with the slate-gray pipes. By flapping its wings, you must direct the yellow bird as it flies through pipes,  as you focus on getting the highest score by passing as many pipes as you can without touching or crashing into them. If you stop tapping, the bird falls to the ground, and the game is over. The pipes are positioned at different heights, and you need to time your taps correctly to make the bird pass through the gaps in the pipes.",
            "As you play Flappy Bird online, the difficulty level rises as the pipes become closer in proximity and at more difficult angles. But if you start out struggling, don't worry; you'll improve as you play it more.",
          ],
        },
        {
          image: {
            path: "/game-assets/game-images/flying-bird-game-online.jpg",
            alt: "Flappy Bird Game Online",
            title: "Flappy Bird Game Online",
            caption: "Flappy Bird Game Online",
          },
        },
        {
          title: "How to Play & Rules - Flappy Bird Free Online",
          description:
            "Here's everything you need to know to become a Flappy Bird arcade game expert and emerge victoriously!",
        },
        {
          subTitle: "Controls",
          description:
            "Flappy Bird game online controls are generally similar across devices, although the way of play may differ depending on the device. Here's how you can play Flappy Bird game on different devices:",
          items: [
            {
              title: "Mobile Devices",
              description:
                "Control the bird's movement by tapping the screen with your fingers. Each tap makes the bird flap its wings and fly upward. If you stop tapping, the bird falls to the ground. Tapping fast makes the bird move up faster.",
            },
            {
              title: "Desktop",
              description:
                "To flap the bird, use the keyboard. Press the spacebar to make the bird flap its wings and fly upward. The bird drops to the ground when you let go of the key. You can even tap on the touchpad on a laptop for upward movement.",
            },
          ],
        },
        {
          subTitle: "How to Play Flying Bird Game",
          description:
            "A step-by-step instruction for playing the Flying Bird online game is provided below:",
          items: [
            {
              title: "Open the game",
              description:
                "Start the Flying Bird online game on your device of choice.",
            },
            {
              title: "Control the bird's movement",
              description:
                "If you're playing on a mobile device, tap the screen to move the bird, or press the spacebar to move the bird on a desktop. The bird's wings flap and it flies upward with each tap.The bird drops to the ground if you stop tapping.",
            },
            {
              title: "Make your way through the pipes",
              description:
                "Your mission is to guide the bird through a series of pipes that are positioned at various heights.Crashing the bird into the pipe will end the game.",
            },
          ],
        },
        {
          subTitle: "Rules for Flappy Bird on Browser",
          description:
            "To conquer the Flappy Bird game online, remember these essential rules:",
          items: [
            "Avoid touching any pipes as you cross them. The game ends if the bird contacts a pipe, and you have to restart it from the beginning.",
            "As long as you can prevent the bird from contacting any pipes, the game will continue.",
            "To earn a high score, you must focus on passing through as many pipes as possible.",
          ],
        },
        {
          title: "Tips And Tricks For Playing Flappy Bird Game Online",
          description:
            "Here are some tips and tricks to play the Flappy Bird game online better and score higher.",
        },
        {
          subTitle: "Tips",
          items: [
            "Avoid tapping too hard as this can cause the bird to fly too high or drop too quickly.",
            "Time your taps properly to ensure that the bird is at the right height to pass through the gaps in the pipes. Don't tap too early or too late.",
            "Avoid tapping too frequently, as this can cause the flying bird game to lose control.",
            "Stay focused on the Flappy Bird game online and avoid distractions. Concentrate on the bird and the pipes to improve your performance.",
            "Practice regularly to improve your timing and control of the bird. The more you play, the better you'll get.",
            "Stepping away from the game for a few minutes can help you regain your focus.",
          ],
        },
        {
          subTitle: "Tricks",
          items: [
            "Try to maintain a consistent rhythm when tapping the screen. This will help you control the bird and avoid sudden drops or jumps.",
            "Stay low to the ground whenever possible. The lower you fly, the easier it is to control the bird and avoid hitting the pipes.",
            "Memorize the pattern of the pipes and the timing of the gaps between them. This will help you anticipate when to tap and when to stay still.",
            "Focus on the space between the pipes rather than the pipes themselves. This will help you more accurately gauge the distance between them and avoid hitting them.",
            "Use the bird's momentum to your advantage. If the bird is flying upward, wait until it starts to descend before tapping again. This will help you maintain control and avoid hitting the pipes.",
          ],
        },
      ],
      faq: [
        {
          question: "What is Flappy Bird?",
          answer:
            "Flappy Bird is a game where the user tries to control a bird by tapping the screen to help it fly through a series of pipes without colliding with any of them.",
        },
        {
          question: "Is the Flappy Bird game still available to play online?",
          answer:
            "Yes, the flappy bird game is available to play online on mobile and desktop.",
        },
        {
          question: "How do I control the bird in the Flappy Bird game online?",
          answer:
            "To control the bird in the Flappy Bird game online, tap the screen to make it flap its wings and fly upward. Release your finger to make it descend. The goal is to navigate the bird through a series of pipes without hitting them.",
        },
        {
          question: "Is Flappy Bird a free game to play?",
          answer: "Yes, you can play the flappy bird game for free.",
        },
        {
          question:
            "What is the highest score achieved in the Flappy Bird game?",
          answer:
            "The highest score achieved in the Flappy Bird game is 9813 points by a user called Eli Duke.",
        },
        {
          question: "Are there any cheats or hacks available for Flappy Bird?",
          answer:
            "Although there might be cheats or hacks accessible, using them is not advised. Cheating or hacking can ruin the gameplay experience and is not in the spirit of fair competition. You can use our tips and tricks to ace the game.",
        },
        {
          question:
            "Are there any age restrictions or content warnings for Flapping Bird?",
          answer:
            "Flapping Bird does not have any age restrictions or content warnings.",
        },
        {
          question:
            "Is there a time limit on Flapping Bird, or can I play for as long as I want?",
          answer:
            "There is no time restriction on how long you can play Flapping Bird, so feel free to play for as long as you wish.",
        },
        {
          question:
            "Are there any power-ups or bonuses in the Flappy Bird game online?",
          answer:
            "No, there are no power-ups or bonuses in the Flappy Bird game online that can help you score higher.",
        },
      ],
      systemRequirements: [
        {
          description: [
            "It is advised to check your device's system requirements before playing a flying bird game online to ensure a smooth and satisfying experience.",
            "Playing Flappy Bird game online is possible on a number of devices and online browsers, including Google Chrome, Safari, Opera, and Mozilla Firefox. Also, it is compatible with portable Android 4.4, iOS 8, and higher versions, and can be accessed by Android WebView.",
          ],
        },
      ],
    },
  },
  runout_champ: {
    details: {
      title: "Runout Champ Game - Run Out Cricket Game",
      gameData: [
        {
          description: [
            'Cricket games are all about the sport we love. They offer a thrilling experience of being on the field, where you can enjoy hitting sixes, taking wickets, and making amazing catches. However, for those who relish the tactical challenge of runouts, there\'s something special just for you – introducing "Runout Champ: Run Out Cricket Game".',
            "For cricket enthusiasts, the Runout Champ game will leave you thrilled and keep you on the edge of your seat! This game is all about those adrenaline-pumping moments when a batsman runs for a quick single, and you have to hit the stumps to get them out.",
            "One popular format of cricket games that people enjoy playing is called Howzat. In this game, you get to play as your favorite cricket team and players, batting, bowling, and fielding just like in a real match. It's like experiencing the cricket stadium in the comfort of your house.",
            "So, if you're a die-hard cricket fan and want to experience the excitement of making crucial runouts, Runout Champ is the game for you!",
          ],
        },
        {
          title: "About - Batsman Run Out Game",
          description: [
            "EpicPlay has developed the Runout Champ game to let you experience playing cricket in real. In this game, your mission is to run out the batsman before they score runs. The batsman will try to take quick singles. You have to be quick and accurate to hit the stumps before they cross the crease.",
            "The game is designed with different challenges to test your skills. You'll face various scenarios like direct hits from the outfield or stumpings behind the wickets. Each challenge will put your reflexes and precision to the test, just like in a real cricket match!",
            "So, if you're eager to sharpen your cricketing abilities and have a blast while doing it, don't wait any longer!",
          ],
        },
        {
          title: "Gameplay - Runout Champ",
          image: {
            path: "/game-assets/game-images/runout-champ-online-cricket-game.jpg",
            alt: "RunOut Champ: Cricket Game Online",
            title: "RunOut Champ: Cricket Game Online",
            caption: "RunOut Champ: Cricket Game Online",
          },
        },
        {
          description:
            "To help you understand the game better, let’s dive into the gameplay and see what different modes this game has:",
          numberItems: [
            {
              subTitle: "Starting the Game",
              description:
                "As you launch Runout Champ, you'll see a tap to start the game and different modes you can select from on the home screen. ",
            },
            {
              subTitle: "Choosing the Mode",
              description:
                "Next, you'll have the option to choose your game mode. There are three modes to select from:",
              subItems: [
                {
                  title: "Normal Mode",
                  description:
                    "In this mode, you'll face regular batsmen trying to take quick runs. Your task is to run them out before they reach the crease!",
                },
                {
                  title: "Golden Wicket Mode",
                  description:
                    "In this mode, Instead of 3 stumps, there will only be only one wicket stump you need to hit. You must aim for the stumps with precision to earn golden wickets!",
                },
                {
                  title: "Time Stumps Mode",
                  description:
                    "In Time Stumps Mode, you're up against the clock! At the start, you’ll have 10 seconds. With each hit, you’ll get an extra 1 second. Run out as many batsmen as possible within the given time limit.",
                },
              ],
            },
            {
              subTitle: "Three Chances to Hit the Stumps",
              description: [
                "Once you've chosen a mode, the real challenge begins! You'll have three chances to throw the ball and hit the stumps. This is only available in the normal and golden wicket modes.",
                "Every successful runout will earn you points.",
              ],
            },
            {
              subTitle: "Game Over",
              description:
                "Remember, if you miss hitting the stumps three times, the game will be over.",
            },
          ],
        },
        {
          title: "How to play & Rules - Run Out Cricket Game",
          description:
            'Let\'s first discuss how to play the "Runout Cricket Game":',
        },
        {
          subTitle: "How to play",
          items: [
            {
              title: "Desktop",
              description:
                "To aim, simply move the mouse cursor to your desired position and flick it to throw the ball toward the stumps.",
            },
            {
              title: "Mobile",
              description:
                "On your mobile, just touch and drag your finger to your desired position and flick it to throw the ball toward the stumps.",
            },
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "Your goal is to run out the batsman by hitting the stumps before they cross the crease.",
            "You have three chances to throw the ball and hit the stumps.",
            "Each successful runout will earn you points.",
            "Missing the stumps three times will result in a game over.",
          ],
        },
        {
          title: "Tips and Tricks - Score High in Run Out Game",
          description:
            "Let's begin with the tips and then move on to the tricks:",
        },
        {
          subTitle: "Tips",
          items: [
            "Aim for the stumps by placing the cursor/finger slightly ahead of the batsman's running path.",
            "Consecutive wickets earn bonus points",
            "Keep an eye on the timer to ensure you dismiss the batsman before they reach the crease.",
            "Keep an eye on the timer but avoid rushing.",
          ],
        },
        {
          subTitle: "Tricks",
          items: [
            "Practice throwing the ball from various angles to increase your chances of hitting the stumps.",
            "Master the side angle technique to run out batsmen when only a single stump is visible.",
            "Adjust your throw angles according to the wind speed to ensure the ball hits the stumps accurately.",
            "Train yourself to make quick decisions on when to throw the ball.",
          ],
        },
      ],
      faq: [
        {
          question: "What is a Run out Game?",
          answer:
            "Run Out Game is an exciting cricket game where you aim to run out batsmen by hitting the stumps before they cross the crease.",
        },
        {
          question:
            "What are some common mistakes players make when trying to run out a batsman?",
          answer:
            "Some common mistakes include throwing too early or too late, aiming inaccurately, and panicking under pressure.",
        },
        {
          question: "How can I improve my chances of running out of a batsman?",
          answer:
            "Improve your aim, practice quick throws, and anticipate the batsman's movements to increase your chances of successful runouts.",
        },
        {
          question: "What are some tips for fielding in run-out situations?",
          answer:
            "Stay alert, position yourself well, and be ready to throw quickly. Aim for direct hits and keep the batsman under pressure.",
        },
        {
          question: "What are some common run-out scenarios?",
          answer:
            "Common scenarios include quick singles, run-outs from fielding positions, and close calls at the non-striker's end.",
        },
        {
          question: "How do I play the Run Out Game?",
          answer:
            "Darg the mouse cursor or swipe the screen to aim and throw the ball at the stumps.",
        },
        {
          question: "How can I compete with my friends in the Run Out Game?",
          answer:
            "You can share your scores and challenge your friends to beat your high score.",
        },
        {
          question: "Are there different game modes in Run Out Game?",
          answer:
            "Yes, there are different modes like Normal, Golden Wicket, and Time Stumps. Each mode offers unique challenges.",
        },
        {
          question:
            "How can I report a bug or provide feedback for Run Out Game?",
          answer:
            "For bug reports or feedback, use the in-game feedback option or contact the support team through the game's website.       ",
        },
      ],
      systemRequirements: [
        {
          description:
            "Run Out Champ is an exciting cricket game that can be enjoyed on multiple platforms. Here are the basic system requirements for playing Run Out Champ:",
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 4.4 or higher",
            "iOS 8 or higher",
          ],
        },
        {
          description:
            "Please note that these are the minimum requirements, and the game may run on devices that meet or exceed these specifications. Get ready to experience the thrill of running out batsmen on your favorite device!",
        },
      ],
    },
  },
  ludo_matka: {
    details: {
      title: "Play Ludo Game Online with Friends",
      gameData: [
        {
          description: [
            "Playing the Ludo game online with friends can be a pleasant and exciting way to entertain yourself. Start playing ludo, a timeless board game played for decades by players of all ages. Ludo with friends worldwide is now more convenient than ever with the development of online gaming.",
            "Ludo is a game of luck and strategy that involves moving your pawns around the board and trying to get them to the finish line before your opponents. It's a game that's easy to learn but can take a lifetime to master, making it an excellent choice for casual and competitive players.",
            "Many websites and apps allow you to play ludo online with friends. Create a game, invite your friends to join, and you're ready to start rolling the dice and making your moves. Many online Ludo games also offer different variations and rules to keep things interesting, so you can switch things up and try something new.",
          ],
        },
        {
          title: "About - Free Classic Ludo Game",
          description: [
            "Free Classic Ludo Game is an online version of the popular board game ludo, which can be played for free on various websites and mobile apps. The game follows the same rules as the traditional Ludo game, where each player has four pawns that they must move around the board by rolling dice.",
            "The game's goal is to be the first player to move all four of your pawns from the starting point to the finish line. Players take turns rolling the dice and moving their pawns accordingly, trying to avoid being knocked off the board by their opponents.",
          ],
        },
        {
          description: (
            <>
              Ludo Matka is an online version of the popular board game ludo,
              which has become increasingly popular recently. Players move their
              pawns around the board and roll dice like in <b>ludo classic</b>{" "}
              game to cross the finish line first. Some features of Ludo Matka
              are below:
            </>
          ),
          items: [
            "It is entirely free to play, meaning anyone can join in the fun spending any money.",
            "Players can earn virtual coins by winning games or completing various challenges. These coins can be used to purchase new dice designs, board themes, and other customizations to make your playing experience more personalized and enjoyable.",
            "Ludo Matka also provides various game modes, including single-player, multiplayer, and online multiplayer. Players can play against computer-controlled opponents, friends on the same device, or other players worldwide.",
            "It is available in solo (with computer), online multiplayer, and play-with-friends modes. Furthermore, online multiplayer and play-with-friends modes have two options: Quick and Classic, two-player and four-player.",
          ],
        },
        {
          title: "Gameplay of 2 Player Ludo Game",
          description: [
            "Two player Ludo game follows the same rules as traditional ludo, with each player having two sets of colored pawns that they move around the board by rolling dice. In order to win, a player must be the first to move all of their pawns from the starting point to the finish line. The player with the highest number on their dice gets to go first and roll again to determine how many blocks they can move. Then, each player rolls a die and alternately moves one of their pawns anticlockwise across the board.",
            "Participants must move exactly the number of squares shown on the dice and can only move their pawns in a clockwise orientation. The opponent's pawn is knocked off the board and must start again from scratch if a player lands on the spot already occupied by their opponent's pawn. Players must move their pawns from the starting point to the finish line by reaching the designated end blocks for each color. Once a player's pawns have reached the finish line, that player is declared the winner.",
            "Two-player Ludo game can be played in various modes, including online multiplayer, where players can compete against friends or other players worldwide. Overall, this game is a fun and competitive way to enjoy the classic board game with a friend or family member.",
          ],
          image: {
            path: "/game-assets/game-images/ludo-matka-game-screenshots.jpg",
            alt: "2 player Ludo matka",
            title: "2 player Ludo matka",
            caption: "2 player Ludo matka",
          },
        },
        {
          title: "How to play & Rules - Multiplayer Ludo Online",
          description: (
            <>
              <b>Multiplayer ludo online</b> is a virtual version of the classic
              board game that can be played with multiple players online. The
              game follows the same rules as traditional ludo, with players
              moving their pawns around the board by rolling the dice and trying
              to reach the finish line before their opponents.
            </>
          ),
        },
        {
          subTitle: "Controls",
          description: (
            <>
              In <b>multiplayer ludo online</b>, players use simple controls to
              move their pawns around the board. The dice can be rolled by
              clicking on the dice on the bottom left. Once the die has rolled,
              players can select the pawn they want to move by clicking or
              tapping on it.
            </>
          ),
        },
        {
          description: [
            "Players can click on the block they want to move the selected pawn. The pawn will automatically move the correct number of blocks based on the number shown on the dice. If a player rolls a six, they get to roll again and take an additional turn.",
            "For mobile devices, players can 'tap' functionality to play the game.",
          ],
        },
        {
          subTitle: "How to play",
          description:
            "The dice numbers are used to move your pawns around the board in ludo. Here's how you can use the dice numbers:",
          items: [
            {
              title: "Roll the dice",
              description:
                "To begin your turn, roll the dice by clicking or tapping on the dice at the bottom. You can move your pawn by so many steps depending on the number on the dice.",
            },
            {
              title: "Choose a pawn",
              description:
                "After rolling the dice, choose a pawn to move. You can choose one by clicking or tapping on it.",
            },
            {
              title: "Move the pawn",
              description:
                "Once you've selected a pawn, you can move the number of blocks indicated by the dice. Wherever you wish to move the pawn, press or push down on the area. The pawn will automatically move to the selected block.",
            },
            {
              title: "Knocking off opponent",
              description:
                "You can knock off an opponent pawn by advancing to the block where it is placed.",
            },
            {
              title: "Win the game",
              description:
                "Ludo aims to get your pawns to the end zone before your rivals do. You win the game once you've gotten every pawn to the goal.",
            },
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "To begin the game, each player selects a color and takes four pawns of that color.",
            "Then, each player has a turn rolling the dice to see how many blocks they can move their pawns.",
            "Players must move their pawns in a clockwise direction and move the exact number of blocks shown on the dice.",
            "If a player rolls a six, they are given another roll and an additional turn.",
            "If a player's pawn lands on a block already occupied by an opponent's pawn, the opponent's pawn is knocked off the board and must start over from the beginning.",
          ],
        },
        {
          description: [
            <>
              <b>Multiplayer ludo online</b> offers several variations and
              customizable rules to keep things interesting. For example,
              players can choose to play with different numbers of pawns or
              change the number of rolls allowed per turn. The game also offers
              different board designs and themes to personalize the playing
              experience.
            </>,
            <>
              Players can create a game and invite friends or other players to
              join to play <b>multiplayer ludo online</b> in real time. If you
              leave a multiplayer game mid-way, the die rolls automatically and
              pawn moves depending on the die's number, to prevent the gameplay
              from being affected.
            </>,
          ],
        },
        {
          title: "Tips and Tricks - Win Ludo Game",
          description:
            "Knowing when to open your pawns in ludo can be crucial in winning the game. Here are some tips to keep in mind:",
          items: [
            {
              title: "Consider the board layout",
              description:
                "Before opening your pawns, look at the board and consider where your opponents' pawns are located. If their pawns are positioned to knock out your pawns easily, it may be better to wait before opening them.",
            },
            {
              title: "Use sixes wisely",
              description:
                "Rolling a six is an excellent opportunity to open your pawns, but save it by opening a non-strategically positioned pawn. Alternatively, open a pawn in a fantastic position to advance toward the finish line using the six.",
            },
            {
              title: "Prioritize your pawns",
              description:
                "If you have multiple pawns, prioritize opening the pawns in the best position to move towards the finish line. If you do this, you'll have the highest chance of winning the game.",
            },
          ],
        },
        {
          description:
            "Creating a strategy in ludo can be the key to winning the game. Here are some tricks to help you create a winning strategy:",
          items: [
            "Focus on moving your pawns towards the finish line. Your primary objective should be to move your pawns towards the finish line. Focus on opening pawns closest to the finish line and prioritize moving them.",
            "Only move some of your pawns at once. Moving them at once may seem like a good idea, but it can leave them vulnerable to attack. Instead, move your pawns strategically, one at a time, to avoid losing them.",
            "Use your pawns to obstruct opponents and slow them down. This can give you an edge and enable you to move your pawns closer to the goal.",
            "Pay attention to your opponent's moves. Keep an eye on your opponent's moves and adjust your strategy accordingly. If they get too close to the finish line, use your pawns to obstruct or knock them off the board.",
            "Use your dice rolls wisely. Your dice rolls can be used strategically to move your pawns closer to the finish line or to block your opponents. Make good use of them and plan.",
          ],
        },
      ],
      faq: [
        {
          question: "What is Ludo?",
          answer:
            "Ludo is a classic board game where you must be the first player to move all of your pawns from the starting point to the finishing point on the board. The game can be played solo or in multiplayer mode.",
        },
        {
          question: "How can I play ludo online?",
          answer:
            "You can download a Ludo app or go to a website hosting the game to play ludo online. You may join a game room, start your own room, and invite other players to play with you after logging in or creating an account.",
        },
        {
          question: "Can I play ludo online with my friends?",
          answer:
            "Yes, playing ludo online multiplayer with your friends is possible by setting up a private game room and providing them with the room code. Alternatively, you can participate in public game rooms and play with individuals worldwide.",
        },
        {
          question: "What are the rules for rolling the dice in ludo?",
          answer:
            "In the game of ludo, players can roll the dice by clicking a button on the screen or shaking their mobile device. The dice has six sides, each numbered from one to six. The number on the dice after it is rolled determines the number of blocks a player can move their game pawn.",
        },
        {
          question: "Can I use strategy to win at ludo?",
          answer:
            "Of course, several tactics can improve one's chances of winning at ludo. For instance, players can strategically place their pawns to block their opponents' pawns or move them in a specific manner to avoid being captured.",
        },
        {
          question: "How long does a game of Ludo typically last?",
          answer:
            "The duration of a game may differ based on factors such as the number of players and the specific rules in play. However, on average, a ludo game can take 20 minutes to an hour to complete.",
        },
        {
          question: "Is playing online Ludo safe?",
          answer: "Yes, it's safe and legal to play free ludo online.",
        },
        {
          question: "How many players can participate in a Ludo game?",
          answer:
            "Two to four players can play the board game ludo with just one.",
        },
      ],
      systemRequirements: [
        {
          items: [
            "Ludo Matka can be played on Windows 7, Android 4.4, iOS 8 or higher versions. You can play it on browsers including Google Chrome, Safari, Opera, and Mozilla Firefox. Android WebView also supports it.",
            "It is important to note that these are the minimum system requirements and that higher specifications may be required for optimal performance.",
          ],
        },
      ],
    },
  },
  sudo: {
    details: {
      title: "Sudo Game - Tile Block Puzzle Game Online",
      gameData: [
        {
          description: [
            "Are you looking for a game that can challenge your brain and have fun at the same time? If yes, the Sudo Game is a great choice. It is an exciting tile block puzzle game online that will keep you entertained for hours.",
            "You might be wondering what tile games are. Tile games are puzzle games that involve arranging tiles of different colors on a board. Your goal is to fit the tiles together and create a pattern. It's similar to solving a puzzle with movable pieces!",
            "Tile games are not just ordinary games. They are logic games that require strategic thinking and careful planning. By manipulating the tiles and considering their color and positions, you need to find the best way to solve the puzzle. It's like giving your brain a workout!",
          ],
        },
        {
          title: "About - Sudo Tile Game 🔢",
          description:
            "Sudo by EpicPlay is a logic-based block puzzle game that has gained immense popularity among players. It's a fun and challenging game that anyone can enjoy. Let me explain why people adore EpicPlay block puzzle games, including Sudo.",
          items: [
            "These games are engaging and stimulate your thinking, keeping your mind active.",
            "They are easy to learn, allowing anyone to start playing right away.",
            "They provide a perfect blend of challenge and relaxation.",
            "The captivating gameplay and soothing ambiance help you unwind and destress.",
          ],
        },
        {
          subTitle: "Unique features:",
          items: [
            "Sudo is designed to be easy to play and suitable for all players.",
            "The game offers a wide range of challenging grid sizes to keep you engaged.",
            "It has simple rules and controls, making it accessible to everyone.",
            "As you progress, the puzzles become increasingly difficult, providing a satisfying challenge.",
          ],
        },
        {
          title: "Gameplay - Sudo Block Puzzle Game Online",
          description:
            "Inspired by Sudoku, Sudo is a fun block puzzle game online that gets better the more you play! In Sudo, the objective is to solve puzzles by placing differently shaped blocks on a grid. It's a simple game that exercises your brain. Here's how the gameplay works:",
          items: [
            "Start by selecting the size of the grid. You can choose from sizes 4, 6, 8, or 10.",
            "Once you've chosen the grid size, you need to solve the puzzle. You must place tiles on the grid, which come in either blue or red colors.",
            "To place a tile, simply single or double-tap on an empty block and select either a red or blue tile. Remember, you can only delete the tiles you create, not the ones already present on the grid.",
            "To delete a block, just tap on it, and it will be removed.",
            "Remember not to put three blocks of the same color together up and down or side by side. Keep an equal number of blocks of each color in each row and column, and make sure each row has a different arrangement to solve the puzzle successfully.",
          ],
        },
        {
          description:
            "Have fun exploring the different shapes, patterns, and challenges that Sudo offers!",
          image: {
            path: "/game-assets/game-images/sudo-game-modes.jpg",
            alt: "Different Levels of Sudo Tile Game",
            title: "Different Levels of Sudo Tile Game",
            caption: "Different Levels of Sudo Tile Game",
          },
        },
        {
          title: "How to Play & Rules - Tile Game",
          description:
            "To play the Tile Game online, follow these steps to complete it:",
          items: [
            "Start with an empty grid consisting of multiple blocks.",
            "Your task is to place tiles on the grid to fill it completely.",
            "Select a tile from the available options and place it on an empty block in the grid.",
            "Avoid placing three tiles of the same color together vertically or horizontally. Make sure to keep them separated.",
            "Ensure that each column has an equal number of tiles of each color. Maintain a balance by distributing the colors evenly.",
            "Continue placing tiles and following the rules until you have filled the entire grid.",
            "Once you have placed all the tiles and followed the rules correctly, the puzzle is considered complete.",
          ],
        },
        {
          subTitle: "Rules:",
          items: [
            "Avoid placing three red or blue tiles together vertically or horizontally. Make sure to arrange them in a way that avoids these formations.",
            "Each row or column must have an equal number of red and blue tiles. Maintain a balance between the two colors in each row and column.",
            "No two rows can be the same. Ensure that each row is unique and different from the others.",
          ],
        },
        {
          title: "Tips and Tricks - Sudo Blocks Tile Game",
          subTitle: "Tips:",
          items: [
            "Start by looking at the grid and identifying rows or columns with mostly by a single color. This will help you decide where to place your tiles.",
            "Aim to maintain an equal number of red and blue tiles in each row and column. Keep the colors balanced.",
            "Be careful not to put three tiles of the same color next to each other in a row or column. Adhering to this rule will help you avoid issues.",
            "Take your time and carefully consider your moves before placing a tile. Plan your moves ahead and think about how they will affect the rest of the grid.",
            "If you're stuck, don't worry! You can remove tiles and try different combinations. ",
          ],
        },
        {
          subTitle: "Tricks:",
          items: [
            "Be mindful of placing a third tile of the same color next to two tiles of the same color. This would break the rule, so watch out for adjacent grids or columns with two tiles of the same color.",
            "Keep an eye on the color balance within the grid. If one color is taking over, try placing more tiles of the other color to make things equal.",
            "Look for patterns in the rows and columns. Make sure each row has a unique arrangement by avoiding repetitions or similarities between them.",
            "Use the delete option wisely. If you realize that a placement will break a rule, remove the tile before it's too late.",
          ],
        },

        {
          description:
            "Remember, practice and observation are key to mastering the game. Have fun and enjoy the challenges!",
        },
      ],
      faq: [
        {
          question: "How do I play the Sudo Tile game?",
          answer:
            "To play the Sudo Tile game, you need to place different-shaped blocks on the grid, following the rules, in order to complete the puzzle.",
        },
        {
          question: "What is the objective of the game?",
          answer:
            "The objective of the game is to fill the grid with blocks while following the rules of not having three same-colored blocks adjacent and maintaining equal colors in each column.",
        },
        {
          question: "How do I select the blocks in the game?",
          answer:
            "To select blocks in the game, you can either single or double tap on an empty block. This will allow you to place a red or blue block inside the selected space.",
        },
        {
          question: "Are there different grid levels in the game?",
          answer:
            "Yes, the game offers multiple grid levels with increasing difficulties to challenge your skills.",
        },
        {
          question: "Is there a time limit in the game?",
          answer:
            "No, there is no time limit in the game. You can take your time to strategize and solve the puzzles.",
        },
        {
          question: "Can I undo a move in the game?",
          answer:
            "Yes, you have the ability to undo a move in the game by deleting the tile color if you wish to make a change to a previous placement. ",
        },
        {
          question: "Are there any power-ups or special tiles in the game?",
          answer:
            "No, the game focuses solely on the core puzzle-solving mechanics and does not include any power-ups or special tiles.",
        },
        {
          question: "Can I compete with friends or other players in the game?",
          answer:
            "Unfortunately, the game doesn't offer multiplayer. It is designed as a single-player puzzle experience.",
        },
      ],
      systemRequirements: [
        {
          description:
            "To play Sudo Tile game online, you don't need any specific requirements. It can be enjoyed on most devices with basic specifications, such as:",
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 4.4 or higher",
            "iOS 8 or higher",
          ],
        },
        {
          description:
            "Please note that these are general recommendations, and the game may also run on devices with lower specifications.",
        },
      ],
    },
  },
  hextris: {
    details: {
      title: "Hextris: Play The Best Ultimate Hexagon Puzzle Game Online",
      gameData: [
        {
          description: [
            "Welcome to Hextris, the exciting hexagon puzzle game that will test your concentration and logic skills! Inspired by the classic game Tetris, Hextris brings a unique twist with its hexagonal game board.",
            "Just like Tetris, Hextris requires you to strategically place and match falling shapes to clear lines and earn points. But here's the catch - instead of working with traditional rectangular blocks, you'll be dealing with hexagons. This adds an extra layer of complexity and challenge to the gameplay.",
            "To score high in this hexagon puzzle game online, you need to pay close attention to the colors. Matching three or more lines of the same color in a row will make them disappear. This enables you to clear space on the board for more colors to come.",
            "But beware, the game gets progressively faster and more challenging as you advance. You'll need to think ahead and plan your moves carefully to avoid reaching the top of the screen. One wrong move could lead to a game over!",
            "If you're ready to test your concentration and logic, jump into Hextris and start stacking hexagons! Get ready for an addictive gaming experience like no other.",
          ],
        },
        {
          title: "About - Hextris, the Hexagon Puzzle Game",
          description: [
            "Hextris is a game inspired by Tetris. However, Hextris adds a unique twist by utilizing a hexagonal game board instead of the traditional rectangular one. It has gained popularity due to its engaging nature.",
            "One of the reasons why Hextris is so engaging is its simplicity combined with its challenging gameplay. Players must strategically place and match colors to clear lines and earn points. This requires concentration and quick thinking, as the lines continuously emerge from either side of the screen.",
            "EpicPlay caters to both desktop and mobile users with this hexagon puzzle game online. This accessibility allows players to enjoy Hextris on their preferred devices. So, it doesn’t matter whether you’re playing it on a computer or a mobile phone.",
            "If you're looking for a game that offers engaging and enjoyable gameplay, Hextris is the perfect choice. So, are you ready for endless fun and entertainment?",
          ],
        },
        {
          title: "Gameplay of Hexagon Puzzle Online",
          description:
            "In Hextris, your objective is to clear colored lines by joining at least three lines of the same color. Let's explore the gameplay with a series of screenshots to understand how to play the game.",
          image: {
            path: "/game-assets/game-images/hextris-color-and-shape-puzzle-game.jpg",
            alt: "Hextris: Hexagon Puzzle Game Online",
            title: "Hextris: Hexagon Puzzle Game Online",
            caption: "Hextris: Hexagon Puzzle Game Online",
          },
          items: [
            "Tap the left and right keys to rotate the central hexagon. This allows you to strategically position it to match the colors.",
            "Join at least three lines of the same color by aligning the hexagon. When you do this, those lines disappear, and you earn points.",
            "To score more points in this hexagon puzzle game, clear the colored lines quickly by continuously joining the same colors. Be fast and precise in your moves.",
            "However, be careful not to fill the hexagon completely, as this will lead to the end of the game. Stay focused and plan your moves wisely.",
            "The game continues as long as you can keep clearing the colored lines. The game is over if you fill the lines on the hexagon.",
          ],
        },
        {
          title: "How to Play & Rules of Hexagon Puzzle Game",
          description:
            "Would you like to learn the rules and how to play the hexagon puzzle online? Here’s a breakdown of it!",
        },
        {
          subTitle: "How to play",
          items: [
            {
              title: "Desktop",
              description:
                "To rotate the central shape on a desktop, you can use the left and right arrow keys or the A and D keys. Additionally, you can left-click your mouse to rotate the shape.",
            },
            {
              title: "Mobile",
              description:
                "On a mobile device, tap the left side of the screen to rotate the central shape to the left and tap the right side of the screen to rotate it to the right.",
            },
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "The objective of Hextris is to clear color strips by matching at least three lines of the same color.",
            "When three or more lines of the same color form a line, they will disappear.",
            "The game ends if the color strips fall outside the hexagon shape. Therefore, be careful not to let them stack up too high.",
            "Clearing multiple lines at once will give you a higher score and can create combo chains for additional points.",
            "As you progress, the speed of the falling shapes will increase.",
          ],
        },
        {
          title:
            "Tips and Tricks to Achieve a High Score in Hexagon Puzzle Game",
            description: "Let us start discussing tips about the hexagon puzzle online first:"
        },
        {
          subTitle: "Tips",
          items: [
            "Stay focused and keep an eye on the upcoming shapes. Anticipate their positions to plan your moves in advance.",
            "Analyze the board, and look for chances to align three lines horizontally or vertically. Identify potential matches in rows or columns.",
            "Aim to create combos by clearing multiple lines simultaneously in this hexagon puzzle game. This will earn you bonus points.",
            "Be mindful of the colors of the shapes. Try to prioritize matching colors that are nearing the top of the board.",
            "Practice your reflexes to quickly rotate the central shape and position it correctly.",
            "Stay calm and avoid making hasty moves.",
          ],
        },
        {
          subTitle: "Tricks",
          items: [
            "Rotate the central shape strategically to create matches.",
            "Look for chances to create chain reactions in this hexagon puzzle online. Clearing one line may cause the shapes above to fall and create additional matches.",
            "Prioritize matching colors that are close to forming a line. Clearing these lines will prevent the board from filling up quickly.",
            "When the board gets crowded, focus on clearing the top lines to create more space.",
          ],
        },
        {
          title: "System Requirements For Hextris Game",
          description:
            "Hextris is an accessible game that can be enjoyed on various devices without the need for high specifications. Here are the basic system requirements to ensure a smooth gaming experience:",
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 4.4 or higher",
            "iOS 8 or higher",
          ],
        },
        {
          description:
            "With these system requirements, you can easily play Hextris, the hexagon puzzle game, on your preferred device and immerse yourself in the engaging world of colorful shape-matching!",
        },
      ],
      faq: [
        {
          question: "How do I play Hextris?",
          answer:
            "Rotate the central shape and position falling lines to match at least three colors in a row or column.",
        },
        {
          question: "What is the goal of Hextris?",
          answer:
            "The goal is to clear color lines by creating matches and earning high scores.",
        },
        {
          question: "How do I control the color lines in Hextris?",
          answer:
            "To control the color lines in Hextris, use arrow keys or A/D keys on desktop and tap left/right sides of the screen on mobile.",
        },
        {
          question: "Are there power-ups or special tiles in Hextris?",
          answer:
            "No, Hextris focuses on matching colors without power-ups or special tiles.",
        },
        {
          question: "Can I compete with friends or other players in Hextris?",
          answer: "No, Hextris does not have a multiplayer mode.",
        },
        {
          question:
            "Is there a strategy or tips for achieving a high score in Hextris?",
          answer:
            "Yes, strategize to create combos, clear lines quickly, and anticipate upcoming colors.",
        },
        {
          question: "Is this game similar to Tetris?",
          answer:
            "Hextris is inspired by Tetris but offers a unique hexagonal gameplay experience.",
        },
      ]
    },
  },
  emoji_minesweeper: {
    details: {
      title: "Emoji Minesweeper: Play Minesweeper Game Online Free Now",
      gameData: [
        {
          description: [
            "Welcome to the world of Minesweeper game online - a classic game that has been played for decades. Are you someone who loves challenging and logical puzzle games? If yes, then you're in for a treat.",
            "Minesweeper’s history goes back to the early 1960s when it was invented by Curt Johnson. He created a prototype of the Minesweeper game online on an IBM computer. Later on, it was introduced formally to the public through Microsoft's Windows operating system in 1990. From there, it became an instant hit and has been a staple game on Windows ever since.",
            "With time, Minesweeper has transformed and expanded to include different versions and difficulty levels. Nowadays, you can easily find Minesweeper available online or as a mobile app. Thus, allowing players like you to enjoy the game on the go.",
            "So, what are you waiting for? Challenge yourself and test your strategic thinking skills with the Minesweeper browser game. Play the Minesweeper game online today and see if you can clear the board without clicking on any mines!",
          ],
        },
        {
          title: "About - Emoji Minesweeper Game Online",
          description: [
            "EpicPlay developers have introduced a new variant of the Minesweeper game online for you. So, get ready to enjoy the classic game with a fun and quirky twist.",
            "The main goal of playing the game is to uncover all the squares on the board without blowing up any hidden mines. The numbers on the board show the number of mines in the adjacent squares. So, you must use a good strategy to clear the board while avoiding the mines.",
            "With the addition of emojis, the game has reached a whole new level of fun and excitement. Each square on the board is now represented by a vibrant emoji. This new addition makes the game visually more appealing and entertaining.",
            "This Minesweeper online version is not only challenging and engaging but also easy to play. So, whether you're looking to kill time or trick your mind, the Emoji Minesweeper is the perfect game for you. It's simple, fun, and highly engaging.",
            "Play Minesweeper online today and challenge yourself to see if you have what it takes to uncover all the safe squares without blasting any mines.",
          ],
        },
        {
          title: "Gameplay of Minesweeper Browser Game",
          description: [
            "Once you've opened the game, you'll be shown a board that has several squares, some of which may contain hidden mines. Beware of these mines!",
            "Your aim is to clear the board of all the squares that do not contain mines without exploding any of the mines. Sounds easy, right? Well, it's not as simple as it seems.",
            "To start, you'll need to click on a square to reveal what's underneath. It could be a number or a mine. If a number appears, it indicates how many mines are adjacent to that square. Your task is to use the numbers to deduce where the mines are located. As you continue exploring squares, the game becomes more challenging, and the number of mines increases.",
            "You'll need to use your logic and deduction skills to clear the board without detonating any of the mines. If you accidentally detonate a mine, the game is over, and you'll need to start again.",
            "However, if you manage to clear the board without detonating any mines, you win the game!",
          ],
        },
        {
          title: "How to Play & Rules of Minesweeper Puzzle Game",
          subTitle: "Controls",
          description:
            "The controls for Minesweeper game online are slightly different between desktop and mobile devices.",
        },
        {
          items: [
            {
              title: "For desktop",
              description:
                "To reveal a square, left-click on it. If you deduce that a square is a mine, right-click on it to mark it. This will place a flag on the square. To remove a flag from a square, right-click on it again.",
            },
            {
              title: "For mobile",
              description:
                "Tap on a square to reveal it. If you believe a specific square contains a mine, long-press on it. This will place a flag on the square. To remove that flag long-press on it again.",
            },
          ],
        },
        {
          subTitle: "How to play?",
          description:
            "Now, after knowing the basics you must be wondering how to play this classic time. Here's what you need to learn before you start playing.",
        },
        {
          description: "Each cell can have one of these three states",
          items: [
            {
              title: "Open",
              description: "which means they contain emojis.",
            },
            {
              title: "Numbered",
              description:
                "which indicates the number of bombs placed adjacent or diagonally.",
            },
            {
              title: "Flagged",
              description:
                "which indicates that there may be a bomb around it.",
            },
          ],
        },
        {
          description: "Below are step-by-step instructions:",
          items: [
            "Start the game by visiting the Emoji Minesweeper game online on your device.",
            "A game board consisting of a grid of squares will appear on the screen. Remember not to forget that some of these squares contain hidden mines.",
            "Click on any square to reveal what's underneath.",
            "Mark the squares you believe contain mines by right-clicking on them. This will place a flag on the square to indicate that you believe it contains a mine.",
            "If you click on a square that contains a mine, the game is over. You can restart the game by clicking on the emoji button at the top of the gameplay area.",
            "If the square doesn't contain a mine, a number will appear indicating how many mines are surrounding that square.",
            "Using these numbers, you must logically figure out where the mines are located.",
            "If you've correctly uncovered all the squares without clicking on the mine, you win the game.",
          ],
        },
        {
          image: {
            path: "/game-assets/game-images/emoji-minesweeper-game-online.jpg",
            alt: "Emoji Minesweeper Game Online",
            title: "Emoji Minesweeper Game Online",
            caption: "Emoji Minesweeper Game Online",
          },
        },
        {
          description:
            "In this screenshot, you can see the game board with some squares already revealed and some still hidden.",
        },
        {
          subTitle: "Rules",
          description:
            "Mastering Minesweeper game online involves adhering to some essential rules:",
          items: [
            "The objective of the game is to clear a board filled with hidden mines by revealing squares that do not contain mines.",
            "When you reveal a square, it will either be empty or contain a number between 1 and 8. This number represents the number of mines that are in the eight surrounding squares.",
            "If you reveal a square that contains a mine, the game is over, and you lose.",
            "To win the game, you must successfully reveal all the non-mine squares on the board.",
            "It's important to think carefully before revealing a square or flagging a square as a mine. One wrong move can result in detonating a mine and ending the game.",
            "You cannot mark a square as a mine if it has already been revealed.",
            "You cannot reveal a square that has been marked as a mine until you unmark it first.",
            "The game is won when all non-mine squares are cleared and all mines are flagged.",
          ],
        },
        {
          title: "Tips and Tricks of Minesweeper Computer Game",
          description:
            "Below are some tips and tricks to successfully avoid mines in the Minesweeper game online.",
        },
        {
          subTitle: "Tips",
          items: [
            "Start playing it even if you do not know about it to get comfortable with the game rules and develop your skills gradually.",
            "Always pay attention to the numbers on the board. These numbers give you clues about which squares contain mines.",
            "Try to flag squares that you think contain mine. This will help you keep track of which squares you need to avoid and prevent you from accidentally detonating mines.",
            "Avoid making random guesses. Guessing can lead to clicking a mine and losing the game.",
            "Look for patterns on the board. These patterns can give you clues about which squares contain mines.",
            "Take your time and think through each move carefully. Rushing can lead to mistakes and accidental detonation of mines.",
          ],
        },
        {
          subTitle: "Tricks",
          items: [
            "If you're unsure about a square, use the \"flag\" option to indicate that you're unsure about it. This can help you keep track of which squares you need to revisit later.",
            "Always keep an eye on the number of remaining mines. This will help you determine which squares are safe to reveal and which ones to avoid.",
            "Keep practicing and learning from your mistakes; Minesweeper game online is a game of strategy and deduction, and the more you play, the better you'll become.",
          ],
        },
      ],
      faq: [
        {
          question: "What is Minesweeper?",
          answer:
            "Minesweeper is a classic single-player puzzle game that involves uncovering hidden mines on a grid-based board without detonating them.",
        },
        {
          question: "How to play Minesweeper?",
          answer:
            "To play Minesweeper, players must use logic and deduction to determine which squares on the board contain hidden mines and which do not, based on clues revealed by adjacent numbered squares.",
        },
        {
          question: "What is the strategy to win at Minesweeper game online?",
          answer:
            "Winning at Minesweeper game online involves successfully uncovering all non-mine squares on the board without detonating any hidden mines.",
        },
        {
          question: "How do you flag a mine in Minesweeper?",
          answer:
            "To flag a mine in Minesweeper, players must right-click or long-press on the square where they believe a mine is located.",
        },
        {
          question: "How do the numbered squares in Minesweeper provide clues?",
          answer:
            "The point of the numbers in Minesweeper is to provide clues about the number of mines in the adjacent or diagonal squares.",
        },
        {
          question: "Can the difficulty level of Minesweeper be adjusted?",
          answer:
            "Yes, Minesweeper typically offers different difficulty levels that can be customized to the player's skill level or preference.",
        },
        {
          question: "Can Minesweeper game online be played on mobile devices?",
          answer:
            "Absolutely, Minesweeper game online is accessible and enjoyable on mobile devices.",
        },
        {
          question: "Is Minesweeper a game of chance or skill?",
          answer:
            "Minesweeper is primarily a game of skill, as players must use logic and deduction to determine the location of hidden mines, although luck can sometimes play a role in certain situations.",
        },
      ],
      systemRequirements: [
        {
          description: [
            "Emoji Minesweeper game online is a simple game that can be played on most devices with basic specifications. It can run on Google Chrome, Safari, Opera, and Mozilla Firefox. The game does not require high-end graphics or sound and can be played on most browsers. It is compatible with portable Android 4.4 and iOS 8 or higher device versions, as well as desktop computers running Windows 7 or higher versions.",
            "However, it is recommended to have a stable internet connection for smooth gameplay. Overall, the system requirements for Minesweeper game online are very minimal and should be compatible with most devices.",
          ],
        },
      ],
    },
  },
  epic_chess: {
    details: {
      title: "Play Epic Chess: Free Online Chess Game Against Computer",
      gameData: [
        {
          description: [
            "Welcome to the exciting world of chess, If want to play an online chess game against the computer or friends, you've come to the right place. Where using the right strategy is the key to winning. Do you know that Chess is a traditional board game that has been played by millions of people all around the world for centuries? ",
            "You need to use your critical thinking and a little bit of creativity to beat the opponent. Whether you're a chess expert or have just started, there's always something new to learn and enjoy in this free online chess game against a computer. Chess is not only a great way to kill time, but it's also a fantastic way to exercise your brain and increase your cognitive ability.",
            "So, gear up to challenge your mind in epic battles against a virtual opponent in this online chess game against a computer or play chess against a friend on the same computer.",
          ],
        },
        {
          title: "About - Free Chess Game Against Computer",
          description: [
            "Chess, a timeless strategy game, has been a favorite pastime for decades. Thanks to modern technology, you can now engage in intense battles against a computer opponent right from the comfort of your home in this free online chess game against a computer.",
            "One of the best things about this free online chess game against the computer or with friends is that it allows you to play at your own pace with ease. Depending upon your skill, you may choose the appropriate difficulty level to practice your abilities against the computer.",
          ],
        },
        {
          subTitle: "Why should you play Epic Chess?",
          items: [
            {
              title: "Mental exercise",
              description:
                "Engaging in this online chess game against the computer or with friends enhances your critical thinking, problem-solving, and analytical skills.",
            },
            {
              title: "Stress relief",
              description:
                "Chess is a strategic game that requires you to focus on the board and plan your moves. This can help you take your mind off of daily stressors and provide a relaxing outlet.",
            },
            {
              title: " Social interaction",
              description:
                "Chess can be played with other people, either in-person or online. This can provide an opportunity to connect with others and make new friends.",
            },
            {
              title: "Learning opportunity",
              description:
                "Chess has a rich history and complex strategy. Playing online chess games against the computer can be an opportunity to learn more about the game and its intricacies.",
            },
            {
              title: "Competitive challenge",
              description:
                "If you relish competition, this online chess game against the computer provides a stimulating and rewarding experience.",
            },
          ],
        },
        {
          description:
            "So give Epic Chess a shot if you're searching for a fun and free game to sharpen your skills and challenge your mind.",
        },
        {
          title: "Gameplay of Online Chess Game to Play with Friends",
          image: {
            path: "/game-assets/game-images/online-chess-game-against-computer.jpg",
            alt: "Free Online Chess Game Against Computer",
            title: "Free Online Chess Game Against Computer",
            caption: "Free Online Chess Game Against Computer",
          },
        },
        {
          description: [
            "To excel in the world of online chess and enjoy thrilling matches with your friends, it's crucial to comprehend the gameplay dynamics. Online chess, much like its traditional counterpart, involves two players taking turns maneuvering black and white pieces across a 64-tile (8x8) square board. The ultimate objective of the game remains constant: to corner your opponent's king, rendering it immobile without falling victim to capture or checkmate.",
            "Here's a comprehensive breakdown of the gameplay for an online chess game designed for friendly matches:",
          ],
        },
        {
          subTitle: "Game Modes",
          items: [
            {
              title: "Player vs. player",
              description:
                "This mode enables two players to engage in a chess duel against each other using the same computer. It's the perfect setting for friendly competitions and casual matches among friends.",
            },
            {
              title: "Player vs. AI",
              description:
                "In this mode, players can play online chess against a computer, providing a challenging opponent for solo play or practice sessions.",
            },
          ],
        },
        {
          subTitle: "Difficulty level",
          items: [
            {
              title: "Easy",
              description:
                "With simpler moves and an easy approach, it is best for players who have just started learning the game.",
            },
            {
              title: "Medium",
              description:
                "This mode is more challenging than the easy mode, with complex tactics and plans, making the game more difficult for players with some experience.",
            },
            {
              title: "Difficult",
              description:
                "It is the hardest setting and is usually only played by more seasoned players. In this setting, the computer or opponent is extremely talented and makes advanced plays and strategies.",
            },
          ],
        },
        {
          description:
            "The Epic Chess game also uses a game clock. A game clock, also known as a chess clock, is a timing device that is used to keep track of the amount of time each player has taken to make their moves during a game",
        },
        {
          title: "How to Play & Rules - Chess Board Game Online",
          description:
            "Eager to master the art of chess? Keep reading to discover everything you need to know about playing this online chess game against computer opponents.",
        },
        {
          subTitle: "Controls",
          description:
            "Controlling an online chess game against a computer or with friends on both desktop and mobile devices can be slightly different, but the general principles remain the same.",
          items: [
            {
              title: "Desktop",
              description:
                "Use the mouse to select and move pieces. You can click on the piece you want to move, and then click on the square you want to move it to.",
            },
            {
              title: "Mobile",
              description:
                "Tap on the screen to select and move pieces. Tap on the piece you want to move, and then tap on the square you want to move it to.",
            },
          ],
        },
        {
          subTitle: "How to play",
          description:
            "Here's a step-by-step guide to playing this online chess game against computer opponents:",
          items: [
            {
              title: "Start the game",
              description:
                "Start the Epic Chess game on your device of choice.",
            },
            {
              title: "Select a game mode",
              description:
                "There are two game modes available in this online chess game against the computer or with friends. You can also choose a level of difficulty to test your skills.",
            },
            {
              title: "Make your moves",
              description:
                "Once the game starts, it's time to make your moves. Select the piece you want to move, and then decide the square you want to move it to.",
            },
            {
              title: "Check the game clock",
              description:
                "Most online chess games against the computer use a game clock to ensure that games don't go on indefinitely. Make sure to keep a close eye on the clock and make your moves on time.",
            },
            {
              title: "End the game",
              description:
                "Once the game is over, i.e., when a King has been captured, it's time to end it.",
            },
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "Chess is played on a square board of 8x8 squares, with alternating black and white squares.",
            "Each player has 16 pieces: one king, one queen, two rooks, two knights, two bishops, and eight pawns.",
            "The goal of the game is to checkmate your opponent's king.",
            "White always moves first, followed by each player moving one piece at a time.",
            "Each piece moves in a specific way. For example, the pawn can move forward one or two squares on its first move, and then one square forward on subsequent moves. The bishop moves diagonally, the knight moves in an L-shaped pattern, and the rook moves horizontally or vertically. The queen can move in any direction, like a combination of the bishop and rook.",
            "The king can also castle. It is a unique move that enables the king to be guarded by a rook, by moving two squares to the left or right.",
            "A piece is captured and taken from the board when it lands on a square that is already occupied by an opponent's piece.",
            "The player is in check if his or her king is under attack and cannot be moved to safety.",
            "A player who is in check must act to escape check on their next turn.",
            "The game ends in a draw by stalemate if a player is not in check but has no legitimate moves to make.",
            "If the same position is repeated three times or 50 moves are made without a capture or pawn move, the game is drawn by threefold repetition or the 50-move rule, respectively.",
          ],
        },
        {
          title: "Tips and Tricks to Play Chess Online Free",
          description:
            "Would you like to become a better Chess player? Look nowhere else! You may achieve your objective of improving your chess skills and taking your game to the next level by using our tips and tricks.",
        },
        {
          subTitle: "Tips",
          items: [
            {
              title: "Start with the basics",
              description:
                "Make sure you have a firm understanding of the basics before moving on to more complex techniques. This includes being aware of both the game's general goal and how each piece moves.",
            },
            {
              title: "Plan ahead",
              description:
                "Considering what lies ahead is one of the most crucial chess abilities. Try to foresee your opponent’s moves so that you can prepare your own accordingly.",
            },
            {
              title: "Control the center",
              description:
                "The most crucial aspect of the game is the center of the board. To outsmart your opponent, try to take control of the major squares.",
            },
            {
              title: "Keep your pieces protected",
              description:
                "Make sure to protect your pieces by keeping them out of harm's way because losing a piece can be a significant setback.",
            },
            {
              title: "Develop your pieces",
              description:
                "Develop your pieces by moving them towards the center of the board and creating a strong position. This will help you control the board and gain an advantage.",
            },
            {
              title: "Guard your king",
              description:
                "The key to winning the game is to keep your king safe. Early on in the game, fortify your king's position with a castle, and keep it there until the end.",
            },
          ],
        },
        {
          subTitle: "Tricks",
          items: [
            "Use the Fork strategy to kill two or more of your opponent's pieces at the same time. For this use your knights or bishops to create forks to put your opponent in a difficult position.",
            "Pin a piece to restrict its movement and make it vulnerable to attack.",
            "Use your queen and king together to checkmate. For example, use your queen to create threats and your king to protect it. Get your opponent in a position where they have nowhere to move.",
            "When you are attacked, look for opportunities to defend and attack at the same time. Use your pieces to defend your pieces while also attacking your opponent.",
          ],
        },
      ],
      faq: [
        {
          question: "What are the basic rules of chess?",
          answer:
            "Chess is a game played by two players who move pieces on a board to checkmate their opponent's king. Each player has 16 pieces consisting of pawns, knights, bishops, rooks, a queen, and a king.",
        },
        {
          question: "How can I improve my chess skills?",
          answer:
            "By practicing various strategies, studying openings, analyzing games, and playing against opponents of varying skill levels. Resources like books, online tutorials, and chess clubs can be quite helpful in this regard.",
        },
        {
          question: "What distinguishes blitz, rapid, and classical chess?",
          answer:
            "Blitz chess involves each player having just a few minutes to make all their moves, while rapid chess typically allows 15-30 minutes for each player to complete their moves. Classical chess is played with longer time controls and can last several hours.",
        },
        {
          question: "Can I play chess online with other players?",
          answer:
            "Yes, it is possible. Many online chess websites and apps provide the opportunity to play against other players from around the world.",
        },
        {
          question: " What are some common chess tactics and strategies?",
          answer:
            "Common chess tactics include forks, pins, skewers, and discovered attacks. Strategies may involve controlling the board's center, developing pieces, and creating pawn structures to support your pieces. Advanced strategies may include sacrificing material for positional or tactical advantages.",
        },
        {
          question: "How do you move the pieces in Chess?",
          answer:
            "Each piece has its unique way of moving. The king can move one square in any direction, the queen can move diagonally, horizontally, or vertically, the rook can move horizontally or vertically, the bishop can move diagonally, the knight moves in an L-shaped pattern, and the pawn moves forward one or two squares on its first move, and then one square forward on subsequent moves.",
        },
        {
          question: "How do you win at Chess?",
          answer:
            "To win at Chess, you must checkmate your opponent's king. This means placing their king under attack in such a way that it cannot escape capture. If a player's king is in check and they have no legal moves to get out of check, they are checkmated and the game is over.",
        },
        {
          question: "What is checkmate in Chess?",
          answer:
            "Checkmate is when the opponent's king is under attack and cannot escape capture. The main goal of the game is to checkmate the opponent's king.",
        },
      ],
      systemRequirements: [
        {
          description: [
            "Epic Chess can be played on Windows 7, Android 4.4, iOS 8, or higher versions. You can play it on browsers including Google Chrome, Safari, Opera, and Mozilla Firefox. Android WebView also supports it.",
            "It is important to note that these are the minimum system requirements and that higher specifications may be required for optimal performance.",
            "Enjoy your epic chess journey and master the art of the online chess game against computer opponents!",
          ],
        },
      ],
    },
  },
  callbreak: {
    details: {
      title: "Call Break Multiplayer Game Online (Lakadi Game)",
      gameData: [
        {
          description:
            "Call Break is a popular card game that is typically played with four players, although variations of the game can be played with different numbers of players. The game is believed to have originated in South Asia and is now enjoyed by players around the world.",
        },
        {
          title: "About Call Break Card Game for PC",
          description: [
            'The game is played with a standard deck of 52 cards ranked from highest to lowest as follows: Ace, King, Queen, Jack, 10, 9, 8, 7, 6, 5, 4, 3, 2. In Call Break, the objective of each round is to win as many tricks as possible, with players earning points based on the number of tricks they win and the "call" they make before the round begins.',
            'Before each round, players must make a "call" or prediction about how many tricks they expect to win during the round. If a player\'s actual number of tricks won matches their call, they receive bonus points. If a player wins more or fewer tricks than their call, they receive penalty points.',
          ],
        },
        {
          description: (
            <>
              <b>Why should you play Call Break</b>
            </>
          ),
          items: [
            {
              title: "Entertainment",
              description:
                "It can be a great way to spend time with friends and family and have some fun.",
            },
            {
              title: "Strategy",
              description:
                "Call Break requires players to use their strategic thinking skills to play their cards wisely and win tricks. ",
            },
            {
              title: "Socialization",
              description:
                "It can help to build relationships and create a sense of community among players.",
            },
            {
              title: "Mental Exercise",
              description:
                "It helps improve your memory, concentration, and analytical skills. It can also help to reduce stress and improve your overall mental well-being.",
            },
            {
              title: "Easy to Learn",
              description:
                "Call Break is a relatively easy game to learn, making it accessible to players of all ages and skill levels.",
            },
          ],
        },
        {
          title: "Gameplay of Call Break (Lakadi) Game",
          description: [
            "The game of call break typically consists of four rounds, although in trump call break games, players have the option to choose from Quick Play, Classic which has 2 rounds, 4 rounds respectively. Once players select a mode and make a bid, the game begins.",
            "One player out of the four is dealt five cards and selects a trump suit based on those cards. Then, all players are dealt 10 cards each. The players then bid on the number of tricks they think they can win, starting from the player who announced the trump and moving clockwise. The player who announced the trump leads the round by playing any card from their hand. Other players must follow suit if they have a card of that suit. If they don't, they can choose to play a trump card.",
            "The winner of the first trick leads the second, and the game continues until no cards remain. After each round, scores are calculated. If players have chosen to play additional rounds, the second round begins, and the player seated to the left of the player who announced the trump selects the trump suit. After all rounds are complete, the player with the highest score wins the game.",
          ],
        },
        {
          subTitle: "What are the different modes",
          description: "There are two modes in CallBreak:",
          items: [
            {
              title: "Quick Play",
              description: "It has two rounds.",
            },
            {
              title: "Classic",
              description: "It has four rounds.",
            },
          ],
        },
        {
          image: {
            path: "/game-assets/game-images/call-break-2-rounds-4-rounds.jpg",
            alt: "Call Break Multiplayer Online",
            title: "Call Break Multiplayer Online",
            caption: "Call Break Multiplayer Online",
          },
        },
        {
          subTitle: "What are the different bids",
          description:
            "You can bid up to 8 coins in the Call Break game. Points distribution with bids is as follows:",
          items: [
            "Each bid win gives the player +1 point. Each extra bid win gives 0.1.",
            "If the user selects 3 bids and is not able to cover it with 3 bid wins, they get a total of -3 points.",
          ],
        },
        {
          image: {
            path: "/game-assets/game-images/make-bid-call-break.jpg",
            alt: "Call Break Single Player",
            title: "Call Break Single Player",
            caption: "Call Break Single Player",
          },
        },
        {
          subTitle: "What is Trump",
          description: [
            'In Call Break, a "trump" card is a card from the suit that has been designated as the trump suit for that round. At the beginning of each round, one of the four suits (hearts ♥♥, diamonds ♦♦, clubs ♣♣, or spades ♠♠) is randomly selected to be the trump suit for that round. Once the trump suit has been determined, all cards in that suit become trump cards for that round, which means they have a higher value than cards from other suits.',
            "During the round, if a player cannot follow the suit led by the first player, they may choose to play a trump card instead. If multiple players play trump cards, the player with the highest ranking trump card wins the trick. The trump suit changes every round, so players must adapt their strategy based on which suit is currently trump.",
          ],
        },
        {
          subTitle: "4-player gameplay example",
          description: [
            "Let's say Alice, Bob, Charlie, and Diane are 4 players.",
            "Alice predicts that she will win 4 tricks, Bob predicts that he will win 3 tricks, Charlie predicts that he will win 2 tricks, and Diane predicts that she will win 4 tricks. The total number of predicted tricks is 13.",
          ],
        },
        {
          image: {
            path: "/game-assets/game-images/call-break-multiplayer-online.jpg",
            alt: "Call Break: Lakadi Game",
            title: "Call Break: Lakadi Game",
            caption: "Call Break: Lakadi Game",
          },
        },
        {
          description:
            "In the first trick, Alice leads with the Ace of ♠, and the other players follow suit. Diane plays the King of ♠ and wins the trick. Diane then leads the second trick with the Ace of ♥, and Charlie plays the Queen of ♥ to win the trick. Charlie leads the third trick with the 2 of ♣, and Bob plays the 5 of ♣ to win the trick. Bob leads the fourth trick with the 6 of ♥, and Alice plays the 9 of ♥ to win the trick.",
          items: [
            "After 13 tricks, Alice won 3 tricks instead of her prediction of 4, so she receives 3 points.",
            "Bob won 2 tricks instead of his prediction of 3, so he receives 2 points.",
            "Charlie won 2 tricks instead of his prediction of 2, so he receives 12 points (10 points for the exact prediction and 2 points for the number of tricks won).",
            "Diane won 6 tricks instead of her prediction of 4, so she receives 6 points.",
          ],
        },
        {
          description:
            "The game continues with additional rounds until one player reaches the predetermined point threshold to win the game.",
        },
        {
          image: {
            path: "/game-assets/game-images/call-break-4-player-game.jpg",
            alt: "Call Break Multiplayer Online",
            title: "Call Break Multiplayer Online",
            caption: "Call Break Multiplayer Online",
          },
        },
        {
          title: "How to Play & Rules - Call Break",
          description:
            "These are the steps to play Call Break, also known as Lakadi:",
          items: [
            "Call break is typically played with four players, using a standard deck of 52 playing cards.",
            "The game is divided into 4 rounds, and in each round, each player is dealt 13 cards.",
            "The player has to select the number of bids they can win as per their set of cards.",
            "The objective of the game is to win bids, with the player who wins the most bids wins the round.",
            "The player to the dealer's right is expected to lead the first hand.",
            "Players have to play a card of the same suit that is being played during the current hand. In case they don't have a card belonging to the suit that is played, they can use a trump card. However, this doesn't necessarily mean you will win the hand.",
            "For example, the player sitting next to the dealer plays an Ace of Hearts. After that, every player will have to play a card from the same suit unless they don't have any. In such cases, the player without a card from the same suit can choose to play a trump card. If a player throws an Ace and no player has played a trump card, the player with the Ace card will win the hand.",
            "You must play a higher value card than the cards that have already been played during the hand if you have one. If you don't have a card with a higher value, you can play any card.",
          ],
        },
        {
          image: {
            path: "/game-assets/game-images/call-break-won.jpg",
            alt: "Play Call Break Lakadi Game",
            title: "Play Call Break Lakadi Game",
            caption: "Play Call Break Lakadi Game",
          },
        },
        {
          subTitle: "Rules",
          description: "These are the fundamental rules of CallBreak:",
          items: [
            {
              title: "Number of players",
              description: "CallBreak is a four-player game.",
            },
            {
              title: "Bidding",
              description:
                "The game begins with each player placing their bets or calls. Every player must call the number of tricks they believe they can win in that round. The sum of all calls must be equal to the number of total tricks available in that round, typically 13.",
            },
            {
              title: "Dealing",
              description:
                "After the calls are made, the dealer deals 13 cards to each player one at a time, starting from the player on their left.",
            },
            {
              title: "Trump Suit",
              description:
                "Before the first trick is played, players must select a trump suit. The suit that is chosen becomes the trump suit for that round, and a trump card beats any other card, irrespective of its rank or suit.",
            },
            {
              title: "Playing",
              description:
                "The player to the left of the dealer leads the first trick by playing any card from their hand. The other players must follow suit if possible, but if they do not have a card of the same suit, they can play any card, including a trump card.",
            },
            {
              title: "Winning tricks",
              description:
                "The player who wins a trick leads the next one until all the cards have been played. The game is won by the player who has the most points at the end of the predetermined number of rounds. Each player receives points based on the number of tricks they win. The player who wins the exact number of tricks they called earns bonus points, while players who take more or fewer tricks lose points.",
            },
            {
              title: "Scoring",
              description: "In CallBreak, the scoring system is as follows:",
              subItems: [
                "A player earns one point for every trick won.",
                "If a player wins the exact number of tricks they called, they earn ten points plus the number of tricks they won.",
                "If a player wins more or fewer tricks than they called, they lose one point for each trick they were off.",
              ],
            },
            {
              title: "Rounds",
              description:
                "The game continues with players taking turns being the dealer and playing multiple rounds until a predetermined score or number of rounds is reached.",
            },
          ],
        },
        {
          title: "Tips and Tricks - Call Break Card Game",
          description: (
            <>
              If you are a beginner, you must know all the rules on how to{" "}
              <b>play Call Break for PC</b> and easy tricks to do better bidding
              in the game. It is well established that perfecting the game can
              only come through persistence and practice, but a few game tricks
              won't hurt. The tips will allow you to enjoy the Call Break
              gameplay online for free and help you make fewer mistakes. Here
              are some of the best tips and tricks that can make you the best
              player, even in your first play:
            </>
          ),
          items: [
            {
              description: (
                <>
                  Always take <b>calculated risks</b> and avoid any random move.
                  Before you bid, you should look at your cards, and based on
                  that, you can predict how many tricks you can make.
                </>
              ),
            },
            {
              description: (
                <>
                  Use the <b>trump card</b> wisely because it makes you score or
                  even win your bid. So, use it when you need it the most and
                  when it is necessary to use it.
                </>
              ),
            },
            {
              description: (
                <>
                  A dealer may have a slight advantage over other players. In
                  the game <b>Call Break multiplayer online</b>, the dealers
                  change with each round, and at the start, the dealer is chosen
                  randomly. So, volunteer first as a dealer to get an edge over
                  the other players.{" "}
                </>
              ),
            },
            "The queen and jack are the high cards in the game. But if you are doing your tricks based on those two cards, it will not always win you the game. Do not bid just by considering the queens and jacks; be more strategic about it. ",
            {
              description: (
                <>
                  Always watch the <b>play Call Break</b> game, and do not let
                  your guard down even for a minute. You need to predict each
                  player's cards based on previous rounds to make your card
                  predictions.
                </>
              ),
            },
          ],
        },
      ],
      faq: [
        {
          question: "What is Call Break?",
          answer:
            "Call Break is a trick-based card game played with a 52-card deck. The total number of players in the game is four, each with 13 cards.",
        },
        {
          question: "How do I play Call Break?",
          answer:
            "At the start of the game, each player must make a call, predicting how many tricks they will win in each round. The players who make the right prediction or win the highest number of tricks will win and earn points.",
        },
        {
          question: "Can I play Call Break online?",
          answer:
            "Yes. Call Break online play is available on desktop and apps.",
        },
        {
          question: "How many rounds are typically played in the Call Break?",
          answer:
            "The number of rounds is typically between 5 and 9. However, it can vary depending upon the number of players or what the players prefer.",
        },
        {
          question:
            "Can I play a Call Break card game with more or less players than four?",
          answer:
            "The most traditional way to Call Break play is with four players. However, you can play it with 3 or 5 players with slightly different rules depending on the number of players.",
        },
        {
          question: "What is the rule of playing a card in a CallBreak?",
          answer:
            "There are many rules of playing a card in CallBreak. Check the Rules section to learn more.",
        },
        {
          question: "How can you calculate the score in the CallBreak?",
          answer:
            "In Call Break online, if a player wins the exact number of tricks they predict, they earn an extra 10 points with the number of tricks won. But if their prediction is not right, they only win one point for each trick.",
        },
      ],
      systemRequirements: [
        {
          items: [
            "Windows 7 or higher versions.",
            "Android 4.4 or higher versions.",
            "iOS 8 or higher versions.",
          ],
        },
      ],
    },
  },
  hillclimb_india: {
    details: {
      title: "Hill Climb Racing Game Online For Free on PC",
      gameData: [
        {
          description: [
            <>
              Are you ready to take your hill racing experience to the next
              level? Look no further than the Hill Climb racing game! Featuring
              the exciting and unique concept of driving an Auto Rickshaw on
              hills and offroad, this{" "}
              <a href="https://www.epicplay.in/category/arcade-games">
                arcade game
              </a>{" "}
              is sure to provide endless entertainment.
            </>,
            "In the Hill Climb India game, you can enjoy the thrill of racing and experience the thrill of driving an auto-rickshaw, car, or taxi up and down a hill. Navigate through a long hilly street with bumps, and pick up and drop off passengers along the way.",
            "Hill Climb games have always been a fan favorite in the world of driving and racing games, and EpicPlay’s Hill Climb India takes it to the next level with its fun and exciting gameplay. Get ready to experience the thrill of driving an Auto Rickshaw like never before with Hill Climb racing!",
          ],
        },
        {
          title: "About - Hill Climb Game Online 🛺🚗",
          description:
            "Hill Climb India Game is an entertaining and thrilling game that can be played for free online for endless hours. Players can drive an auto-rickshaw, a cab, or a taxi through various terrains, picking up passengers and safely dropping them off at their destination within a given time limit. The game offers a challenge for players as they must keep the luggage from falling off, do wheelies, and make their way through various obstacles. In Rush Mode, you will be chased by police and need to safely escape while bagging fuel and not falling into road traps.",
          image: {
            path: "/game-assets/game-images/hill-climb-racing-game-online.jpg",
            alt: "Hill Climb Racing Game Online",
            title: "Hill Climb Racing Game Online",
            caption: "Hill Climb Racing Game Online",
          },
        },
        {
          description:
            "The game's popularity can be attributed to its engaging gameplay, infinite challenging levels, and modes to choose from based on your expertise. The game has also received frequent updates with new vehicles and environments, keeping players engaged and interested. It also allows you to upgrade Auto Rickshaw’s skins and accessories for real cash or fake money you collect and save in the game.",
          image: {
            path: "/game-assets/game-images/hill-climb-racing-online-purchase.jpg",
            alt: "Hill Climb Racing Online Purchase",
            title: "Hill Climb Racing Online Purchase",
            caption: "Hill Climb Racing Online Purchase",
          },
        },
        {
          description:
            "If you're looking for a browser-based version of Hill Climb Racing Game, EpicPlay has got you covered. With the browser version, you can easily play the game without any downloads or installations. The game offers a fun and challenging experience for all players as they navigate rugged terrain and try to complete the given tasks within the given time. So why wait? Start playing the Hill Climb India Racing Game today!",
        },
        {
          title: "Gameplay of Hill Climb India Racing Game",
          descriptions: [
            "Embark on a thrilling journey through the rough terrains and hills of India. The Hill Climb India game puts you in the driver's seat of an Auto Rickshaw, a Cab, or a Taxi, where you'll pick up passengers, earn money, repair your vehicle, and evade the cops.",
            "The game features infinite levels and two modes that challenge the player's skills. Players can also purchase skins or upgrade accessories to improve their ability to transport passengers and earn more money. As you navigate through the hills and terrains, you'll feel the rush of excitement as you race against the clock and overcome obstacles. You'll also experience India's unique culture and landscape as you drive through the game's various levels. From the bustling streets of Mumbai to the serene countryside, Hill Climb India immerses you in the country’s rich and diverse environment.",
          ],
          image: {
            path: "/game-assets/game-images/hill-climb-racing-online-play.jpg",
            alt: "Hill Climb Racing Online Play",
            title: "Hill Climb Racing Online Play",
            caption: "Hill Climb Racing Online Play",
          },
        },
        {
          description: [
            "The roads are bumpy and uneven, and your vehicle can take a beating from the rough terrain, so you'll need to be careful. Damaged vehicles will stop at Raju or Bunty’s Garage for repairs.",
            "One of the game's key features is the ability to upgrade and buy new vehicles. You'll start with an Auto Rickshaw and work your way up to a Hatchback Cab or a Taxi. Each vehicle has unique capabilities, such as speed, durability, and passenger capacity. And as you drop off passengers at their destinations, you'll earn drive points that help you progress through the game. The more passengers you transport, the more drive points you'll make.",
            "With its variety of vehicles, levels, and challenges, players can enjoy hours of gameplay while building their own cab business on the hills of India.",
          ],
        },
        {
          title: "How to play & Rules - Hill Climb Online",
          subTitle: "How to play",
          items: [
            "To start, press the gas button to fuel the vehicle. ",
            "Press the brake when you come across a speed breaker or a bump. ",
            "Along the way, the game will provide multiple tips to improve your play and score more. ",
            "The vehicle will automatically stop when you reach the distance required to complete the level.",
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "Earn points by picking up and dropping off passengers.",
            "Collect points for completing all the tasks.",
            "Do wheelies and earn additional points.",
            "Drop VIP passengers within a given time by racing your auto or car.",
            "Drive in a rush or survival mode to break your friends' high scores.",
            "To win the game, you must complete all the levels and drop off all the passengers at their destination.",
            "You will lose points if you crash your vehicle or fail to drop off a passenger at the right stop point.",
            "Keep an eye on your fuel level to refill it whenever it is low so you do not miss a garage stop.",
          ],
        },
        {
          title: "Tips and Tricks - Hill Climb Racing",
          items: [
            "Drive slowly but consistently in hilly places.",
            "Take care of the bumps on the way.",
            "Repair your vehicle regularly.",
            "Drop the passenger and his luggage at the right stop point.",
          ],
        },
      ],
      faq: [
        {
          question:
            "How do I unlock all the vehicles in the Hill Climb India racing game?",
          answer:
            "To unlock all the vehicles in Hill Climb India, earn more fake money by playing the game consistently. You can then use them to purchase new vehicles or upgrade your existing ones.",
        },
        {
          question: "What is the best vehicle to use in Hill Climb Racing?",
          answer:
            "The best vehicle in Hill Climb Racing depends on the level you are playing and your drive. Some vehicles are better suited for certain terrains or challenges, so experiment with different vehicles to find the one that works best.",
        },
        {
          question: "How do I beat the levels in Hill Climb India?",
          answer:
            "To beat the levels in Hill Climb India, you must successfully finish each level without crashing your vehicle or running out of fuel. Drive carefully and strategically, and use your money to upgrade your vehicle when necessary.",
        },
        {
          question: "How do I perform stunts in Hill Climb Racing?",
          answer:
            "To perform stunts in Hill Climb Racing, choose the appropriate vehicle, build up speed, utilize the game's physics, find ramps for flips and tilt the vehicle, balance on the back wheels for wheelies, find long ramps for long jumps and adjust the trajectory mid-air, and consider upgrading your vehicle for improved performance.",
        },
        {
          question: "Can I play Hill Climb India Racing offline?",
          answer:
            "You can play Hill Climb India Racing offline by downloading the Hill Climb India app. However, some features may be unavailable when playing offline.",
        },
      ],
      systemRequirements: [
        {
          description:
            "To play Hill Climb India on EpicPlay, your device needs to meet the following minimum requirements:",
          items: [
            {
              title: "PC",
              description: "Windows 7 (64-bit) or a higher version",
            },
            {
              title: "Android",
              description: "Version 4.4 or a higher version",
            },
            {
              title: "iOS",
              description: "Version 8 or a higher version",
            },
          ],
        },
      ],
    },
  },
  pac_man: {
    details: {
      title: "Pac Man - Play Pacman Game Online For Free",
      gameData: [
        {
          description: [
            "Welcome to the Pac-Man game. It is a classic arcade game that has captured the hearts of players for generations. Since it was released, it quickly became an icon in the world of gaming.",
            "In this game, players control a character as they navigate through a maze filled with colorful dots and ghosts. The objective is simple. Eat all the dots in the maze while avoiding the ghosts.",
            "As you progress through the levels, the game becomes more challenging. The ghosts become faster and smarter. In this game strategy and quick reflexes are key to achieving high scores.",
            "This game has a simple yet engaging gameplay. It's catchy music and vibrant visuals have made it a beloved classic in the gaming community.",
            "You will feel nostalgic by playing this game. So are you ready for the challenge? Let the games begin!",
          ],
        },
        {
          title: "About - Pac Man at EpicPlay",
          description: [
            "EpicPlay brings you a Pac-Man game that is suitable for players of all ages. Their version captures the essence of this beloved character and offers an authentic gameplay experience.        ",
            "Pac-Man at EpicPlay is a simple yet engaging game that has stood the test of time. It takes you back to the nostalgic days of arcade gaming. Where you guide the yellow character through mazes filled with dots and ghosts. The objective is to eat all the dots while avoiding the ghost.        ",
            "EpicPlay takes pride in offering the original version of the game. It ensures that players can enjoy the game just as they remember it. The familiar graphics, sounds, and gameplay make you feel nostalgic.        ",
            "EpicPlay’s goal is to provide a platform where players can relive the joy of this iconic game. So, get ready to immerse yourself in the world of Pac-Man.",
          ],
        },
        {
          title: "Gameplay – PacMan Game",
          image: {
            path: "/game-assets/game-images/pac-man-game-online.jpg",
            alt: "Pac Man Game Online",
            title: "Pac Man Game Online",
            caption: "Pac Man Game Online",
          },
        },
        {
          description:
            "In PacMan, your objective is to navigate the character and dodge the ghosts. Let's explore the gameplay with a series of screenshots to understand how to play the game.",
          items: [
            {
              title: "Starting the Game",
              description:
                "When you start the game, you'll be presented with a maze consisting of walls, pellets, power-ups, and ghosts. The player controls the character using arrow keys or touch.",
            },
            {
              title: "Collecting Pellets",
              description:
                "Your main objective is to eat all the small pellets scattered throughout the maze. Move the character around the maze. As you pass over the pellets they will disappear. This adds points to your score.",
            },
            {
              title: "Power Pellets",
              description:
                "When the character eats a power pellet, something special happens: the ghosts turn blue and become weak for a little while. This is your chance to eat the ghosts and earn extra points!",
            },
            {
              title: "Avoiding Ghosts",
              description:
                "The game features several colorful ghosts named Blinky, Pinky, Inky, and Clyde. These ghosts roam the maze and try to catch the character. If a ghost touches the character without you eating a power pellet, you lose a life.",
            },
            {
              title: "Level Progress",
              description:
                "The game consists of multiple levels. Each level features a different maze layout. As you progress in the game, the mazes become more challenging and harder to navigate. The main objective is to complete all the levels and try to get the highest score possible.",
            },
            {
              title: "Game Over",
              description: [
                "At the beginning of the game, you typically start with three lives. You lose a life if a ghost catches you without eating a power pellet.",
                "However, you can earn extra lives by reaching certain point thresholds. If you lose all your lives, it's game over, and you'll have to start from the beginning. You can also watch the ad to resume the game.",
              ],
            },
            {
              title: "High Score",
              description:
                "Pac-Man keeps track of your score throughout the game. The game encourages players to achieve high scores.",
            },
          ],
        },
        {
          title: "How to Play & Rules - Online Pac Man Game",
        },
        {
          subTitle: "How to Play",
          items: [
            {
              title: "Desktop",
              description:
                "Use the arrow keys (up, down, left, right) on your keyboard to move Pac-Man through the maze. You can also use the on-screen controller to play and move.",
            },
            {
              title: "Mobile",
              description:
                'On mobile, use the on-screen virtual controls. You can tap the "Start" or "Pause" button to begin the game.',
            },
          ],
        },
        {
          subTitle: "Rules",
          description:
            "To play the online Pac-Man game, follow these rules and instructions:",

          items: [
            "Guide Pac-Man through the maze, eating all the small pellets while avoiding the ghosts.",
            "Move Pac-Man over the small pellets in the maze to make them disappear. Each pellet you eat adds points to your score.",
            "Try to stay away from the ghost. If you touch any ghost the game will be over.",
            "You’ll have 3 lives to begin the game. If you lose all 3, the game is over.",
          ],
        },
        {
          description:
            "Remember to have fun while playing and try to achieve the highest score possible in the online Pac-Man game. Good luck!",
        },
        {
          title: "Tips and Tricks - Free PacMan Online",
        },
        {
          subTitle: "Tips",
          items: [
            "Take a moment to analyze the maze and plan your path to efficiently eat all the pellets.",
            "Prioritize eating power pellets to turn the ghosts blue and earn extra points by eating them.",
            "Utilize the walls to your advantage by navigating around the maze and escaping from the ghosts.",
            "Observe the ghosts' movement patterns to predict their actions and plan your moves accordingly.",
            "Keep an eye on the ghosts' positions and anticipate their movements to avoid being trapped.",
          ],
        },
        {
          subTitle: "Tricks",
          items: [
            "Lead the ghosts into a corner by strategically positioning yourself. This allows you to eat them easily.",
            "Pretend to move in one direction and quickly change course to confuse the ghosts.",
            "Wait until the ghosts are near a power pellet before grabbing it.",
            "If a ghost is closing in, quickly move in the opposite direction and loop around to confuse and avoid them.",
            "Each ghost has unique characteristics. Learn their behaviors and use them to your advantage.",
          ],
        },
      ],
      faq: [
        {
          question: "How do I play Pac-Man?",
          answer:
            "To play Pac-Man, use the arrow keys (up, down, left, right) on your keyboard or virtual controls on mobile devices to move Pac-Man through the maze and eat all the pellets while avoiding the ghosts.",
        },
        {
          question: "What is the objective of the game?",
          answer:
            "The objective of Pac-Man is to clear each level by eating all the pellets in the maze while avoiding contact with the ghosts. Earn points, reach high scores, and progress through different levels.",
        },
        {
          question: "Are there different levels in Pac-Man?",
          answer:
            "Yes, Pac-Man consists of multiple levels. Each level comes with a different maze layout. The complexity and difficulty of the mazes increase as you advance through the game.",
        },
        {
          question:
            "What are the different types of ghosts in Pac-Man and how do they behave?",
          answer:
            "There are four types of ghosts. Blinky, Pinky, Inky, and Clyde. Each ghost has its own movement pattern and behavior. This makes the game more challenging as they try to catch Pac-Man.",
        },
        {
          question:
            "Are there power-ups or bonuses in the game? How do they work?",
          answer:
            "Yes, there are power pellets in Pac-Man. When Pac-Man eats a power pellet, the ghosts turn blue and become vulnerable. During this time, you can eat the ghosts for extra points.",
        },
        {
          question: "Can I play Pac-Man on different platforms or devices?",
          answer:
            "Yes, Pac-Man can be played on various platforms and devices, including desktop computers, and mobile devices.",
        },
        {
          question: "How do I control Pac-Man's movements?",
          answer:
            "On a desktop, use the arrow keys on your keyboard to control Pac-Man. On mobile devices, use virtual controls displayed on the screen.",
        },
        {
          question:
            "Are there any strategies or tips for achieving high scores in Pac-Man?",
          answer:
            "Some strategies include planning your routes, utilizing power pellets effectively, and studying the ghosts' movement patterns to outsmart them. Refer to the tips and tricks section for more detailed advice.",
        },
        {
          question: "Is there a time limit for each level in the game?",
          answer:
            "No, there is no specific time limit for each level in Pac-Man. Take your time to navigate the maze and make strategic moves.",
        },
        {
          question: "Can I compete with other players or friends in Pac-Man?",
          answer:
            "No, Hextris does not have a multiplayer mode. But you share your score with your friends and compete with them.",
        },
      ],
      systemRequirements: [
        {
          description: [
            "Pac-Man is a game that can be enjoyed on a variety of devices without requiring high specifications. Whether you're playing on a desktop or mobile, the basic system requirements are quite accessible.",
            "Here are the basic system requirements to ensure a smooth gaming experience:",
          ],
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 4.4 or higher",
            "iOS 8 or higher",
          ],
        },
        {
          description:
            "Please note that system requirements may vary slightly depending on the specific platform. It’s advisable to refer to the official game's requirements or consult the platform's recommendations for the best gaming experience.",
        },
      ],
    },
  },
  basket_hop: {
    details: {
      title: "Basketball Game - Basketball Bouncing Game For Free",
      gameData: [
        {
          description: [
            "Sports games hold a special place in the gaming world, offering players the chance to experience the thrill of their favorite sports from the comfort of their own homes. Whether it’s cricket, basketball, or any other sport, these games allow you to immerse yourself in the action.",
            "Basketball, in particular, holds a special place among sports enthusiasts. Remember those carefree days in school when you used to play basketball with your friends? Nostalgia sets in as you recall bouncing the ball and shooting hoops just for the fun of it.",
            "The Basketball game brings back those joyful memories, allowing you to relive the excitement of shooting baskets without any pressure or complex gameplay.",
            "So, what are you waiting for? Get ready to bounce the basketball and aim for the basket!",
          ],
        },
        {
          title: "About - Basket Hop The Basketball Game Online",
          description: [
            "EpicPlay presents a delightful basketball game – Basket Hop. This exciting game challenges players to keep the ball bouncing endlessly. It's a casual and time-pass game that will keep you entertained for hours.",
            "The objective is simple. You need to keep the basketball bouncing on a moving hoop for as long as possible. This tests your reflexes and precision as you tap the screen to control the basketball's movements. The longer you keep the ball bouncing without dropping it, the higher your score goes.",
            "The unique selling point of Basket Hop is its endless gameplay. Unlike traditional basketball games with defined rounds or levels, Basket Hop allows you to keep bouncing the ball until you drop it. This endless mode provides an excellent opportunity to practice and improve your bouncing skills.",
            "What’s more interesting is that Basket Hop is perfect for basketball lovers of all ages. It doesn’t matter whether you're a basketball pro, a casual gamer, or a beginner. This game is designed for you!",
          ],
        },
        {
          title: "Gameplay - Free Basketball Game",
          image: {
            path: "/game-assets/game-images/baskethop-basketball-game.jpg",
            alt: "Basket Hop: Basketball Bouncing Game",
            title: "Basket Hop: Basketball Bouncing Game",
            caption: "Basket Hop: Basketball Bouncing Game",
          },
        },
        {
          description:
            "Let's dive into the gameplay of this exciting basketball game.",
          numberItems: [
            {
              title: "Starting the Game",
              description:
                "To begin, simply tap on the screen. This will take you onto the court, where you can start playing the game.",
            },
            {
              title: "Climbing High",
              description:
                "Keep the basketball bouncing to climb higher. The longer you play without dropping the ball, the higher your score goes!",
            },
            {
              title: "Perfect Baskets",
              description:
                "Aim for the hoops to score extra points. Show off your accuracy and shooting skills by making perfect baskets!",
            },
            {
              title: "Endless Basketball Fun",
              description:
                "There are no limits to this game! Keep the ball bouncing, continue scoring points, and enjoy the endless basketball fun!",
            },
            {
              title: "End the Game",
              description:
                'The game ends when you drop the ball. You can tap "Restart" to start a new game and beat your previous record!',
            },
          ],
        },
        {
          title: "How to Play & Rules - Online Basketball Bouncing Game",
          description:
            "Let's first discuss how to play the basketball bouncing game:",
        },
        {
          subTitle: "How to Play",
          items: [
            {
              title: "Desktop",
              description:
                "Drag the mouse to adjust the angle of the basketball shot. Click the left mouse button to release the basketball and make it bounce toward the hoop.",
            },
            {
              title: "Mobile",
              description:
                "Swipe on the screen to adjust the angle of the basketball shot. Tap the screen to release the basketball and shoot it toward the hoop.",
            },
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "The objective of the game is to score as many baskets as possible by bouncing the basketball into the hoop.",
            "Aim carefully and time your shots to make baskets and earn points.",
            "Each successful shot adds points to your score.",
            "The game ends when you miss a basketball to shoot.",
          ],
        },
        {
          title: "Tips and Tricks - Play an Engaging Basketball game",
          description:
            "Let's explore some valuable tips and tricks to excel in the basketball game:",
        },
        {
          subTitle: "Tips",
          items: [
            "Timing is crucial. Practice your timing to release the basketball at the right moment for a perfect shot.",
            "Adjust your angles carefully using the mouse or swipe gestures on mobile to aim accurately at the hoop.",
            "Keep an eye on the power of your shot. Sometimes a gentle bounce works better than a forceful one.",
            "Aim for the center of the hoop to increase your chances of making successful baskets consistently.",
            "Pay attention to the movement patterns of the moving hoops or obstacles. Understanding these patterns will help you time your shots better.",
          ],
        },
        {
          subTitle: "Tricks",
          items: [
            "Stay focused when the hoop moves or changes positions. Adapt your shots accordingly for a higher success rate.",
            "When the hoop is spinning, wait for the right moment to release the basketball. Time your shot to align with an open section of the hoop.",
            "Bounce the basketball off walls to reach the hoop from different angles.",
            "Practice makes perfect. Keep honing your skills and try new techniques.",
          ],
        },
      ],
      faq: [
        {
          question: "What is Basketball bouncing game?",
          answer:
            "Basketball bouncing game is an online sports game where players control a basketball's movements to keep it bouncing on a moving hoop for as long as possible.",
        },
        {
          question: "Are there different game modes in the basket hop game?",
          answer:
            "No, the basketball bouncing game has an endless gameplay mode, allowing players to bounce the ball continuously without defined rounds or levels.",
        },
        {
          question: "How can I improve my high score in the basketball game?",
          answer:
            "To improve your high score, practice timing your taps and aim for perfect baskets by shooting through the moving hoops.",
        },
        {
          question:
            "Is the Basket Hop game available for different mobile platforms?",
          answer:
            "Yes, Basket Hop is available on both Android and iOS devices for you to enjoy on the go.",
        },
        {
          question: "How can I improve my basketball bouncing skills?",
          answer:
            "Practice regularly, focus on precise taps, and learn to adjust to different bouncing scenarios to enhance your skills.",
        },
        {
          question:
            "What are some tips for avoiding bounces that go out of bounds?",
          answer:
            "To avoid bounces going out of bounds, focus on your shots' power, aim for the center of the hoop, and adapt your shots when the hoop moves or changes positions.",
        },
        {
          question: "What is the time limit for the Basket Hop game?",
          answer:
            "There is no time limit in Basket Hop. Enjoy the endless basketball-bouncing fun!",
        },
      ],
      systemRequirements: [
        {
          description:
            "The Basket Hop - Basketball Bouncing Game on EpicPlay is designed to be accessible and enjoyable on a variety of devices. Here are the basic system requirements to ensure a smooth gaming experience:",
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 5.0 or higher",
            "iOS 10.0 or higher",
          ],
        },
        {
          description:
            "By meeting these system requirements, you can easily play the game on your preferred device and dive into the thrilling world of bouncing games.",
        },
      ],
    },
  },
  "8_ball_pool": {
    details: {
      title: "8 Ball Pool Game Online Play On PC And Mobile For Free",
      description: [
        "8 Ball Pool game online is the most popular multiplayer pool game on the planet. Play with friends or players online and compete against each other in a game of pool. This free multiplayer game allows you to play pool with an immersive gaming experience. ",
        "The game became popular when MiniClip introduced its version in 2008. Since then, it has gained a massive following online and offline. Several online versions are available, but they all demand you to download the game or pay to play. Whereas, EpicPlay's 8 Ball Pool game online lets you play your favorite pool sport for hours without downloading or paying a penny.",
      ],
      gameData: [
        {
          title: "About - 8 Ball Pool Game Online",
          description:
            "8 Ball Pool game online by EpicPlay is a great game to pass the time, especially if you are interested in cue sports games. The gameplay is simple yet engaging with the help of life-like graphics and motions. Striking the balls with the cue stick feels real. The game also gives you a tutorial to help you play and tells you if you have committed a foul. You can play against the computer or another player. Whether you are a seasoned pool player or a newbie, this game will provide you with endless hours of fun and entertainment.",
        },
        {
          title: "Gameplay Of 8 Ball Pool Online Multiplayer",
          description:
            "The gameplay for the 8 Ball Pool game online in EpicPlay simulates the real-life experience of playing pool. The room and the atmosphere make you think you are standing next to a billiards table with a cue stick. You can choose to play either against a computer or against another player. The game against the computer has three levels. You can choose your level depending on your skill and experience. While playing against another player, you can take turns and play. The person needs to be with you to play the multiplayer option. You can play 1vs1 or 2vs2 in the multiplayer option.",
          image: {
            path: "/game-assets/game-images/8-ball-pool-game-online.jpg",
            alt: "8 Ball Pool Game Online",
            title: "8 Ball Pool Game Online",
            caption: "8 Ball Pool Game Online",
          },
        },
        {
          description:
            "As the game starts, you will first be taught the game – how to strike, move the cue ball, and where to click to get the perfect spin. The first player will strike a shot. You can easily aim the stick to the ball you want to pocket, and the game shows you which direction the ball will roll if you hit it from an angle. This makes the game more interesting and fun to play.",
          image: {
            path: "/game-assets/game-images/8-ball-pool-online.jpg",
            alt: "8 Ball Pool Online",
            title: "8 Ball Pool Online",
            caption: "8 Ball Pool Online",
          },
        },
        {
          description:
            "The sound of the cue stick hitting the billiard balls echoes throughout the room as players take turns. As each player lines up their shot, they can feel the tension and excitement building. Every shot in the 8 Ball Pool game online feels like a real game of pool, and the immersive experience will keep you coming back for more.",
        },
        {
          title: "How To Play & Rules - Eight Ball Pool Game Online",
        },
        {
          subTitle: "Game Modes",
          description: [
            "If you are playing alone, you can play against the computer. Three levels are offered in this mode — easy, medium, and hard. Choose the mode based on your expertise and skills.",
            "You can also play the 8 Ball Pool game online with a friend by choosing the multiplayer option. It allows two players to take turns. The rest of the gameplay remains the same.",
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "There are 16 balls, including one cue ball and 15 object balls. The object balls are divided into two categories — solid and striped balls.",
            "The game aims to pocket the 7 balls legally, then the black ball, and then the opponent's 8 balls.",
            "The game can be played with two players or two teams of players or against the computer.",
            "The players take turns shooting the cue ball, and each shot must result in the cue ball making contact with an object ball of the player.",
            "It is a fault if you fail to contact the object ball designated for you.",
            "If a player legally pockets an object ball, they are allowed to shoot again and can continue shooting until they fail to pocket a ball or fault.",
          ],
        },
        {
          subTitle: "Fouls",
          items: [
            "If a player fails to hit any object ball with the cue ball on a shot, it is considered a 'fault', and the other player gets the ball in hand.",
            "If a player pockets the cue ball, it is considered a foul, and the opponent gets to choose where to place the ball and strike.",
          ],
        },
        {
          title: "Tips & Tricks For Playing 8 Ball Pool Browser Game",
          items: [
            "Before you shoot, plan your next shot and the positions of object balls to give yourself the best chance of pocketing them.",
            "The best way to improve aiming is by practicing. Make sure the cue ball aims to spin the object ball in the right direction.",
            "By using spin, you can make the cue ball curve and change its path, which can be very useful in certain situations.",
            "The key to success in an 8 Ball Pool game online is controlling the cue ball. Avoid leaving the cue ball in difficult positions for your next shot, and focus on positioning the cue ball in a favorable position.",
            "Knowing the rules can give you an advantage over your opponent.",
            "The break is the first shot of the game, and it's crucial to get it right. Try experimenting with different positions and power levels to find a break that works for you.",
            "Don't rush your shots. Remain calm and focused, even when things aren't going your way.",
            "Watching other players and professional matches can help you learn new techniques and strategies.",
          ],
        },
      ],
      faq: [
        {
          question: "How do I aim better in the 8 Ball Pool?",
          answer:
            "Tap on the cue ball and adjust the spin on the ball of your choice. Once done, tap again and drag the stick away to adjust the intensity of the strike. Once satisfied, slowly release the cue stick to follow the ball to the pocket.",
        },
        {
          question: "Can I play 8 Ball Pool as a guest without signing in?",
          answer:
            "Yes, you can enjoy 8 Ball Pool as a guest player without the need to create an account. Simply choose the guest option to get started.",
        },
        {
          question: "How do I break in the 8 Ball Pool game online?",
          answer:
            "By choosing your spot, checking position, adjusting power, and focusing on hitting at the center. That way you can break in the 8 Ball Pool game online.",
        },
        {
          question: "How do I win in an 8 Ball Pool every time?",
          answer:
            "Although it is unlikely to win every time, unless you are a skilled professional, practicing, playing strategically, controlling the cue ball, and staying positive can help you win the 8 Ball Pool game.",
        },
        {
          question: "Can I play 8 Ball Pool offline?",
          answer:
            "You can play 8 Ball Pool offline by downloading it on your desktop or mobile device. You can also play it on the billiards pool table with your friends.",
        },
        {
          question: "How do I challenge friends in the 8 Ball Pool?",
          answer:
            "You can challenge friends in the 8 Ball Pool by choosing a 1-vs-1 game mode.",
        },
      ],
      systemRequirements: [
        {
          description:
            "To ensure a seamless gaming experience on EpicPlay, your device must meet the following minimum requirements:",
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 4.4 or higher",
            "iOS 8 or higher",
          ],
        },
      ],
    },
  },
  zombvival: {
    details: {
      title: "Zombie Game Online - Play Zombie Attack Game on PC",
      gameData: [
        {
          description: [
            "Are you ready to dive into the thrilling world of zombie games? Zombie enthusiasts, brace yourselves for an adrenaline-pumping experience! The zombie games genre has taken the gaming community by storm, becoming immensely popular across the globe. So, what's the secret behind their widespread appeal? Let's find out.",
            'The popularity of zombie games has skyrocketed in recent years. It is mainly due to the success of hit zombie movies like "World War Z," "Train to Busan," and the iconic "Resident Evil" series. These movies have amassed a massive fan base, attracting countless individuals to explore the captivating world of zombie games.',
            "Now, you might be curious about what makes these games so exciting. It’s the excitement you feel while fighting against large groups of zombies. Imagine yourself in a world destroyed by disaster, armed with powerful weapons to defend yourself. You must survive against never-ending waves of scary, walking-dead creatures. As you navigate through treacherous paths, you'll feel a constant sense of tension and fear.",
            "So, are you ready to go on an adventure in our zombie game world? Join us now, and let the zombie apocalypse begin!",
          ],
        },
        {
          title: "About - Free Zombie Attack Game on EpicPlay",
          description: [
            "Are you excited to know about the Zombie Attack Game that will keep you on the edge of your seat? Look no further than EpicPlay's zombie attack game. It's an absolute hit!",
            "Inspired by popular zombie games found across the web, Zombvival offers a unique and enjoyable experience. EpicPlay’s mission is to create a game that is easy to pick up and play, catering to players of all skill levels. This game guarantees endless fun for zombie game enthusiasts.",
            "In Zombvival, you'll find yourself in a world overrun by zombies. Your objective is simple: survive for as long as you can against the zombies. You’ll walk through different environments, each comes with its own challenges and surprises.",
            "This game allows players of all skill levels to jump right in and start having a blast. It's designed to provide quick, fast-paced action that keeps you engaged and excited throughout the entire game.",
            "Start playing Zombvival now and get ready for some crazy zombie action!",
          ],
        },
        {
          title: "Gameplay - Zombie Shooting Games",
          description:
            "Let's take a look at the gameplay and learn how to play this exciting game.",
          image: {
            path: "/game-assets/game-images/free-zombie-game-online.jpg",
            alt: "Free Zombie Game Online",
            title: "Free Zombie Game Online",
            caption: "Free Zombie Game Online",
          },
        },
        {
          noTag: true,
          subTitle: "Starting the Game",
          description:
            "As you enter the game, you'll encounter instructions displayed on the main screen. Simply tap on the screen to initiate your thrilling zombie-shooting adventure. ",
        },
        {
          noTag: true,
          subTitle: "Storyline",
          description:
            "As the game begins, you'll find yourself in a world devastated by a zombie apocalypse. Your objective is to survive by fighting off waves of zombies. As you play the game, the story will unfold, and you will learn more about the zombie outbreak. The game will reveal secrets and mysteries surrounding the creation of these zombies.",
        },
        {
          noTag: true,
          subTitle: "Character and Weapons",
          description:
            "At the start, your character will be equipped with a basic weapon, a knife, at the start. As you advance, you can unlock more powerful weapons by earning in-game rewards. Choose the most suitable weapon for each situation you encounter.",
        },
        {
          noTag: true,
          subTitle: "Keep Moving",
          description:
            "To stay alive, it's important to keep moving within the game. Avoid remaining in one place for too long, as the zombies might overpower you. Use various weapons wisely to increase your chances of survival. Strategically plan your moves and use them to the best of your ability in order to stay alive.",
        },
        {
          noTag: true,
          subTitle: "Game Over",
          description:
            "If the zombies manage to catch you or your health reaches zero, it will result in the end of the game. So be Alert, and do whatever it takes to avoid seeing the game over screen. Strive to survive as long as possible.",
        },
        {
          description:
            "Equip your weapons and immerse yourself in the action-packed world of Zombie Shooting Games!",
        },
        {
          title: "How to Play & Rules - Online Zombie Game",
          description:
            "Do you want to learn the rules and how to play the game? Here is a breakdown for you!",
        },
        {
          subTitle: "How to Play:",
          items: [
            {
              title: "Desktop",
              description:
                "To control your character, you can use either the arrow keys on your keyboard or the W, A, S, and D keys. Alternatively, you can click and hold the mouse in the desired direction to move. Stand still to attack the zombies. If you want to switch weapons, simply click on the weapon located at the side.",
            },
            {
              title: "Mobile",
              description:
                "To control your character on mobile, utilize the virtual joystick displayed on the screen. Attacking the zombies requires you to remain stationary. If you wish to switch your weapon, simply tap on the weapon icons.",
            },
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "Your main objective is to survive in a world infested with zombies.",
            "Eliminate zombies by attacking them with your weapons.",
            "Be careful not to get caught by the zombies or let them harm you.",
            "Complete each level by killing zombies to progress to the next level.",
          ],
        },
        {
          title: "Tips and Tricks - Free Zombie Game Online",
        },
        {
          subTitle: "Tips:",
          items: [
            "Constantly move to avoid being surrounded by zombies. Staying in one place makes you an easy target.",
            "Stay vigilant and be ready to react by keeping an eye on all directions from where zombies might approach.",
            "Use obstacles to your advantage. These objects can be really helpful in dealing with large groups of zombies or creating distractions.",
            "Upgrade your weapons as you progress to increase their power against tougher zombies.",
            "Collect skulls and health packs. Skulls will help you progress through levels, and health packs will help you survive longer.",
          ],
        },
        {
          subTitle: "Tricks:",
          items: [
            "When there are many zombies together, try to attack them all at once.",
            "Confuse groups of zombies by moving in a circular motion around them. This will make it harder for them to attack you.",
            "Engage the zombies in short bursts and quickly move away to a safe distance. Repeat this strategy to avoid getting overwhelmed.",
            "Pay attention to how different types of zombies move and attack. Understanding their behavior can give you an advantage.",
          ],
        },
      ],
      faq: [
        {
          question: "What is a zombie game?",
          answer:
            "A zombie game is a type of video game where players battle against undead creatures known as zombies.",
        },
        {
          question: "What is the objective of a zombie survival game?",
          answer:
            "The objective of a zombie survival game is to stay alive by fighting off and surviving against waves of zombies in a post-apocalyptic world.",
        },
        {
          question: "How do you typically play a zombie survival game?",
          answer:
            "In a zombie survival game, players navigate through dangerous environments and use various weapons to defend themselves against zombies.",
        },
        {
          question:
            "Are there different types of zombies in the game, and do they have different abilities?",
          answer:
            "Yes, zombie games often feature different types of zombies with unique abilities. Some zombies may be faster, stronger, or have special attacks.",
        },
        {
          question:
            "Are there any resources or items that players need to collect or manage in the game?",
          answer:
            "Yes, players usually need to collect resources like health packs and other useful items to survive and progress in the game.",
        },
        {
          question:
            "Can you build or fortify shelters in a zombie survival game?",
          answer:
            "It depends on the specific game. Some zombie survival games may include elements of base-building or fortification where players can create and secure shelters to protect themselves from zombies.",
        },
        {
          question:
            "Are there any special abilities or skills that players can acquire to help them survive?",
          answer:
            "Many zombie survival games offer skills where players can acquire new skills. They can enhance their combat abilities or unlock special powers to aid in their survival.",
        },
        {
          question:
            "Is there an end goal or a way to win a zombie survival game, or is it an open-ended experience?",
          answer:
            "This game has open-ended gameplay where the objective is to survive for as long as possible against increasing challenges.",
        },
      ],
      systemRequirements: [
        {
          description:
            "Zombvival is an exciting game that can be enjoyed on various devices without requiring high specifications. To ensure a smooth gaming experience, here are the basic device requirements:",
        },
        {
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 4.4 or higher",
            "iOS 8 or higher",
          ],
        },
      ],
    },
  },
  space_invader: {
    details: {
      title: "Space Invader: Play Epic Space Shooter Game Free Online",
      gameData: [
        {
          description: [
            "Welcome to the world of space shooter games! These exciting arcade games are all about the wonders of outer space and are enjoyed by people of all ages. With their enduring popularity, space games have captured the hearts of gamers for a long time.",
            "Let me tell you a bit about the space game genre. It's a cool category of games where you get to be a spaceship pilot and explore the vastness of outer space. You'll encounter lots of challenges along the way. Your main goal is to shoot down enemies that come your way. It's like being a hero in your space game adventure!",
            "Let's talk about one of the best space shooter games ever. Yes, you guessed it right. It’s Space Invader! It's a classic arcade shooting game that has been around for a long time. Can you believe it was made way back in 1978? That's even before we were born! But guess what? Even today, players of all ages love playing this game.",
            "Space Invader is an infinity-shooting galaxy war. The game keeps getting faster and more intense as you go. The feeling of making your best score and becoming the space shooting champion is simply out of this world!",
            "Are you ready to become a space hero and shoot some alien spaceships? Let's go on a space adventure together! Enjoy the excitement of space shooting and have a great time!",
          ],
        },
        {
          title: "About - Space Invader, a Space Shooter Arcade Game",
          description: [
            "EpicPlay came up with a fun and exciting game to take you on an exciting journey! If you love shooting arcade games, this space shooter game is just for you.",
            "EpicPlay developed this game because we wanted to bring all the fun of the original Space Invader arcade game to your fingertips. The game is designed to be extremely fun, with awesome gameplay and sounds that make you feel like you're really in a space battle.",
            "In Space Invader, you fight against alien spaceships and deadly meteors. It's like being the star of our sci-fi adventure. The goal is to defend your spaceship by shooting down alien spaceships that come your way.",
          ],
        },
        {
          title: "Gameplay - Space Shooter Galaxy Game",
          image: {
            path: "/game-assets/game-images/space-invader-space-shooter-game.jpg",
            alt: "Space Invader: Space Shooter Game",
            title: "Space Invader: Space Shooter Game",
            caption: "Space Invader: Space Shooter Game",
          },
        },
        {
          description:
            "Are you ready to fight against alien spaceships and protect your ship? To help you better understand this game, let's dive into the gameplay and see how this space shooter game works!",
          numberItems: [
            {
              title: "Game Start",
              description:
                "When you open the game, you'll see the title screen. Tap to start and begin your space battle.",
            },
            {
              title: "The Player's Ship",
              description:
                "Once the game starts, you'll control a small spaceship at the bottom of the screen. Move it left or right by dragging it on the screen.",
            },
            {
              title: "Battling Enemies",
              description:
                "Alien spaceships will come and move down from the top of the screen toward your ship. Your mission is to stop them before they kill you.",
            },
            {
              title: "Shooting",
              description:
                "To shoot the alien spaceships and meteors, simply drag your ship. Your ship will fire laser beams to destroy them.",
            },
            {
              title: "Game Over",
              description:
                "Be careful not to let the alien spaceships reach the bottom of the screen or its game over. But don't worry, you can always start again!",
            },
          ],
        },
        {
          title: "How to Play and Rules - Space Shooter on PC and Mobile",
          description:
            "Let us discuss how to play the Space Shooter game on both PC and Mobile platforms:",
        },
        {
          subTitle: "How to Play",
          items: [
            {
              title: "PC",
              description:
                "Use the arrow keys or W, A, S, and D keys to move the spaceship in different directions in this space shooter game. When you move the spaceship it will shoot lasers.",
            },
            {
              title: "Mobile",
              description:
                "Tap and drag the spaceship to move it on your mobile device. While pulling the spaceship, it will shoot lasers against the alien spaceships and meteors.",
            },
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "Your objective is to defeat the alien spaceships by shooting them with your lasers.",
            "Avoid getting hit by alien spaceships and meteors. Getting hit will cause you to lose a life.",
            "Destroy all the enemy spaceships before they reach the bottom of the screen; otherwise, the game will be over.",
            "Each time you shoot an alien spaceship, you earn points. Try to score as many points as possible to achieve the highest score possible.",
            "As the game progresses, the enemy spaceships may become faster and more aggressive.",
          ],
        },
        {
          title:
            "Tips and Tricks for Scoring High in Space Invader: Space Shooter Game",
          description:
            "Let us start discussing tips about the Space Shooter games first:",
        },
        {
          subTitle: "Tips",
          items: [
            "Aim at the target by aligning your spaceship with the enemy while flying.",
            "Avoid getting hit by an alien spaceship by moving your ship away from its attacks.",
            "Keep moving constantly to avoid staying in one place and becoming an easy target.",
            "Observe and learn the movement patterns of different enemy ships.",
            "Be cautious near the edges of the screen. Sometimes alien spaceships may appear there unexpectedly. This can catch you off guard.",
          ],
        },
        {
          subTitle: "Tricks",
          items: [
            "Maintain a safe distance from enemy ships while shooting to reduce the risk of getting hit.",
            "Swing your ship while attacking to dodge incoming enemy attacks and protect yourself. Practice zig-zag movements while attacking enemies.",
            "If hitting an alien spaceship is challenging, focus on staying safe. Keep your distance from it or let it pass instead of risking yourself. Your survival is more important than taking unnecessary chances.",
            "Train your reflexes to respond swiftly to sudden changes in the game. Quick reactions can save you from unexpected dangers.",
            "Position your spaceship near the center of the screen. This gives you a better view of the action and more time to react to threats.",
          ],
        },
        {
          title: "System Requirements for Space Shooter Game",
          description: [
            "Space Invader game is designed to be accessible and enjoyable for everyone, regardless of their device specifications. They do not require high-end graphics or sound, so they can be played on most browsers.",
            "To have a smooth gaming experience on EpicPlay, you only need to meet the basic device requirements.",
          ],
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 4.4 or higher",
            "iOS 8 or higher",
          ],
        },
      ],
      faq: [
        {
          question: "How do I control the spaceship in Space Invader?",
          answer:
            "To move your spaceship, use the arrow keys or A, W, S, and D keys on your keyboard. The spaceship shoots automatically. You only need to focus on moving it left or right to dodge the enemy.",
        },
        {
          question: "How do I shoot in Space Invader?",
          answer:
            "Shooting is automatic in Space Invader. Your spaceship continuously fires bullets toward the enemy invaders without needing any specific button to press.",
        },
        {
          question: "What is the objective of Space Invaders?",
          answer:
            "The objective is to defeat waves of enemy invaders coming from the top of the screen. Destroy as many invaders as possible while avoiding their bullets.",
        },
        {
          question:
            "Are there power-ups or special abilities in Space Invaders?",
          answer:
            "In the classic version, there are usually no power-ups. The focus is on shooting. Some versions may add new features or power-ups.",
        },
        {
          question: "How do I earn points in Space Invader?",
          answer:
            "You earn points by shooting down enemy invaders. Each invader you destroy gives you points. The more you defeat, the higher your score.",
        },
        {
          question:
            "Are there different types of enemy invaders in Space Invaders?",
          answer:
            "Yes, there are different invaders. Multiple rows with unique designs and behaviours. As you progress, invaders may become faster and more challenging.",
        },
        {
          question:
            "Can I play Space Invader with friends or in multiplayer mode?",
          answer:
            "Original Space Invader is a single-player, but modern versions may offer multiplayer modes.",
        },
        {
          question: "Are there different difficulty levels in Space Invaders?",
          answer:
            "Yes, many versions have easy, medium, and hard modes. Each level offers varying enemy behavior and challenge.",
        },
        {
          question: "Is Space Invader available on different platforms?",
          answer:
            "Yes, Space Invader is on various platforms like arcade, consoles, PCs, and mobile devices.",
        },
        {
          question: "Can I customize or modify the gameplay in Space Invader?",
          answer:
            "Options vary by version. Some versions allow options like speed, life, graphics, or sound.",
        },
      ],
    },
  },
  traffic_rider: {
    details: {
      title: "Traffic Rider Game - Bike Racing Game Online",
      gameData: [
        {
          description: [
            "Are you ready to enter the world of bike racing games? These games have become incredibly popular over the years, attracting a large number of players worldwide.",
            "In these games, you become a virtual rider, taking on thrilling challenges and racing motorbikes against time and other players. You can choose from a wide range of bikes, each bike comes with its unique features and abilities. Your goal is to navigate through different tracks and reach the finish line as quickly as possible.",
            "The popularity of bike racing games can be attributed to several factors. It provides a thrilling and exciting experience for players who enjoy high speeds. Moreover, the realistic graphics, sound effects, and physics simulation in these games make players feel like they are riding an actual motorcycle.",
            "Bike racing games give you a feeling of freedom and the chance to explore vast virtual worlds with breathtaking views, busy cities, and challenging paths. You can go on exciting adventures and find surprises hidden in the game.",
            <>
              Whether you're a casual gamer looking for some quick fun or a
              hardcore enthusiast seeking a thrilling and immersive experience,
              bike{" "}
              <a href="https://www.epicplay.in/category/racing-games">
                racing games
              </a>{" "}
              have something to offer everyone.
            </>,
            "So, gear up, hop on your virtual bike, and get ready to experience the exciting gameplay of bike racing like never before!",
          ],
        },
        {
          title: "About - Traffic Rider Moto Bike Game 🏍️🚧🛵🚓",
          description: [
            'The game "Traffic Rider" developed by EpicPlay has become a favorite among players all around the world. It is a super cool moto bike game that will get your heart racing! In this game, you\'ll experience the excitement of riding through busy roads with lots of traffic.',
            "Here are some key features of the game:",
          ],
          items: [
            {
              title: "Realistic Riding Experience",
              description:
                "Enjoy a lifelike feeling as you ride through traffic-packed roads with stunning graphics.",
            },
            {
              title: "Wide Selection of Bikes",
              description:
                "Choose from a variety of bikes, each with its unique design and abilities.",
            },
            {
              title: "Thrilling Challenges",
              description:
                "Test your skills and progress in the game by taking on exciting challenges.",
            },
            {
              title: "Dynamic Time and Lighting",
              description:
                "Experience different times of the day, with dynamic lighting effects and increased challenges during night rides.",
            },
            {
              title: "Immersive Sound Effects",
              description:
                "Feel the rush as you hear realistic sounds of engines, tires screeching, and horns honking.",
            },
          ],
        },
        {
          title: "Gameplay - Traffic Rider Game Online",
          description:
            "In the Traffic Rider game, you experience the thrill of riding motorcycles in a virtual world. If you're interested in playing Traffic Rider but uncertain about how the gameplay works, here's a breakdown of the game mechanics:",
          image: {
            path: "/game-assets/game-images/traffic-rider-moto-bike-game.jpg",
            alt: "Traffic Rider: Variety of Moto Bikes",
            title: "Traffic Rider: Variety of Moto Bikes",
            caption: "Traffic Rider: Variety of Moto Bikes",
          },
          items: [
            {
              title: "Select Different Bikes",
              description:
                "You can choose from a variety of bikes, each with its own unique styles and features. Pick the one you like the most to start your adventure.",
            },
            {
              title: "Ride on Various Roads",
              description:
                "Get ready to ride on different types of roads, from busy city streets to open highways. Each road presents its own set of challenges and obstacles.",
            },
            {
              title: "Dodge Obstacles",
              description:
                "As you ride, you will encounter various obstacles such as road barriers. Use your skills to dodge them and avoid collisions.",
            },
            {
              title: "Collect Power-ups",
              description:
                "As you progress through the game, collect power-ups to enhance your gameplay. These power-ups can be used to increase the speed of your bike.",
            },
          ],
        },
        {
          image: {
            path: "/game-assets/game-images/traffic-rider-bike-racing-game.jpg",
            alt: "Traffic Rider: Bike Racing Game",
            title: "Traffic Rider: Bike Racing Game",
            caption: "Traffic Rider: Bike Racing Game",
          },
        },
        {
          title: "How to Play & Rules - Bike Riding Game",
        },
        {
          subTitle: "How to play",
          items: [
            {
              title: "Desktop",
              subItems: [
                "Press the up arrow key to accelerate your bike.",
                "Use the down arrow key to slow down or stop by releasing the up arrow key.",
                "Use the left arrow key to steer your bike to the left.",
                "Use the right arrow key to steer your bike to the right.",
              ],
            },
            {
              title: "Mobile",
              subItems: [
                "Manually swipe the bike to the left or right to steer it.",
                "To accelerate, tap and hold the screen.",
                "Release your finger from the screen to slow down.",
              ],
            },
          ],
        },
        {
          subTitle: "Rules",
          description:
            "To enjoy the bike riding game to the fullest and stay safe, remember these important rules:",
          items: [
            "Avoid crashing into other vehicles or obstacles on the road. Collisions can slow you down or even end your ride.",
            "Stay on the designated road and avoid deviating from the track. Going off-track may lead to penalties or game over.",
            "Pay attention to the flow of traffic and be cautious of other vehicles. Look out for cars, trucks, or any moving objects that could obstruct your path.",
            "Observe the speed limits indicated in the game. Going too fast or too slow might affect your performance or progress.",
            "Try to score as high as possible.",
          ],
        },
        {
          description:
            "Follow the above rules to enjoy the thrill of the ride.",
        },
        {
          title: "Tips and Tricks - Traffic Raider Moto Bike Game",
        },
        {
          subTitle: "Tips",
          items: [
            "Select a bike that suits your style of play. Different bikes may have varying speeds, acceleration, or handling capabilities, so pick one that aligns with your preferences.",
            "Take advantage of lane splitting, which means riding between vehicles in traffic. This can help you gain extra points.",
            "Keep an eye out for power-ups on the road. They can provide temporary boosts like extra speed, giving you an advantage during the game.",
            "Focus on completing objectives to earn extra rewards and unlock new bikes or upgrades.",
          ],
        },
        {
          subTitle: "Tricks",
          items: [
            "When overtaking other vehicles, choose the right moment to pass. Look for gaps in traffic and make your move when it's safe to do so.",
            "Observe traffic patterns and anticipate the movements of other vehicles. This will help you plan your actions and avoid collisions.",
            "Utilize the rewards and points you earn to upgrade your bike's performance. Enhancements to speed, acceleration, and handling can make a big difference in your gameplay.",
            "Master smooth controls by maintaining a steady grip and avoiding sudden movements. This will help you maintain control and prevent crashes.",
          ],
        },
      ],
      faq: [
        {
          question: "How do I control the motorcycle in Traffic Rider?",
          answer:
            "On the desktop, use arrow keys to accelerate, slow down, and steer the bike. On mobile, swipe to steer the bike and tap and hold the screen to accelerate.",
        },
        {
          question: "Can I customize my motorcycle in Traffic Rider?",
          answer:
            "Yes, you can customize your motorcycle. Earn points to unlock new bikes and upgrade their appearance and performance.",
        },
        {
          question: "How can I earn more points in Traffic Rider?",
          answer:
            "To earn more points, ride at maximum speed and collect power-ups on the road.",
        },
        {
          question: "Can I upgrade my motorcycle to Traffic Rider?",
          answer:
            "Absolutely! Use the points you earn to unlock new motorcycles. Each bike has different speed and handling characteristics.",
        },
        {
          question: "Are there different locations or maps in Traffic Rider?",
          answer:
            "Currently, Traffic Rider offers rides through busy city streets and highways. ",
        },
        {
          question: "How can I improve my scores in Traffic Rider?",
          answer:
            "Practice smooth controls, avoid collisions with vehicles and obstacles, and ride faster to improve your scores.",
        },
        {
          question: "Can I compete with other players in Traffic Rider?",
          answer:
            "No, currently Traffic Rider only features an online individual game. However, you can compare your score with your friends to showcase your riding skills.",
        },
      ],
      systemRequirements: [
        {
          description:
            "The Traffic Rider bike race game is designed to be accessible and enjoyable on a variety of devices. To enjoy the exciting experience of playing Traffic Rider, make sure your device meets the following system requirements:",
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 5.0 or higher",
            "iOS 8.0 or higher",
          ],
        },
        {
          description:
            "By ensuring that your device meets these system requirements, you can fully immerse yourself in the fast-paced world of Traffic Rider and enjoy a smooth and exciting gaming experience.",
        },
      ],
    },
  },
  snake_and_ladder: {
    details: {
      title: "Snakes & Ladders - Play Snake Ladder (Sap Sidi) Online For Free",
      gameData: [
        {
          description: [
            "Are you ready to know about a Snakes & Ladders game that is also known as Sap Sidi? Sap Sidi is an ancient and popular game that has been enjoyed by people of all ages for centuries.",
            "This board game has 100 squares. Each square is hiding different challenges and shortcuts. The goal of the game is simple. You need to reach the final square before your opponent wins the game.",
            "Snakes & Ladders is a luck-based game. This makes it accessible and enjoyable for players of all skill levels. All you need to do is roll the dice. With each roll, you will either climb a ladder, advance several squares, or slide back down. This makes the player entertained for a long time.",
            "Playing Snakes & Ladders online offers a convenient way to experience this timeless game from the comfort of your own home. So, start playing today, and let the dice decide your fate!",
          ],
        },
        {
          title: "Origin of Snakes and Ladder Game",
          description: [
            "The game we know today as Snakes and Ladders has a fascinating history that traces its roots back to ancient India. It was originally called Mokshapat or Moksha Patamu. It is believed that the game was invented by Saint Gyandev in the 13th century AD. ",
            'During the British colonial rule in India, the game caught the attention of the colonial rulers. They introduced it to England in the 19th century. As it made its way to England, the game underwent some changes and was renamed "Snakes and Ladders". ',
            'The game gained popularity in England. It eventually made its way to the United States in 1943, where it was introduced as "Chutes and Ladders." The game became a beloved pastime for children and families.',
            "Throughout its history, Snakes and Ladders have been known by various names in different regions. In Andhra Pradesh, it is called Vaikunthapali or Paramapada Sopana Patam, while in Hindi, it is known as Saanp aur Seedhi or Mokshapat. In Tamil Nadu, the game is called Parama padam and is often played during the Vaikuntha Ekadashi festival as a way to stay awake throughout the night. In Bengali-speaking regions, it is referred to as Shap Shiri or Shapludu. ",
            "Snakes and Ladders have changed and grown over time, but people still love it because it's simple and exciting. Anyone can play, no matter how old they are. It reminds us of where it came from and how it has connected different cultures around the world.",
          ],
        },
        {
          title: "About - Snake Ladder Board Game Online",
          description: [
            "EpicPlay has created a Snake Ladder Board Game Online to let you experience the classic Sap Sidi game in a traditional format. The best part? You can enjoy it on any device without the need to download a game app!",
            "You can have the convenience of playing it right in your browser without worrying about storage space or compatibility issues. You just simply need to open your favorite web browser, visit our website, and start playing it right away!",
            "In this game, you need to roll the dice and watch your game piece move across the board. You will have to navigate through the snakes and ladders and try to advance quickly. Sounds simple? The challenge is that you have the chance to encounter a snake and slide back down. So, it's a game of chance and strategy that keeps you on the edge of your seat.",
            "So, why wait? Enjoy the game's simplicity. Get ready for an unforgettable journey filled with snakes, ladders, and endless entertainment!",
          ],
        },
        {
          title: "Gameplay - Snake and Ladders Online",
          image: {
            path: "/game-assets/game-images/snake-and-ladder-game-online.jpg",
            alt: "Snake and Ladder Game Online",
            title: "Snake and Ladder Game Online",
            caption: "Snake and Ladder Game Online",
          },
        },
        {
          description:
            "You must be excited to play Snake and Ladders Online, where you can compete against bots or challenge other players from around the world. To help you better understand this game, let's dive into the gameplay and see how this game works!",
        },
        {
          numberItems: [
            {
              title: "Start the game",
              description:
                "Once you start the game, you'll be given 2 options to choose from. Whether to play with the AI bot or PVP. Take a moment and decide which option you want to choose.",
            },
            {
              title: "Click on the play button",
              description: [
                "After deciding which option to choose from, click on the play button. You will be given the option to select the color of your piece from red, yellow, green, and blue.",
                "Once you start the game, you'll see a colorful game board with 100 blocks. Each block represents a different square. ",
              ],
            },
            {
              title: "Roll the dice",
              description:
                "To move forward, you'll need to roll the dice. Just tap on the dice icon. The number that appears on the dice determines the number of blocks you move on the game board. This is purely luck based. The game has a turn-based nature. This ensures that everyone gets a fair chance.",
            },
            {
              title: "Navigating Snakes and Ladders",
              description:
                "As you move across the game board, you may encounter snakes and ladders. Landing on a snake's head will cause you to slide down to a lower block. Landing at the base of a ladder will allow you to climb up to a higher block.",
            },
            {
              title: "Reaching the Finish Line",
              description:
                "The objective of the game is to be the first player to reach block number 100. Continue rolling the dice until you reach the finish line. Once you reach or exceed block number 100, you have won the game!",
            },
          ],
        },
        {
          title: "How to Play & Rules - Online Snake & Ladder Board Game",
          subTitle: "How to play:",
          items: [
            {
              title: "Desktop",
              description:
                "To play the game on your desktop, left-click the virtual dice displayed on the screen. The game will automatically move your game piece on the game board.",
            },
            {
              title: "Mobile",
              description:
                "To move the dice on your mobile, tap the virtual dice displayed on the screen. The game will automatically move your game piece on the game board.",
            },
          ],
        },
        {
          subTitle: "Rules:",
          items: [
            "The game is played on a 100-block board. Each block is numbered from 1 to 100.",
            "The objective is to be the first player to reach or exceed block number 100.",
            "Players take turns rolling the dice and moving their game pieces accordingly.",
            "The number rolled on the dice determines the number of blocks the player moves.",
            "If a player lands on the base of a ladder, they climb up to the higher block.",
            "If a player lands on the head of a snake, they slide down to the lower block.",
            "The game follows a turn-based system, where players take their turns one by one.",
            "If a player rolls a 6, they get an additional turn.",
            "The player who reaches the finish line first is declared the winner.",
            "The Snake and Ladder board game can be played with 2 players.",
            "Each player can choose a different color for their game piece. They can choose from red, yellow, blue, or green.",
          ],
        },
        {
          title: "Tips and Tricks - Sap Sidi Online",
          description:
            "Although Snake and Ladder is a luck-based game, there are a few simple tips that you can keep in mind to improve your chances of winning.",
          items: [
            "Pay attention to the game and make sure not to miss your turn. This will help you make the most of each opportunity.",
            "Watch the timer and make sure to take your turns within the allotted time.",
            "Keep a close eye on the game board and take note of the locations of snakes and ladders. This awareness can help you plan your moves better and avoid potential setbacks.",
            "Consider the potential risks and rewards of each move. Evaluate whether it's worth taking a chance on a ladder or if it's safer to avoid snakes.",
            "Stay patient and grab opportunities when they come your way.",
            "Assess the positions of other players and adjust your moves accordingly.",
          ],
        },
        {
          description:
            "Keep these tips in mind as you play Sap Sidi online to have a great time with your fellow players!",
        },
      ],
      faq: [
        {
          question:
            "How many players can participate in a game of Snake and Ladders?",
          answer: "Snake and Ladders can be played with 2 or more players. ",
        },
        {
          question: "What is the objective of Snake and Ladders?",
          answer:
            "The objective is to be the first player to reach or exceed block number 100 on the game board. ",
        },
        {
          question: "How is the game board set up?",
          answer:
            "The game board consists of 100 blocks, numbered from 1 to 100, with snakes and ladders placed at various positions. ",
        },
        {
          question: "How do you determine who goes first in Snake and Ladders?",
          answer:
            "The starting player is usually determined by a random selection, such as rolling the dice or using a spin wheel. ",
        },
        {
          question:
            "What are the rules for moving your game piece on the board?",
          answer:
            "Players take turns rolling the dice and move their game piece according to the number rolled. The movement is determined by the number on the dice. ",
        },
        {
          question:
            "What happens when you land on a ladder in Snake and Ladders?",
          answer:
            "When you land on the base of a ladder, you climb up to the higher block, advancing your position on the board. ",
        },
        {
          question:
            "Can you skip over a ladder or snake when moving your game piece?",
          answer:
            "No, you must follow the path of the board. If you land on the head of a snake, you slide down to the lower block, moving backward on the board. ",
        },
        {
          question: "How do you win a game of Snake and Ladders?",
          answer:
            "The player who reaches or exceeds block number 100 first is declared the winner of the game.",
        },
      ],
      systemRequirements: [
        {
          description:
            "Snakes & Ladders is a classic board game that can be enjoyed on a variety of devices. Here are the basic system requirements for playing Snakes & Ladders:",
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 4.4 or higher",
            "iOS 8 or higher",
          ],
        },
        {
          description:
            "Please note that these are basic requirements, and the game may run on devices that meet or exceed these specifications.",
        },
      ],
    },
  },
  need_for_speedsters: {
    details: {
      title: "Play Free Car Racing Game Online for PC and Mobile",
      gameData: [
        {
          description: [
            "Car racing games have been loved by players for a long time. They are one of the most played categories in the gaming era. They are fast, thrilling, and full of challenges. This keeps people coming back to play them more.",
            'Car racing games are special to gamers because they provide a thrilling experience. The popularity of this genre has also been influenced by blockbuster movies like "Fast and Furious", as well as exciting online content showcasing the adrenaline-pumping world of car racing. The cool cars, powerful nitro boosts, and high-speed action have made car racing games more popular.',
            "So, don't wait any longer – jump into the fast-paced world of car racing! Get behind the wheel, show off your skills, and become the ultimate car racing champion!",
          ],
        },
        {
          title: "About - Car Racing Online",
          description: [
            "EpicPlay specially designed Need for Speedsters to help you enjoy a thrilling car racing game online. If you are a fan of speed and adrenaline, this game is custom-made for you. It’s an exciting game that’s available online and completely free to play on any device.",
            "In a world where many racing games require payment to access the full experience, this game doesn’t require you to spend a single penny to enjoy the high-speed action of this racing adventure.",
            'Whether you prefer playing on your computer, tablet, or smartphone, Car Racing Online offers an incredible racing experience without any cost. Finding high-quality car racing games for PC that are both free and offer great gameplay can be quite a challenge. However, the search for racing enthusiasts ends with "Need for Speedsters" developed by EpicPlay!',
            "Get ready to immerse yourself in the world of Car Racing Online. So, are you ready for the ultimate racing experience? Let the race begin!",
          ],
        },
        {
          title: "Gameplay - Need For Speedsters Car Racing Game",
          image: {
            path: "/game-assets/game-images/car-racing-game-online.jpg",
            alt: "Free Car Racing Game Online",
            title: "Free Car Racing Game Online",
            caption: "Free Car Racing Game Online",
          },
        },
        {
          description:
            "Let's take a closer look at the gameplay and exciting features offered by Need for Speedsters car racing game.",
          items: [
            {
              title: "Game Start",
              description:
                'When you open the game, you\'ll see the main menu. Tap "Play" to start the game!',
            },
            {
              title: "Choose Your Car",
              description:
                "From the store, pick your favorite car from a variety of powerful options. Each car is unique, so choose wisely!",
            },
            {
              title: "Different Tracks",
              description:
                "Different tracks are available that you want to race on. There are many exciting options to try out.",
            },
            {
              title: "Stay ahead",
              description:
                "Press the accelerator button and make sure to speed ahead of your opponents.",
            },
            {
              title: "Dodge Obstacles",
              description:
                "Be careful of obstacles and when taking sharp turns. Steer your car skillfully to avoid crashes.",
            },
            {
              title: "Collect money and nitrogen boost",
              description:
                "Try to collect the money and power-ups placed on the road. This increases your earnings and unlocks more powerful cars and upgrades.",
            },
            {
              title: "Finish Line",
              description:
                "Race towards the finish line and try to be the first to cross it. The excitement builds as you get closer to winning!",
            },
          ],
        },
        {
          title: "How to Play & Rules - Online Car Racing for PC and Mobile",
          description:
            "Learn how to play the online car racing game on both PC and mobile platforms with the following instructions:",
        },
        {
          subTitle: "How to Play",
          items: [
            {
              title: "Desktop",
              subItems: [
                'For steering, use the "A" and "D" keys or the left ⬅️ and right ➡️ arrow keys to steer your car left or right.',
                'Use the "S" Key or the down arrow ⬇️ key to back your car.',
              ],
            },
            {
              title: "Mobile",
              subItems: [
                "To control your car's direction, simply move the onscreen controller left or right.",
                "For braking or reversing, use the onscreen controller to apply brakes and slow down your car.",
              ],
            },
          ],
        },
        {
          subTitle: "Rules",
          items: [
            "Maintain your speed and performance by avoiding any collisions with obstacles.",
            "Overtake opponents skillfully and drive faster while navigating through traffic and turns.",
            "Ensure no collisions with other cars or objects to prevent damage and loss of speed.",
            "Remember, nitrous can only be used for a limited time, so use it wisely.",
            "Race towards the finish line to successfully complete the race and earn rewards based on your position.",
            "Utilize the money collected during races to upgrade your car and enhance its performance.",
          ],
        },
        {
          title: "Tips and Tricks - Free Car Racing Game",
          description:
            "Let's discuss some valuable tips and tricks to excel in the free car racing game:",
        },
        {
          subTitle: "Tips",
          items: [
            "To drive smoothly, maintain a steady hand on the controls to avoid skidding and maintain better control of your car.",
            "Study your opponents' driving patterns and choose the right moments to overtake them safely.",
            "Use brakes wisely before sharp turns to avoid crashing and maintain a good racing line.",
            "Time your boosts carefully, preferably when exiting corners to maximize speed.",
            "Stick to the racing line to maintain speed and reduce distance.",
          ],
        },
        {
          subTitle: "Tricks",
          items: [
            "When the car race begins, accelerate as soon as the countdown ends to get an early speed advantage.",
            "Use the racing line effectively to take the shortest and fastest path through corners, maximizing your speed and reducing lap times.",
            "Learn to anticipate and avoid collisions with other cars, walls, or obstacles by staying aware of your surroundings and reacting quickly.",
            "Master-controlled drifts around corners by tapping the brakes and steering simultaneously for smoother turns.",
            "Use nitro boosts for overtaking opponents or closing in on the finish line.",
            "Block opponents' overtaking attempts by positioning your car strategically on the track.",
            "Upgrade your car performance by investing in new car to gain a competitive edge.",
          ],
        },
      ],
      faq: [
        {
          question: "What is Need for Speedsters car racing game?",
          answer:
            "Need for Speedsters is an exciting racing game where you drive cars in races to win and have fun.",
        },
        {
          question: "What platforms is the game available on?",
          answer: "You can play the game on computers PC, Android, and iOS.",
        },
        {
          question:
            "What are the key features and gameplay mechanics of Need for Speedsters racing game?",
          answer:
            "The car racing game has fast races, different cars and tracks, and a special boost for extra speed.",
        },
        {
          question: "Can you customize and upgrade your cars in the game?",
          answer:
            "Yes, you can change how your cars look and make them faster by upgrading them.",
        },
        {
          question:
            "Are there different game modes available, like single-player, multiplayer, or online racing?",
          answer:
            "The game is mostly single-player, where you race against computer opponents.",
        },
        {
          question:
            "Is there a storyline or career mode in the game, and what are the objectives?",
          answer:
            "The game focuses on racing fun, so there's no story or career mode. Your goal is to win races and have a great time!",
        },
        {
          question:
            "How do I control my car in Need for Speedsters racing game?",
          answer:
            "You can control your car by using the arrow keys on your keyboard or by using the on screen controller on mobile. Use the arrow keys to accelerate, brake, and to steer.",
        },
        {
          question: "Is Need for Speedsters suitable for all ages?",
          answer:
            "Yes, the game is designed for players of all ages who enjoy the thrill of car racing.",
        },
        {
          question: "What is the nitro boost and how do I use it?",
          answer:
            "Nitro boost gives your car a temporary speed boost. You can use it by collecting it on the road during a race.",
        },
      ],
      systemRequirements: [
        {
          description:
            "Need for Speedsters is a thrilling car racing game available on various platforms. Here are the basic system requirements to enjoy the game:",
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 4.4 or higher",
            "iOS 8 or higher",
          ],
        },
        {
          description:
            "Remember, these are the minimum requirements, and the game might work on devices that meet or surpass these specifications. Prepare to immerse yourself in the excitement of Need for Speedsters, racing on your preferred device!",
        },
      ],
    },
  },
  manga_quiz: {
    details: {
      title: " Manga Quiz - Play Anime Quiz Game Online for Free",
      gameData: [
        {
          description: [
            "Do you love anime? Are you a fan of Japanese manga? If so, then you'll love the Manga Quiz game. It's a fun and exciting way to test your knowledge of anime and manga.",
            "The game is designed to be challenging but not too difficult. It's perfect for people who want to learn more about their favorite anime and manga series.",
            "The game features a variety of questions about popular anime and manga series. You'll be asked to identify characters, locations, and other details from these series. The questions are designed to be challenging but not too difficult. It's perfect for people who want to learn more about their favorite anime and manga series.",
          ],
        },
      ],
      systemRequirements: [
        {
          description:
            "Manga Quiz is a fun and exciting game that can be played on a variety of devices. To enjoy the game, make sure your device meets the following system requirements:",
          items: [
            "Windows 7 (64-bit) or higher",
            "Android 5.0 or higher",
            "iOS 10.0 or higher",
          ],
        },
        {
          description:
            "By ensuring that your device meets these system requirements, you can fully immerse yourself in the world of Manga Quiz and enjoy a smooth and exciting gaming experience.",
        },
      ],
    },
  },
};
